import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
export type Maybe<T> = T | null | undefined
export type InputMaybe<T> = T | null | undefined
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K]
}
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>
}
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>
}
const defaultOptions = {} as const
export const namedOperations = {
  Query: {
    Market_GetCurrentUser: 'Market_GetCurrentUser',
    Market_GetVendorIDFromSlugOrID: 'Market_GetVendorIDFromSlugOrID',
    Market_GetCartsInfoForCheckoutButton:
      'Market_GetCartsInfoForCheckoutButton',
    Market_GetCarts: 'Market_GetCarts',
    Market_GetOrderGuide: 'Market_GetOrderGuide',
    Market_GetVendorProductOrderHistory: 'Market_GetVendorProductOrderHistory',
    Market_GetActivePromotions: 'Market_GetActivePromotions',
    Market_GetAllVendors: 'Market_GetAllVendors',
    Market_GetVendorDetailsBySlugOrID: 'Market_GetVendorDetailsBySlugOrID',
    Market_GetVendorProducts: 'Market_GetVendorProducts',
    Market_GetActivePromotionsForVendor: 'Market_GetActivePromotionsForVendor',
  },
  Mutation: {
    Market_UpdateVendorCart: 'Market_UpdateVendorCart',
    Market_UpdateCartQuantity: 'Market_UpdateCartQuantity',
    Market_ClearVendorCart: 'Market_ClearVendorCart',
    Market_PlaceOrder: 'Market_PlaceOrder',
    Market_AddProductsToUserOrderGuide: 'Market_AddProductsToUserOrderGuide',
    Market_RemoveProductsFromOrderGuide: 'Market_RemoveProductsFromOrderGuide',
    Market_UpdateBuyerProfile: 'Market_UpdateBuyerProfile',
  },
  Fragment: {
    Market_VendorProductFields: 'Market_VendorProductFields',
    Market_VendorProductWithActiveDealFields:
      'Market_VendorProductWithActiveDealFields',
    Market_PromotionFields: 'Market_PromotionFields',
    Market_VendorFields: 'Market_VendorFields',
  },
}
export type MarketVendorProductFieldsFragment = {
  __typename?: 'VendorProduct'
  caseSize?: number | null | undefined
  id: string
  inventory?: number | null | undefined
  itemCode?: string | null | undefined
  notes?: string | null | undefined
  status: VendorProductStatus
  wholesalePricing: {
    __typename?: 'PricingInfo'
    casePrice?: number | null | undefined
    unitPrice?: number | null | undefined
  }
  product: {
    __typename?: 'Product'
    brandName?: string | null | undefined
    category?: string | null | undefined
    description?: string | null | undefined
    id: string
    imgURL?: string | null | undefined
    unitVolume?: string | null | undefined
    unitUPC?: string | null | undefined
  }
  vendor?:
    | {
        __typename?: 'Vendor'
        disableOutOfStockPurchases: boolean
        disableDiscontinuedPurchases: boolean
        id: string
        name?: string | null | undefined
        isInventoryEnabled: boolean
      }
    | null
    | undefined
}

export type MarketVendorProductWithActiveDealFieldsFragment = {
  __typename?: 'VendorProduct'
  caseSize?: number | null | undefined
  id: string
  inventory?: number | null | undefined
  itemCode?: string | null | undefined
  notes?: string | null | undefined
  status: VendorProductStatus
  activeDeal?:
    | {
        __typename?: 'BuyXGetYFreeDeal'
        freeCount: number
        threshold: number
        unitOfMeasure: UnitOfMeasure
        displayName: string
        id: string
        type: DealType
      }
    | {
        __typename?: 'FixedDeal'
        dealValue: number
        unitOfMeasure: UnitOfMeasure
        displayName: string
        id: string
        type: DealType
      }
    | {
        __typename?: 'PercentageDeal'
        basisPoints: number
        displayName: string
        id: string
        type: DealType
      }
    | null
    | undefined
  wholesalePricing: {
    __typename?: 'PricingInfo'
    casePrice?: number | null | undefined
    unitPrice?: number | null | undefined
  }
  product: {
    __typename?: 'Product'
    brandName?: string | null | undefined
    category?: string | null | undefined
    description?: string | null | undefined
    id: string
    imgURL?: string | null | undefined
    unitVolume?: string | null | undefined
    unitUPC?: string | null | undefined
  }
  vendor?:
    | {
        __typename?: 'Vendor'
        disableOutOfStockPurchases: boolean
        disableDiscontinuedPurchases: boolean
        id: string
        name?: string | null | undefined
        isInventoryEnabled: boolean
      }
    | null
    | undefined
}

export type MarketPromotionFieldsFragment = {
  __typename?: 'Promotion'
  id: string
  name?: string | null | undefined
  deals: {
    __typename?: 'DealsResults'
    nodes: Array<
      | {
          __typename?: 'BuyXGetYFreeDeal'
          freeCount: number
          threshold: number
          unitOfMeasure: UnitOfMeasure
          displayName: string
          id: string
          type: DealType
          vendorProducts: {
            __typename?: 'DealVendorProductsResult'
            nodes: Array<{
              __typename?: 'VendorProduct'
              caseSize?: number | null | undefined
              id: string
              inventory?: number | null | undefined
              itemCode?: string | null | undefined
              notes?: string | null | undefined
              status: VendorProductStatus
              wholesalePricing: {
                __typename?: 'PricingInfo'
                casePrice?: number | null | undefined
                unitPrice?: number | null | undefined
              }
              product: {
                __typename?: 'Product'
                brandName?: string | null | undefined
                category?: string | null | undefined
                description?: string | null | undefined
                id: string
                imgURL?: string | null | undefined
                unitVolume?: string | null | undefined
                unitUPC?: string | null | undefined
              }
              vendor?:
                | {
                    __typename?: 'Vendor'
                    disableOutOfStockPurchases: boolean
                    disableDiscontinuedPurchases: boolean
                    id: string
                    name?: string | null | undefined
                    isInventoryEnabled: boolean
                  }
                | null
                | undefined
            }>
          }
        }
      | {
          __typename?: 'FixedDeal'
          dealValue: number
          unitOfMeasure: UnitOfMeasure
          displayName: string
          id: string
          type: DealType
          vendorProducts: {
            __typename?: 'DealVendorProductsResult'
            nodes: Array<{
              __typename?: 'VendorProduct'
              caseSize?: number | null | undefined
              id: string
              inventory?: number | null | undefined
              itemCode?: string | null | undefined
              notes?: string | null | undefined
              status: VendorProductStatus
              wholesalePricing: {
                __typename?: 'PricingInfo'
                casePrice?: number | null | undefined
                unitPrice?: number | null | undefined
              }
              product: {
                __typename?: 'Product'
                brandName?: string | null | undefined
                category?: string | null | undefined
                description?: string | null | undefined
                id: string
                imgURL?: string | null | undefined
                unitVolume?: string | null | undefined
                unitUPC?: string | null | undefined
              }
              vendor?:
                | {
                    __typename?: 'Vendor'
                    disableOutOfStockPurchases: boolean
                    disableDiscontinuedPurchases: boolean
                    id: string
                    name?: string | null | undefined
                    isInventoryEnabled: boolean
                  }
                | null
                | undefined
            }>
          }
        }
      | {
          __typename?: 'PercentageDeal'
          basisPoints: number
          displayName: string
          id: string
          type: DealType
          vendorProducts: {
            __typename?: 'DealVendorProductsResult'
            nodes: Array<{
              __typename?: 'VendorProduct'
              caseSize?: number | null | undefined
              id: string
              inventory?: number | null | undefined
              itemCode?: string | null | undefined
              notes?: string | null | undefined
              status: VendorProductStatus
              wholesalePricing: {
                __typename?: 'PricingInfo'
                casePrice?: number | null | undefined
                unitPrice?: number | null | undefined
              }
              product: {
                __typename?: 'Product'
                brandName?: string | null | undefined
                category?: string | null | undefined
                description?: string | null | undefined
                id: string
                imgURL?: string | null | undefined
                unitVolume?: string | null | undefined
                unitUPC?: string | null | undefined
              }
              vendor?:
                | {
                    __typename?: 'Vendor'
                    disableOutOfStockPurchases: boolean
                    disableDiscontinuedPurchases: boolean
                    id: string
                    name?: string | null | undefined
                    isInventoryEnabled: boolean
                  }
                | null
                | undefined
            }>
          }
        }
    >
  }
}

export type MarketVendorFieldsFragment = {
  __typename?: 'Vendor'
  disableDiscontinuedPurchases: boolean
  disableOutOfStockPurchases: boolean
  headerImageURL?: string | null | undefined
  id: string
  imgURL?: string | null | undefined
  isInventoryEnabled: boolean
  name?: string | null | undefined
  slug?: string | null | undefined
}

export type MarketUpdateVendorCartMutationVariables = Exact<{
  lineItems: Array<CartLineItemInput> | CartLineItemInput
  storeID?: InputMaybe<Scalars['ID']>
  vendorID: Scalars['ID']
}>

export type MarketUpdateVendorCartMutation = {
  __typename?: 'Mutation'
  updateVendorCartV2: {
    __typename?: 'UpdateVendorCartResult'
    cart: {
      __typename?: 'VendorCart'
      id: string
      lineItemCount: number
      productCount: number
      subTotal: number
      lineItems: {
        __typename?: 'CartLineItems'
        nodes: Array<{
          __typename?: 'CartLineItem'
          id: string
          quantity: number
          price: number
          vendorProduct: {
            __typename?: 'VendorProduct'
            caseSize?: number | null | undefined
            id: string
            inventory?: number | null | undefined
            itemCode?: string | null | undefined
            notes?: string | null | undefined
            status: VendorProductStatus
            activeDeal?:
              | {
                  __typename?: 'BuyXGetYFreeDeal'
                  freeCount: number
                  threshold: number
                  unitOfMeasure: UnitOfMeasure
                  displayName: string
                  id: string
                  type: DealType
                }
              | {
                  __typename?: 'FixedDeal'
                  dealValue: number
                  unitOfMeasure: UnitOfMeasure
                  displayName: string
                  id: string
                  type: DealType
                }
              | {
                  __typename?: 'PercentageDeal'
                  basisPoints: number
                  displayName: string
                  id: string
                  type: DealType
                }
              | null
              | undefined
            wholesalePricing: {
              __typename?: 'PricingInfo'
              casePrice?: number | null | undefined
              unitPrice?: number | null | undefined
            }
            product: {
              __typename?: 'Product'
              brandName?: string | null | undefined
              category?: string | null | undefined
              description?: string | null | undefined
              id: string
              imgURL?: string | null | undefined
              unitVolume?: string | null | undefined
              unitUPC?: string | null | undefined
            }
            vendor?:
              | {
                  __typename?: 'Vendor'
                  disableOutOfStockPurchases: boolean
                  disableDiscontinuedPurchases: boolean
                  id: string
                  name?: string | null | undefined
                  isInventoryEnabled: boolean
                }
              | null
              | undefined
          }
        }>
      }
    }
  }
}

export type MarketUpdateCartQuantityMutationVariables = Exact<{
  quantity: Scalars['Int']
  unitOfMeasure: UnitOfMeasure
  vendorProductID: Scalars['ID']
}>

export type MarketUpdateCartQuantityMutation = {
  __typename?: 'Mutation'
  updateCartProductQuantity: {
    __typename?: 'updateCartProductQuantityResult'
    updatedVendorCart?:
      | {
          __typename?: 'VendorCart'
          id: string
          lineItemCount: number
          productCount: number
          subTotal: number
          totalDiscount: number
          lineItems: {
            __typename?: 'CartLineItems'
            nodes: Array<{
              __typename?: 'CartLineItem'
              id: string
              quantity: number
              price: number
              vendorProduct: {
                __typename?: 'VendorProduct'
                caseSize?: number | null | undefined
                id: string
                inventory?: number | null | undefined
                itemCode?: string | null | undefined
                notes?: string | null | undefined
                status: VendorProductStatus
                activeDeal?:
                  | {
                      __typename?: 'BuyXGetYFreeDeal'
                      freeCount: number
                      threshold: number
                      unitOfMeasure: UnitOfMeasure
                      displayName: string
                      id: string
                      type: DealType
                    }
                  | {
                      __typename?: 'FixedDeal'
                      dealValue: number
                      unitOfMeasure: UnitOfMeasure
                      displayName: string
                      id: string
                      type: DealType
                    }
                  | {
                      __typename?: 'PercentageDeal'
                      basisPoints: number
                      displayName: string
                      id: string
                      type: DealType
                    }
                  | null
                  | undefined
                wholesalePricing: {
                  __typename?: 'PricingInfo'
                  casePrice?: number | null | undefined
                  unitPrice?: number | null | undefined
                }
                product: {
                  __typename?: 'Product'
                  brandName?: string | null | undefined
                  category?: string | null | undefined
                  description?: string | null | undefined
                  id: string
                  imgURL?: string | null | undefined
                  unitVolume?: string | null | undefined
                  unitUPC?: string | null | undefined
                }
                vendor?:
                  | {
                      __typename?: 'Vendor'
                      disableOutOfStockPurchases: boolean
                      disableDiscontinuedPurchases: boolean
                      id: string
                      name?: string | null | undefined
                      isInventoryEnabled: boolean
                    }
                  | null
                  | undefined
              }
            }>
          }
        }
      | null
      | undefined
  }
}

export type MarketClearVendorCartMutationVariables = Exact<{
  storeID?: InputMaybe<Scalars['ID']>
  vendorID: Scalars['ID']
}>

export type MarketClearVendorCartMutation = {
  __typename?: 'Mutation'
  updateVendorCartV2: {
    __typename?: 'UpdateVendorCartResult'
    cart: {
      __typename?: 'VendorCart'
      id: string
      lineItemCount: number
      productCount: number
      subTotal: number
      lineItems: {
        __typename?: 'CartLineItems'
        nodes: Array<{
          __typename?: 'CartLineItem'
          id: string
          quantity: number
          price: number
          vendorProduct: {
            __typename?: 'VendorProduct'
            caseSize?: number | null | undefined
            id: string
            inventory?: number | null | undefined
            itemCode?: string | null | undefined
            notes?: string | null | undefined
            status: VendorProductStatus
            activeDeal?:
              | {
                  __typename?: 'BuyXGetYFreeDeal'
                  freeCount: number
                  threshold: number
                  unitOfMeasure: UnitOfMeasure
                  displayName: string
                  id: string
                  type: DealType
                }
              | {
                  __typename?: 'FixedDeal'
                  dealValue: number
                  unitOfMeasure: UnitOfMeasure
                  displayName: string
                  id: string
                  type: DealType
                }
              | {
                  __typename?: 'PercentageDeal'
                  basisPoints: number
                  displayName: string
                  id: string
                  type: DealType
                }
              | null
              | undefined
            wholesalePricing: {
              __typename?: 'PricingInfo'
              casePrice?: number | null | undefined
              unitPrice?: number | null | undefined
            }
            product: {
              __typename?: 'Product'
              brandName?: string | null | undefined
              category?: string | null | undefined
              description?: string | null | undefined
              id: string
              imgURL?: string | null | undefined
              unitVolume?: string | null | undefined
              unitUPC?: string | null | undefined
            }
            vendor?:
              | {
                  __typename?: 'Vendor'
                  disableOutOfStockPurchases: boolean
                  disableDiscontinuedPurchases: boolean
                  id: string
                  name?: string | null | undefined
                  isInventoryEnabled: boolean
                }
              | null
              | undefined
          }
        }>
      }
    }
  }
}

export type MarketPlaceOrderMutationVariables = Exact<{
  deliveryDate?: InputMaybe<Scalars['Timestamp']>
  idempotencyKey: Scalars['String']
  noteToVendor?: InputMaybe<Scalars['String']>
  storeID: Scalars['String']
  vendorID: Scalars['String']
}>

export type MarketPlaceOrderMutation = {
  __typename?: 'Mutation'
  createAndSubmitOrderFromCart: {
    __typename?: 'CartOrderResult'
    cart: {
      __typename?: 'VendorCart'
      id: string
      lineItemCount: number
      productCount: number
      subTotal: number
      totalDiscount: number
      lineItems: {
        __typename?: 'CartLineItems'
        nodes: Array<{
          __typename?: 'CartLineItem'
          id: string
          quantity: number
        }>
      }
    }
  }
}

export type MarketAddProductsToUserOrderGuideMutationVariables = Exact<{
  input: AddProductsToV2OrderGuideInput
}>

export type MarketAddProductsToUserOrderGuideMutation = {
  __typename?: 'Mutation'
  addProductsToV2OrderGuide: {
    __typename?: 'AddProductsToV2OrderGuideResult'
    orderGuide: {
      __typename?: 'V2OrderGuide'
      id: string
      vendorProducts?:
        | {
            __typename?: 'OrderGuideProductsResult'
            totalCount: number
            nodes: Array<{
              __typename?: 'VendorProduct'
              product: { __typename?: 'Product'; id: string }
            }>
          }
        | null
        | undefined
    }
  }
}

export type MarketRemoveProductsFromOrderGuideMutationVariables = Exact<{
  input: RemoveProductsFromV2OrderGuideInput
}>

export type MarketRemoveProductsFromOrderGuideMutation = {
  __typename?: 'Mutation'
  removeProductsFromV2OrderGuide: {
    __typename?: 'RemoveProductsFromV2OrderGuideResult'
    orderGuide: {
      __typename?: 'V2OrderGuide'
      id: string
      vendorProducts?:
        | { __typename?: 'OrderGuideProductsResult'; totalCount: number }
        | null
        | undefined
    }
  }
}

export type MarketUpdateBuyerProfileMutationVariables = Exact<{
  displayName?: InputMaybe<Scalars['String']>
  email?: InputMaybe<Scalars['String']>
  phoneNumber?: InputMaybe<Scalars['String']>
}>

export type MarketUpdateBuyerProfileMutation = {
  __typename?: 'Mutation'
  updateProfile: {
    __typename?: 'User'
    displayName?: string | null | undefined
    email?: string | null | undefined
    id: string
    phoneNumber?: string | null | undefined
  }
}

export type MarketGetCurrentUserQueryVariables = Exact<{
  featureIDs?: InputMaybe<Array<Scalars['String']> | Scalars['String']>
}>

export type MarketGetCurrentUserQuery = {
  __typename?: 'Query'
  me?:
    | {
        __typename?: 'Viewer'
        user: {
          __typename?: 'User'
          id: string
          email?: string | null | undefined
          phoneNumber?: string | null | undefined
          defaultDepartmentName?: string | null | undefined
          displayName?: string | null | undefined
          userType?: UserType | null | undefined
          storeDepartments: {
            __typename?: 'StoreDepartmentsResult'
            nodes: Array<{
              __typename?: 'StoreDepartment'
              id: string
              name: string
            }>
          }
          canSeeFeatures: {
            __typename?: 'UserCanSeeFeaturesResult'
            enabledFeatures: Array<string>
          }
          vendorUser?:
            | {
                __typename?: 'VendorUser'
                vendor: {
                  __typename?: 'Vendor'
                  name?: string | null | undefined
                  id: string
                }
              }
            | null
            | undefined
          retailUser?:
            | {
                __typename?: 'RetailUser'
                user: { __typename?: 'User'; id: string }
                retailCompany: {
                  __typename?: 'RetailCompany'
                  id: string
                  name?: string | null | undefined
                  store?:
                    | {
                        __typename?: 'Store'
                        address?: string | null | undefined
                        id: string
                        name?: string | null | undefined
                      }
                    | null
                    | undefined
                }
              }
            | null
            | undefined
        }
      }
    | null
    | undefined
}

export type MarketGetVendorIdFromSlugOrIdQueryVariables = Exact<{
  slugOrID: Scalars['String']
}>

export type MarketGetVendorIdFromSlugOrIdQuery = {
  __typename?: 'Query'
  vendorBySlug?: { __typename?: 'Vendor'; id: string } | null | undefined
}

export type MarketGetCartsInfoForCheckoutButtonQueryVariables = Exact<{
  [key: string]: never
}>

export type MarketGetCartsInfoForCheckoutButtonQuery = {
  __typename?: 'Query'
  me?:
    | {
        __typename?: 'Viewer'
        user: {
          __typename?: 'User'
          id: string
          carts: Array<{
            __typename?: 'VendorCart'
            id: string
            subTotal: number
            lineItemCount: number
            vendor: {
              __typename?: 'Vendor'
              id: string
              slug?: string | null | undefined
              isMarketEnabled: boolean
            }
          }>
        }
      }
    | null
    | undefined
}

export type MarketGetCartsQueryVariables = Exact<{ [key: string]: never }>

export type MarketGetCartsQuery = {
  __typename?: 'Query'
  me?:
    | {
        __typename?: 'Viewer'
        user: {
          __typename?: 'User'
          id: string
          carts: Array<{
            __typename?: 'VendorCart'
            id: string
            lineItemCount: number
            productCount: number
            subTotal: number
            totalDiscount: number
            store: { __typename?: 'Store'; id: string }
            vendor: {
              __typename?: 'Vendor'
              email?: string | null | undefined
              id: string
              imgURL?: string | null | undefined
              isMarketEnabled: boolean
              name?: string | null | undefined
              orderMin?: number | null | undefined
              slug?: string | null | undefined
              disableOutOfStockPurchases: boolean
              orderMinimums?:
                | Array<{
                    __typename?: 'VendorOrderMinimum'
                    orderMin: number
                    storeID: string
                  }>
                | null
                | undefined
            }
            outOfStockProducts: {
              __typename?: 'CartOutOfStockProductsResult'
              nodes: Array<{ __typename?: 'VendorProduct'; id: string }>
            }
            lineItems: {
              __typename?: 'CartLineItems'
              nodes: Array<{
                __typename?: 'CartLineItem'
                id: string
                price: number
                quantity: number
                vendorProduct: {
                  __typename?: 'VendorProduct'
                  caseSize?: number | null | undefined
                  id: string
                  inventory?: number | null | undefined
                  itemCode?: string | null | undefined
                  notes?: string | null | undefined
                  status: VendorProductStatus
                  activeDeal?:
                    | {
                        __typename?: 'BuyXGetYFreeDeal'
                        freeCount: number
                        threshold: number
                        unitOfMeasure: UnitOfMeasure
                        displayName: string
                        id: string
                        type: DealType
                      }
                    | {
                        __typename?: 'FixedDeal'
                        dealValue: number
                        unitOfMeasure: UnitOfMeasure
                        displayName: string
                        id: string
                        type: DealType
                      }
                    | {
                        __typename?: 'PercentageDeal'
                        basisPoints: number
                        displayName: string
                        id: string
                        type: DealType
                      }
                    | null
                    | undefined
                  wholesalePricing: {
                    __typename?: 'PricingInfo'
                    casePrice?: number | null | undefined
                    unitPrice?: number | null | undefined
                  }
                  product: {
                    __typename?: 'Product'
                    brandName?: string | null | undefined
                    category?: string | null | undefined
                    description?: string | null | undefined
                    id: string
                    imgURL?: string | null | undefined
                    unitVolume?: string | null | undefined
                    unitUPC?: string | null | undefined
                  }
                  vendor?:
                    | {
                        __typename?: 'Vendor'
                        disableOutOfStockPurchases: boolean
                        disableDiscontinuedPurchases: boolean
                        id: string
                        name?: string | null | undefined
                        isInventoryEnabled: boolean
                      }
                    | null
                    | undefined
                }
              }>
            }
          }>
        }
      }
    | null
    | undefined
}

export type MarketGetOrderGuideQueryVariables = Exact<{
  storeDepartmentID: Scalars['ID']
  vendorID: Scalars['ID']
}>

export type MarketGetOrderGuideQuery = {
  __typename?: 'Query'
  getVendorStoreDepartmentAccountForVendor?:
    | {
        __typename?: 'VendorStoreDepartmentAccount'
        id: string
        orderGuide?:
          | {
              __typename?: 'V2OrderGuide'
              id: string
              vendorProductIDs: Array<string>
              vendorProducts?:
                | {
                    __typename?: 'OrderGuideProductsResult'
                    nodes: Array<{
                      __typename?: 'VendorProduct'
                      caseSize?: number | null | undefined
                      id: string
                      inventory?: number | null | undefined
                      itemCode?: string | null | undefined
                      notes?: string | null | undefined
                      status: VendorProductStatus
                      activeDeal?:
                        | {
                            __typename?: 'BuyXGetYFreeDeal'
                            freeCount: number
                            threshold: number
                            unitOfMeasure: UnitOfMeasure
                            displayName: string
                            id: string
                            type: DealType
                          }
                        | {
                            __typename?: 'FixedDeal'
                            dealValue: number
                            unitOfMeasure: UnitOfMeasure
                            displayName: string
                            id: string
                            type: DealType
                          }
                        | {
                            __typename?: 'PercentageDeal'
                            basisPoints: number
                            displayName: string
                            id: string
                            type: DealType
                          }
                        | null
                        | undefined
                      wholesalePricing: {
                        __typename?: 'PricingInfo'
                        casePrice?: number | null | undefined
                        unitPrice?: number | null | undefined
                      }
                      product: {
                        __typename?: 'Product'
                        brandName?: string | null | undefined
                        category?: string | null | undefined
                        description?: string | null | undefined
                        id: string
                        imgURL?: string | null | undefined
                        unitVolume?: string | null | undefined
                        unitUPC?: string | null | undefined
                      }
                      vendor?:
                        | {
                            __typename?: 'Vendor'
                            disableOutOfStockPurchases: boolean
                            disableDiscontinuedPurchases: boolean
                            id: string
                            name?: string | null | undefined
                            isInventoryEnabled: boolean
                          }
                        | null
                        | undefined
                    }>
                  }
                | null
                | undefined
            }
          | null
          | undefined
      }
    | null
    | undefined
}

export type MarketGetVendorProductOrderHistoryQueryVariables = Exact<{
  productID: Scalars['ID']
  limit?: InputMaybe<Scalars['Int']>
}>

export type MarketGetVendorProductOrderHistoryQuery = {
  __typename?: 'Query'
  me?:
    | {
        __typename?: 'Viewer'
        user: {
          __typename?: 'User'
          id: string
          retailUser?:
            | {
                __typename?: 'RetailUser'
                user: { __typename?: 'User'; id: string }
                retailCompany: {
                  __typename?: 'RetailCompany'
                  id: string
                  store?:
                    | {
                        __typename?: 'Store'
                        id: string
                        productOrderHistory: {
                          __typename?: 'ProductOrderHistoryResult'
                          nodes: Array<{
                            __typename?: 'ProductOrderHistory'
                            orderID: string
                            orderDateTime: Date | string
                            price: number
                            quantity: number
                            unitOfMeasure: UnitOfMeasure
                            vendorProduct?:
                              | {
                                  __typename?: 'VendorProduct'
                                  caseSize?: number | null | undefined
                                  id: string
                                  inventory?: number | null | undefined
                                  itemCode?: string | null | undefined
                                  notes?: string | null | undefined
                                  status: VendorProductStatus
                                  activeDeal?:
                                    | {
                                        __typename?: 'BuyXGetYFreeDeal'
                                        freeCount: number
                                        threshold: number
                                        unitOfMeasure: UnitOfMeasure
                                        displayName: string
                                        id: string
                                        type: DealType
                                      }
                                    | {
                                        __typename?: 'FixedDeal'
                                        dealValue: number
                                        unitOfMeasure: UnitOfMeasure
                                        displayName: string
                                        id: string
                                        type: DealType
                                      }
                                    | {
                                        __typename?: 'PercentageDeal'
                                        basisPoints: number
                                        displayName: string
                                        id: string
                                        type: DealType
                                      }
                                    | null
                                    | undefined
                                  wholesalePricing: {
                                    __typename?: 'PricingInfo'
                                    casePrice?: number | null | undefined
                                    unitPrice?: number | null | undefined
                                  }
                                  product: {
                                    __typename?: 'Product'
                                    brandName?: string | null | undefined
                                    category?: string | null | undefined
                                    description?: string | null | undefined
                                    id: string
                                    imgURL?: string | null | undefined
                                    unitVolume?: string | null | undefined
                                    unitUPC?: string | null | undefined
                                  }
                                  vendor?:
                                    | {
                                        __typename?: 'Vendor'
                                        disableOutOfStockPurchases: boolean
                                        disableDiscontinuedPurchases: boolean
                                        id: string
                                        name?: string | null | undefined
                                        isInventoryEnabled: boolean
                                      }
                                    | null
                                    | undefined
                                }
                              | null
                              | undefined
                          }>
                        }
                      }
                    | null
                    | undefined
                }
              }
            | null
            | undefined
        }
      }
    | null
    | undefined
}

export type MarketGetActivePromotionsQueryVariables = Exact<{
  [key: string]: never
}>

export type MarketGetActivePromotionsQuery = {
  __typename?: 'Query'
  me?:
    | {
        __typename?: 'Viewer'
        user: {
          __typename?: 'User'
          id: string
          retailUser?:
            | {
                __typename?: 'RetailUser'
                user: { __typename?: 'User'; id: string }
                vendorStoreDepartmentAccounts: {
                  __typename?: 'VendorStoreDepartmentAccountsResult'
                  nodes: Array<{
                    __typename?: 'VendorStoreDepartmentAccount'
                    accountNumber?: string | null | undefined
                    id: string
                    activePromotions?:
                      | {
                          __typename?: 'PromotionsResults'
                          nodes: Array<{
                            __typename?: 'Promotion'
                            id: string
                            name?: string | null | undefined
                            deals: {
                              __typename?: 'DealsResults'
                              nodes: Array<
                                | {
                                    __typename?: 'BuyXGetYFreeDeal'
                                    freeCount: number
                                    threshold: number
                                    unitOfMeasure: UnitOfMeasure
                                    displayName: string
                                    id: string
                                    type: DealType
                                    vendorProducts: {
                                      __typename?: 'DealVendorProductsResult'
                                      nodes: Array<{
                                        __typename?: 'VendorProduct'
                                        caseSize?: number | null | undefined
                                        id: string
                                        inventory?: number | null | undefined
                                        itemCode?: string | null | undefined
                                        notes?: string | null | undefined
                                        status: VendorProductStatus
                                        wholesalePricing: {
                                          __typename?: 'PricingInfo'
                                          casePrice?: number | null | undefined
                                          unitPrice?: number | null | undefined
                                        }
                                        product: {
                                          __typename?: 'Product'
                                          brandName?: string | null | undefined
                                          category?: string | null | undefined
                                          description?:
                                            | string
                                            | null
                                            | undefined
                                          id: string
                                          imgURL?: string | null | undefined
                                          unitVolume?: string | null | undefined
                                          unitUPC?: string | null | undefined
                                        }
                                        vendor?:
                                          | {
                                              __typename?: 'Vendor'
                                              disableOutOfStockPurchases: boolean
                                              disableDiscontinuedPurchases: boolean
                                              id: string
                                              name?: string | null | undefined
                                              isInventoryEnabled: boolean
                                            }
                                          | null
                                          | undefined
                                      }>
                                    }
                                  }
                                | {
                                    __typename?: 'FixedDeal'
                                    dealValue: number
                                    unitOfMeasure: UnitOfMeasure
                                    displayName: string
                                    id: string
                                    type: DealType
                                    vendorProducts: {
                                      __typename?: 'DealVendorProductsResult'
                                      nodes: Array<{
                                        __typename?: 'VendorProduct'
                                        caseSize?: number | null | undefined
                                        id: string
                                        inventory?: number | null | undefined
                                        itemCode?: string | null | undefined
                                        notes?: string | null | undefined
                                        status: VendorProductStatus
                                        wholesalePricing: {
                                          __typename?: 'PricingInfo'
                                          casePrice?: number | null | undefined
                                          unitPrice?: number | null | undefined
                                        }
                                        product: {
                                          __typename?: 'Product'
                                          brandName?: string | null | undefined
                                          category?: string | null | undefined
                                          description?:
                                            | string
                                            | null
                                            | undefined
                                          id: string
                                          imgURL?: string | null | undefined
                                          unitVolume?: string | null | undefined
                                          unitUPC?: string | null | undefined
                                        }
                                        vendor?:
                                          | {
                                              __typename?: 'Vendor'
                                              disableOutOfStockPurchases: boolean
                                              disableDiscontinuedPurchases: boolean
                                              id: string
                                              name?: string | null | undefined
                                              isInventoryEnabled: boolean
                                            }
                                          | null
                                          | undefined
                                      }>
                                    }
                                  }
                                | {
                                    __typename?: 'PercentageDeal'
                                    basisPoints: number
                                    displayName: string
                                    id: string
                                    type: DealType
                                    vendorProducts: {
                                      __typename?: 'DealVendorProductsResult'
                                      nodes: Array<{
                                        __typename?: 'VendorProduct'
                                        caseSize?: number | null | undefined
                                        id: string
                                        inventory?: number | null | undefined
                                        itemCode?: string | null | undefined
                                        notes?: string | null | undefined
                                        status: VendorProductStatus
                                        wholesalePricing: {
                                          __typename?: 'PricingInfo'
                                          casePrice?: number | null | undefined
                                          unitPrice?: number | null | undefined
                                        }
                                        product: {
                                          __typename?: 'Product'
                                          brandName?: string | null | undefined
                                          category?: string | null | undefined
                                          description?:
                                            | string
                                            | null
                                            | undefined
                                          id: string
                                          imgURL?: string | null | undefined
                                          unitVolume?: string | null | undefined
                                          unitUPC?: string | null | undefined
                                        }
                                        vendor?:
                                          | {
                                              __typename?: 'Vendor'
                                              disableOutOfStockPurchases: boolean
                                              disableDiscontinuedPurchases: boolean
                                              id: string
                                              name?: string | null | undefined
                                              isInventoryEnabled: boolean
                                            }
                                          | null
                                          | undefined
                                      }>
                                    }
                                  }
                              >
                            }
                          }>
                        }
                      | null
                      | undefined
                    vendor: {
                      __typename?: 'Vendor'
                      id: string
                      name?: string | null | undefined
                      slug?: string | null | undefined
                    }
                  }>
                }
                retailCompany: {
                  __typename?: 'RetailCompany'
                  id: string
                  store?:
                    | { __typename?: 'Store'; id: string }
                    | null
                    | undefined
                }
              }
            | null
            | undefined
          vendorUser?:
            | {
                __typename?: 'VendorUser'
                vendor: {
                  __typename?: 'Vendor'
                  activePromotions?:
                    | {
                        __typename?: 'PromotionsResults'
                        nodes: Array<{
                          __typename?: 'Promotion'
                          id: string
                          name?: string | null | undefined
                          deals: {
                            __typename?: 'DealsResults'
                            nodes: Array<
                              | {
                                  __typename?: 'BuyXGetYFreeDeal'
                                  freeCount: number
                                  threshold: number
                                  unitOfMeasure: UnitOfMeasure
                                  displayName: string
                                  id: string
                                  type: DealType
                                  vendorProducts: {
                                    __typename?: 'DealVendorProductsResult'
                                    nodes: Array<{
                                      __typename?: 'VendorProduct'
                                      caseSize?: number | null | undefined
                                      id: string
                                      inventory?: number | null | undefined
                                      itemCode?: string | null | undefined
                                      notes?: string | null | undefined
                                      status: VendorProductStatus
                                      wholesalePricing: {
                                        __typename?: 'PricingInfo'
                                        casePrice?: number | null | undefined
                                        unitPrice?: number | null | undefined
                                      }
                                      product: {
                                        __typename?: 'Product'
                                        brandName?: string | null | undefined
                                        category?: string | null | undefined
                                        description?: string | null | undefined
                                        id: string
                                        imgURL?: string | null | undefined
                                        unitVolume?: string | null | undefined
                                        unitUPC?: string | null | undefined
                                      }
                                      vendor?:
                                        | {
                                            __typename?: 'Vendor'
                                            disableOutOfStockPurchases: boolean
                                            disableDiscontinuedPurchases: boolean
                                            id: string
                                            name?: string | null | undefined
                                            isInventoryEnabled: boolean
                                          }
                                        | null
                                        | undefined
                                    }>
                                  }
                                }
                              | {
                                  __typename?: 'FixedDeal'
                                  dealValue: number
                                  unitOfMeasure: UnitOfMeasure
                                  displayName: string
                                  id: string
                                  type: DealType
                                  vendorProducts: {
                                    __typename?: 'DealVendorProductsResult'
                                    nodes: Array<{
                                      __typename?: 'VendorProduct'
                                      caseSize?: number | null | undefined
                                      id: string
                                      inventory?: number | null | undefined
                                      itemCode?: string | null | undefined
                                      notes?: string | null | undefined
                                      status: VendorProductStatus
                                      wholesalePricing: {
                                        __typename?: 'PricingInfo'
                                        casePrice?: number | null | undefined
                                        unitPrice?: number | null | undefined
                                      }
                                      product: {
                                        __typename?: 'Product'
                                        brandName?: string | null | undefined
                                        category?: string | null | undefined
                                        description?: string | null | undefined
                                        id: string
                                        imgURL?: string | null | undefined
                                        unitVolume?: string | null | undefined
                                        unitUPC?: string | null | undefined
                                      }
                                      vendor?:
                                        | {
                                            __typename?: 'Vendor'
                                            disableOutOfStockPurchases: boolean
                                            disableDiscontinuedPurchases: boolean
                                            id: string
                                            name?: string | null | undefined
                                            isInventoryEnabled: boolean
                                          }
                                        | null
                                        | undefined
                                    }>
                                  }
                                }
                              | {
                                  __typename?: 'PercentageDeal'
                                  basisPoints: number
                                  displayName: string
                                  id: string
                                  type: DealType
                                  vendorProducts: {
                                    __typename?: 'DealVendorProductsResult'
                                    nodes: Array<{
                                      __typename?: 'VendorProduct'
                                      caseSize?: number | null | undefined
                                      id: string
                                      inventory?: number | null | undefined
                                      itemCode?: string | null | undefined
                                      notes?: string | null | undefined
                                      status: VendorProductStatus
                                      wholesalePricing: {
                                        __typename?: 'PricingInfo'
                                        casePrice?: number | null | undefined
                                        unitPrice?: number | null | undefined
                                      }
                                      product: {
                                        __typename?: 'Product'
                                        brandName?: string | null | undefined
                                        category?: string | null | undefined
                                        description?: string | null | undefined
                                        id: string
                                        imgURL?: string | null | undefined
                                        unitVolume?: string | null | undefined
                                        unitUPC?: string | null | undefined
                                      }
                                      vendor?:
                                        | {
                                            __typename?: 'Vendor'
                                            disableOutOfStockPurchases: boolean
                                            disableDiscontinuedPurchases: boolean
                                            id: string
                                            name?: string | null | undefined
                                            isInventoryEnabled: boolean
                                          }
                                        | null
                                        | undefined
                                    }>
                                  }
                                }
                            >
                          }
                        }>
                      }
                    | null
                    | undefined
                }
              }
            | null
            | undefined
        }
      }
    | null
    | undefined
}

export type MarketGetAllVendorsQueryVariables = Exact<{ [key: string]: never }>

export type MarketGetAllVendorsQuery = {
  __typename?: 'Query'
  me?:
    | {
        __typename?: 'Viewer'
        user: {
          __typename?: 'User'
          id: string
          userType?: UserType | null | undefined
          defaultDepartmentName?: string | null | undefined
          storeDepartments: {
            __typename?: 'StoreDepartmentsResult'
            nodes: Array<{
              __typename?: 'StoreDepartment'
              id: string
              name: string
              vendorStoreDepartmentAccounts: {
                __typename?: 'VendorStoreDepartmentAccountResult'
                nodes: Array<{
                  __typename?: 'VendorStoreDepartmentAccount'
                  id: string
                  vendor: {
                    __typename?: 'Vendor'
                    disableDiscontinuedPurchases: boolean
                    disableOutOfStockPurchases: boolean
                    headerImageURL?: string | null | undefined
                    id: string
                    imgURL?: string | null | undefined
                    isInventoryEnabled: boolean
                    name?: string | null | undefined
                    slug?: string | null | undefined
                  }
                }>
              }
            }>
          }
          vendorUser?:
            | {
                __typename?: 'VendorUser'
                vendor: {
                  __typename?: 'Vendor'
                  disableDiscontinuedPurchases: boolean
                  disableOutOfStockPurchases: boolean
                  headerImageURL?: string | null | undefined
                  id: string
                  imgURL?: string | null | undefined
                  isInventoryEnabled: boolean
                  name?: string | null | undefined
                  slug?: string | null | undefined
                }
              }
            | null
            | undefined
        }
      }
    | null
    | undefined
}

export type MarketGetVendorDetailsBySlugOrIdQueryVariables = Exact<{
  slugOrID: Scalars['String']
}>

export type MarketGetVendorDetailsBySlugOrIdQuery = {
  __typename?: 'Query'
  vendorBySlug?:
    | {
        __typename?: 'Vendor'
        headerImageURL?: string | null | undefined
        id: string
        imgURL?: string | null | undefined
        name?: string | null | undefined
        orderDeadline?: string | null | undefined
        orderMin?: number | null | undefined
        orderMinimums?:
          | Array<{
              __typename?: 'VendorOrderMinimum'
              storeID: string
              orderMin: number
            }>
          | null
          | undefined
      }
    | null
    | undefined
}

export type MarketGetVendorProductsQueryVariables = Exact<{
  vendorID: Scalars['ID']
  query?: InputMaybe<Scalars['String']>
  cursor?: InputMaybe<Scalars['ID']>
  limit?: InputMaybe<Scalars['Int']>
}>

export type MarketGetVendorProductsQuery = {
  __typename?: 'Query'
  vendorProducts: {
    __typename?: 'VendorProductsResult'
    cursor?: string | null | undefined
    hasMore?: boolean | null | undefined
    nodes: Array<{
      __typename?: 'VendorProduct'
      caseSize?: number | null | undefined
      id: string
      inventory?: number | null | undefined
      itemCode?: string | null | undefined
      notes?: string | null | undefined
      status: VendorProductStatus
      activeDeal?:
        | {
            __typename?: 'BuyXGetYFreeDeal'
            freeCount: number
            threshold: number
            unitOfMeasure: UnitOfMeasure
            displayName: string
            id: string
            type: DealType
          }
        | {
            __typename?: 'FixedDeal'
            dealValue: number
            unitOfMeasure: UnitOfMeasure
            displayName: string
            id: string
            type: DealType
          }
        | {
            __typename?: 'PercentageDeal'
            basisPoints: number
            displayName: string
            id: string
            type: DealType
          }
        | null
        | undefined
      wholesalePricing: {
        __typename?: 'PricingInfo'
        casePrice?: number | null | undefined
        unitPrice?: number | null | undefined
      }
      product: {
        __typename?: 'Product'
        brandName?: string | null | undefined
        category?: string | null | undefined
        description?: string | null | undefined
        id: string
        imgURL?: string | null | undefined
        unitVolume?: string | null | undefined
        unitUPC?: string | null | undefined
      }
      vendor?:
        | {
            __typename?: 'Vendor'
            disableOutOfStockPurchases: boolean
            disableDiscontinuedPurchases: boolean
            id: string
            name?: string | null | undefined
            isInventoryEnabled: boolean
          }
        | null
        | undefined
    }>
  }
}

export type MarketGetActivePromotionsForVendorQueryVariables = Exact<{
  vendorID: Scalars['ID']
}>

export type MarketGetActivePromotionsForVendorQuery = {
  __typename?: 'Query'
  vendorByID?:
    | {
        __typename?: 'Vendor'
        id: string
        activePromotions?:
          | {
              __typename?: 'PromotionsResults'
              nodes: Array<{
                __typename?: 'Promotion'
                id: string
                name?: string | null | undefined
                deals: {
                  __typename?: 'DealsResults'
                  nodes: Array<
                    | {
                        __typename?: 'BuyXGetYFreeDeal'
                        freeCount: number
                        threshold: number
                        unitOfMeasure: UnitOfMeasure
                        displayName: string
                        id: string
                        type: DealType
                        vendorProducts: {
                          __typename?: 'DealVendorProductsResult'
                          nodes: Array<{
                            __typename?: 'VendorProduct'
                            caseSize?: number | null | undefined
                            id: string
                            inventory?: number | null | undefined
                            itemCode?: string | null | undefined
                            notes?: string | null | undefined
                            status: VendorProductStatus
                            wholesalePricing: {
                              __typename?: 'PricingInfo'
                              casePrice?: number | null | undefined
                              unitPrice?: number | null | undefined
                            }
                            product: {
                              __typename?: 'Product'
                              brandName?: string | null | undefined
                              category?: string | null | undefined
                              description?: string | null | undefined
                              id: string
                              imgURL?: string | null | undefined
                              unitVolume?: string | null | undefined
                              unitUPC?: string | null | undefined
                            }
                            vendor?:
                              | {
                                  __typename?: 'Vendor'
                                  disableOutOfStockPurchases: boolean
                                  disableDiscontinuedPurchases: boolean
                                  id: string
                                  name?: string | null | undefined
                                  isInventoryEnabled: boolean
                                }
                              | null
                              | undefined
                          }>
                        }
                      }
                    | {
                        __typename?: 'FixedDeal'
                        dealValue: number
                        unitOfMeasure: UnitOfMeasure
                        displayName: string
                        id: string
                        type: DealType
                        vendorProducts: {
                          __typename?: 'DealVendorProductsResult'
                          nodes: Array<{
                            __typename?: 'VendorProduct'
                            caseSize?: number | null | undefined
                            id: string
                            inventory?: number | null | undefined
                            itemCode?: string | null | undefined
                            notes?: string | null | undefined
                            status: VendorProductStatus
                            wholesalePricing: {
                              __typename?: 'PricingInfo'
                              casePrice?: number | null | undefined
                              unitPrice?: number | null | undefined
                            }
                            product: {
                              __typename?: 'Product'
                              brandName?: string | null | undefined
                              category?: string | null | undefined
                              description?: string | null | undefined
                              id: string
                              imgURL?: string | null | undefined
                              unitVolume?: string | null | undefined
                              unitUPC?: string | null | undefined
                            }
                            vendor?:
                              | {
                                  __typename?: 'Vendor'
                                  disableOutOfStockPurchases: boolean
                                  disableDiscontinuedPurchases: boolean
                                  id: string
                                  name?: string | null | undefined
                                  isInventoryEnabled: boolean
                                }
                              | null
                              | undefined
                          }>
                        }
                      }
                    | {
                        __typename?: 'PercentageDeal'
                        basisPoints: number
                        displayName: string
                        id: string
                        type: DealType
                        vendorProducts: {
                          __typename?: 'DealVendorProductsResult'
                          nodes: Array<{
                            __typename?: 'VendorProduct'
                            caseSize?: number | null | undefined
                            id: string
                            inventory?: number | null | undefined
                            itemCode?: string | null | undefined
                            notes?: string | null | undefined
                            status: VendorProductStatus
                            wholesalePricing: {
                              __typename?: 'PricingInfo'
                              casePrice?: number | null | undefined
                              unitPrice?: number | null | undefined
                            }
                            product: {
                              __typename?: 'Product'
                              brandName?: string | null | undefined
                              category?: string | null | undefined
                              description?: string | null | undefined
                              id: string
                              imgURL?: string | null | undefined
                              unitVolume?: string | null | undefined
                              unitUPC?: string | null | undefined
                            }
                            vendor?:
                              | {
                                  __typename?: 'Vendor'
                                  disableOutOfStockPurchases: boolean
                                  disableDiscontinuedPurchases: boolean
                                  id: string
                                  name?: string | null | undefined
                                  isInventoryEnabled: boolean
                                }
                              | null
                              | undefined
                          }>
                        }
                      }
                  >
                }
              }>
            }
          | null
          | undefined
      }
    | null
    | undefined
}

export const MarketVendorProductFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment Market_VendorProductFields on VendorProduct {
    caseSize
    id
    inventory
    itemCode
    notes
    status
    wholesalePricing {
      casePrice
      unitPrice
    }
    product {
      brandName
      category
      description
      id
      imgURL
      unitVolume
      unitUPC
    }
    vendor {
      disableOutOfStockPurchases
      disableDiscontinuedPurchases
      id
      name
      isInventoryEnabled
    }
  }
`
export const MarketVendorProductWithActiveDealFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment Market_VendorProductWithActiveDealFields on VendorProduct {
    ...Market_VendorProductFields
    activeDeal {
      displayName
      id
      type
      ... on PercentageDeal {
        basisPoints
      }
      ... on FixedDeal {
        dealValue
        unitOfMeasure
      }
      ... on BuyXGetYFreeDeal {
        freeCount
        threshold
        unitOfMeasure
      }
    }
  }
  ${MarketVendorProductFieldsFragmentDoc}
`
export const MarketPromotionFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment Market_PromotionFields on Promotion {
    id
    name
    deals {
      nodes {
        displayName
        id
        type
        vendorProducts {
          nodes {
            ...Market_VendorProductFields
          }
        }
        ... on PercentageDeal {
          basisPoints
        }
        ... on FixedDeal {
          dealValue
          unitOfMeasure
        }
        ... on BuyXGetYFreeDeal {
          freeCount
          threshold
          unitOfMeasure
        }
      }
    }
  }
  ${MarketVendorProductFieldsFragmentDoc}
`
export const MarketVendorFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment Market_VendorFields on Vendor {
    disableDiscontinuedPurchases
    disableOutOfStockPurchases
    headerImageURL
    id
    imgURL
    isInventoryEnabled
    name
    slug
  }
`
export const MarketUpdateVendorCartDocument = /*#__PURE__*/ gql`
  mutation Market_UpdateVendorCart(
    $lineItems: [CartLineItemInput!]!
    $storeID: ID
    $vendorID: ID!
  ) {
    updateVendorCartV2(
      input: {
        lineItems: $lineItems
        misscanLineItems: []
        storeID: $storeID
        vendorID: $vendorID
      }
    ) {
      cart {
        id
        lineItemCount
        productCount
        subTotal
        lineItems {
          nodes {
            id
            quantity
            price
            vendorProduct {
              ...Market_VendorProductWithActiveDealFields
            }
          }
        }
      }
    }
  }
  ${MarketVendorProductWithActiveDealFieldsFragmentDoc}
`
export type MarketUpdateVendorCartMutationFn = Apollo.MutationFunction<
  MarketUpdateVendorCartMutation,
  MarketUpdateVendorCartMutationVariables
>

/**
 * __useMarketUpdateVendorCartMutation__
 *
 * To run a mutation, you first call `useMarketUpdateVendorCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarketUpdateVendorCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [marketUpdateVendorCartMutation, { data, loading, error }] = useMarketUpdateVendorCartMutation({
 *   variables: {
 *      lineItems: // value for 'lineItems'
 *      storeID: // value for 'storeID'
 *      vendorID: // value for 'vendorID'
 *   },
 * });
 */
export function useMarketUpdateVendorCartMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MarketUpdateVendorCartMutation,
    MarketUpdateVendorCartMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    MarketUpdateVendorCartMutation,
    MarketUpdateVendorCartMutationVariables
  >(MarketUpdateVendorCartDocument, options)
}
export type MarketUpdateVendorCartMutationHookResult = ReturnType<
  typeof useMarketUpdateVendorCartMutation
>
export type MarketUpdateVendorCartMutationResult =
  Apollo.MutationResult<MarketUpdateVendorCartMutation>
export type MarketUpdateVendorCartMutationOptions = Apollo.BaseMutationOptions<
  MarketUpdateVendorCartMutation,
  MarketUpdateVendorCartMutationVariables
>
export const MarketUpdateCartQuantityDocument = /*#__PURE__*/ gql`
  mutation Market_UpdateCartQuantity(
    $quantity: Int!
    $unitOfMeasure: UnitOfMeasure!
    $vendorProductID: ID!
  ) {
    updateCartProductQuantity(
      input: {
        quantity: $quantity
        unitOfMeasure: $unitOfMeasure
        vendorProductID: $vendorProductID
      }
    ) {
      updatedVendorCart {
        id
        lineItemCount
        productCount
        subTotal
        totalDiscount
        lineItems {
          nodes {
            id
            quantity
            price
            vendorProduct {
              ...Market_VendorProductWithActiveDealFields
            }
          }
        }
      }
    }
  }
  ${MarketVendorProductWithActiveDealFieldsFragmentDoc}
`
export type MarketUpdateCartQuantityMutationFn = Apollo.MutationFunction<
  MarketUpdateCartQuantityMutation,
  MarketUpdateCartQuantityMutationVariables
>

/**
 * __useMarketUpdateCartQuantityMutation__
 *
 * To run a mutation, you first call `useMarketUpdateCartQuantityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarketUpdateCartQuantityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [marketUpdateCartQuantityMutation, { data, loading, error }] = useMarketUpdateCartQuantityMutation({
 *   variables: {
 *      quantity: // value for 'quantity'
 *      unitOfMeasure: // value for 'unitOfMeasure'
 *      vendorProductID: // value for 'vendorProductID'
 *   },
 * });
 */
export function useMarketUpdateCartQuantityMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MarketUpdateCartQuantityMutation,
    MarketUpdateCartQuantityMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    MarketUpdateCartQuantityMutation,
    MarketUpdateCartQuantityMutationVariables
  >(MarketUpdateCartQuantityDocument, options)
}
export type MarketUpdateCartQuantityMutationHookResult = ReturnType<
  typeof useMarketUpdateCartQuantityMutation
>
export type MarketUpdateCartQuantityMutationResult =
  Apollo.MutationResult<MarketUpdateCartQuantityMutation>
export type MarketUpdateCartQuantityMutationOptions =
  Apollo.BaseMutationOptions<
    MarketUpdateCartQuantityMutation,
    MarketUpdateCartQuantityMutationVariables
  >
export const MarketClearVendorCartDocument = /*#__PURE__*/ gql`
  mutation Market_ClearVendorCart($storeID: ID, $vendorID: ID!) {
    updateVendorCartV2(
      input: {
        lineItems: []
        misscanLineItems: []
        storeID: $storeID
        vendorID: $vendorID
      }
    ) {
      cart {
        id
        lineItemCount
        productCount
        subTotal
        lineItems {
          nodes {
            id
            quantity
            price
            vendorProduct {
              ...Market_VendorProductWithActiveDealFields
            }
          }
        }
      }
    }
  }
  ${MarketVendorProductWithActiveDealFieldsFragmentDoc}
`
export type MarketClearVendorCartMutationFn = Apollo.MutationFunction<
  MarketClearVendorCartMutation,
  MarketClearVendorCartMutationVariables
>

/**
 * __useMarketClearVendorCartMutation__
 *
 * To run a mutation, you first call `useMarketClearVendorCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarketClearVendorCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [marketClearVendorCartMutation, { data, loading, error }] = useMarketClearVendorCartMutation({
 *   variables: {
 *      storeID: // value for 'storeID'
 *      vendorID: // value for 'vendorID'
 *   },
 * });
 */
export function useMarketClearVendorCartMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MarketClearVendorCartMutation,
    MarketClearVendorCartMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    MarketClearVendorCartMutation,
    MarketClearVendorCartMutationVariables
  >(MarketClearVendorCartDocument, options)
}
export type MarketClearVendorCartMutationHookResult = ReturnType<
  typeof useMarketClearVendorCartMutation
>
export type MarketClearVendorCartMutationResult =
  Apollo.MutationResult<MarketClearVendorCartMutation>
export type MarketClearVendorCartMutationOptions = Apollo.BaseMutationOptions<
  MarketClearVendorCartMutation,
  MarketClearVendorCartMutationVariables
>
export const MarketPlaceOrderDocument = /*#__PURE__*/ gql`
  mutation Market_PlaceOrder(
    $deliveryDate: Timestamp
    $idempotencyKey: String!
    $noteToVendor: String
    $storeID: String!
    $vendorID: String!
  ) {
    createAndSubmitOrderFromCart(
      input: {
        client: MARKET
        deliveryDate: $deliveryDate
        idempotencyKey: $idempotencyKey
        noteToVendor: $noteToVendor
        storeID: $storeID
        vendorID: $vendorID
      }
    ) {
      cart {
        id
        lineItemCount
        productCount
        subTotal
        totalDiscount
        lineItems {
          nodes {
            id
            quantity
          }
        }
      }
    }
  }
`
export type MarketPlaceOrderMutationFn = Apollo.MutationFunction<
  MarketPlaceOrderMutation,
  MarketPlaceOrderMutationVariables
>

/**
 * __useMarketPlaceOrderMutation__
 *
 * To run a mutation, you first call `useMarketPlaceOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarketPlaceOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [marketPlaceOrderMutation, { data, loading, error }] = useMarketPlaceOrderMutation({
 *   variables: {
 *      deliveryDate: // value for 'deliveryDate'
 *      idempotencyKey: // value for 'idempotencyKey'
 *      noteToVendor: // value for 'noteToVendor'
 *      storeID: // value for 'storeID'
 *      vendorID: // value for 'vendorID'
 *   },
 * });
 */
export function useMarketPlaceOrderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MarketPlaceOrderMutation,
    MarketPlaceOrderMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    MarketPlaceOrderMutation,
    MarketPlaceOrderMutationVariables
  >(MarketPlaceOrderDocument, options)
}
export type MarketPlaceOrderMutationHookResult = ReturnType<
  typeof useMarketPlaceOrderMutation
>
export type MarketPlaceOrderMutationResult =
  Apollo.MutationResult<MarketPlaceOrderMutation>
export type MarketPlaceOrderMutationOptions = Apollo.BaseMutationOptions<
  MarketPlaceOrderMutation,
  MarketPlaceOrderMutationVariables
>
export const MarketAddProductsToUserOrderGuideDocument = /*#__PURE__*/ gql`
  mutation Market_AddProductsToUserOrderGuide(
    $input: AddProductsToV2OrderGuideInput!
  ) {
    addProductsToV2OrderGuide(input: $input) {
      orderGuide {
        id
        vendorProducts {
          totalCount
          nodes {
            product {
              id
            }
          }
        }
      }
    }
  }
`
export type MarketAddProductsToUserOrderGuideMutationFn =
  Apollo.MutationFunction<
    MarketAddProductsToUserOrderGuideMutation,
    MarketAddProductsToUserOrderGuideMutationVariables
  >

/**
 * __useMarketAddProductsToUserOrderGuideMutation__
 *
 * To run a mutation, you first call `useMarketAddProductsToUserOrderGuideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarketAddProductsToUserOrderGuideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [marketAddProductsToUserOrderGuideMutation, { data, loading, error }] = useMarketAddProductsToUserOrderGuideMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarketAddProductsToUserOrderGuideMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MarketAddProductsToUserOrderGuideMutation,
    MarketAddProductsToUserOrderGuideMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    MarketAddProductsToUserOrderGuideMutation,
    MarketAddProductsToUserOrderGuideMutationVariables
  >(MarketAddProductsToUserOrderGuideDocument, options)
}
export type MarketAddProductsToUserOrderGuideMutationHookResult = ReturnType<
  typeof useMarketAddProductsToUserOrderGuideMutation
>
export type MarketAddProductsToUserOrderGuideMutationResult =
  Apollo.MutationResult<MarketAddProductsToUserOrderGuideMutation>
export type MarketAddProductsToUserOrderGuideMutationOptions =
  Apollo.BaseMutationOptions<
    MarketAddProductsToUserOrderGuideMutation,
    MarketAddProductsToUserOrderGuideMutationVariables
  >
export const MarketRemoveProductsFromOrderGuideDocument = /*#__PURE__*/ gql`
  mutation Market_RemoveProductsFromOrderGuide(
    $input: RemoveProductsFromV2OrderGuideInput!
  ) {
    removeProductsFromV2OrderGuide(input: $input) {
      orderGuide {
        id
        vendorProducts {
          totalCount
        }
      }
    }
  }
`
export type MarketRemoveProductsFromOrderGuideMutationFn =
  Apollo.MutationFunction<
    MarketRemoveProductsFromOrderGuideMutation,
    MarketRemoveProductsFromOrderGuideMutationVariables
  >

/**
 * __useMarketRemoveProductsFromOrderGuideMutation__
 *
 * To run a mutation, you first call `useMarketRemoveProductsFromOrderGuideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarketRemoveProductsFromOrderGuideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [marketRemoveProductsFromOrderGuideMutation, { data, loading, error }] = useMarketRemoveProductsFromOrderGuideMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarketRemoveProductsFromOrderGuideMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MarketRemoveProductsFromOrderGuideMutation,
    MarketRemoveProductsFromOrderGuideMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    MarketRemoveProductsFromOrderGuideMutation,
    MarketRemoveProductsFromOrderGuideMutationVariables
  >(MarketRemoveProductsFromOrderGuideDocument, options)
}
export type MarketRemoveProductsFromOrderGuideMutationHookResult = ReturnType<
  typeof useMarketRemoveProductsFromOrderGuideMutation
>
export type MarketRemoveProductsFromOrderGuideMutationResult =
  Apollo.MutationResult<MarketRemoveProductsFromOrderGuideMutation>
export type MarketRemoveProductsFromOrderGuideMutationOptions =
  Apollo.BaseMutationOptions<
    MarketRemoveProductsFromOrderGuideMutation,
    MarketRemoveProductsFromOrderGuideMutationVariables
  >
export const MarketUpdateBuyerProfileDocument = /*#__PURE__*/ gql`
  mutation Market_UpdateBuyerProfile(
    $displayName: String
    $email: String
    $phoneNumber: String
  ) {
    updateProfile(
      input: {
        displayName: $displayName
        email: $email
        phoneNumber: $phoneNumber
      }
    ) {
      displayName
      email
      id
      phoneNumber
    }
  }
`
export type MarketUpdateBuyerProfileMutationFn = Apollo.MutationFunction<
  MarketUpdateBuyerProfileMutation,
  MarketUpdateBuyerProfileMutationVariables
>

/**
 * __useMarketUpdateBuyerProfileMutation__
 *
 * To run a mutation, you first call `useMarketUpdateBuyerProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarketUpdateBuyerProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [marketUpdateBuyerProfileMutation, { data, loading, error }] = useMarketUpdateBuyerProfileMutation({
 *   variables: {
 *      displayName: // value for 'displayName'
 *      email: // value for 'email'
 *      phoneNumber: // value for 'phoneNumber'
 *   },
 * });
 */
export function useMarketUpdateBuyerProfileMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MarketUpdateBuyerProfileMutation,
    MarketUpdateBuyerProfileMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    MarketUpdateBuyerProfileMutation,
    MarketUpdateBuyerProfileMutationVariables
  >(MarketUpdateBuyerProfileDocument, options)
}
export type MarketUpdateBuyerProfileMutationHookResult = ReturnType<
  typeof useMarketUpdateBuyerProfileMutation
>
export type MarketUpdateBuyerProfileMutationResult =
  Apollo.MutationResult<MarketUpdateBuyerProfileMutation>
export type MarketUpdateBuyerProfileMutationOptions =
  Apollo.BaseMutationOptions<
    MarketUpdateBuyerProfileMutation,
    MarketUpdateBuyerProfileMutationVariables
  >
export const MarketGetCurrentUserDocument = /*#__PURE__*/ gql`
  query Market_GetCurrentUser($featureIDs: [String!]) {
    me {
      user {
        id
        email
        phoneNumber
        defaultDepartmentName
        displayName
        storeDepartments {
          nodes {
            id
            name
          }
        }
        userType
        canSeeFeatures(input: { featureIDs: $featureIDs }) {
          enabledFeatures
        }
        vendorUser {
          vendor {
            name
            id
          }
        }
        retailUser {
          user {
            id
          }
          retailCompany {
            id
            name
            store {
              address
              id
              name
            }
          }
        }
      }
    }
  }
`

/**
 * __useMarketGetCurrentUserQuery__
 *
 * To run a query within a React component, call `useMarketGetCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketGetCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketGetCurrentUserQuery({
 *   variables: {
 *      featureIDs: // value for 'featureIDs'
 *   },
 * });
 */
export function useMarketGetCurrentUserQuery(
  baseOptions?: Apollo.QueryHookOptions<
    MarketGetCurrentUserQuery,
    MarketGetCurrentUserQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    MarketGetCurrentUserQuery,
    MarketGetCurrentUserQueryVariables
  >(MarketGetCurrentUserDocument, options)
}
export function useMarketGetCurrentUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MarketGetCurrentUserQuery,
    MarketGetCurrentUserQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    MarketGetCurrentUserQuery,
    MarketGetCurrentUserQueryVariables
  >(MarketGetCurrentUserDocument, options)
}
export type MarketGetCurrentUserQueryHookResult = ReturnType<
  typeof useMarketGetCurrentUserQuery
>
export type MarketGetCurrentUserLazyQueryHookResult = ReturnType<
  typeof useMarketGetCurrentUserLazyQuery
>
export type MarketGetCurrentUserQueryResult = Apollo.QueryResult<
  MarketGetCurrentUserQuery,
  MarketGetCurrentUserQueryVariables
>
export function refetchMarketGetCurrentUserQuery(
  variables?: MarketGetCurrentUserQueryVariables,
) {
  return { query: MarketGetCurrentUserDocument, variables: variables }
}
export const MarketGetVendorIdFromSlugOrIdDocument = /*#__PURE__*/ gql`
  query Market_GetVendorIDFromSlugOrID($slugOrID: String!) {
    vendorBySlug(slugOrID: $slugOrID) {
      id
    }
  }
`

/**
 * __useMarketGetVendorIdFromSlugOrIdQuery__
 *
 * To run a query within a React component, call `useMarketGetVendorIdFromSlugOrIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketGetVendorIdFromSlugOrIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketGetVendorIdFromSlugOrIdQuery({
 *   variables: {
 *      slugOrID: // value for 'slugOrID'
 *   },
 * });
 */
export function useMarketGetVendorIdFromSlugOrIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    MarketGetVendorIdFromSlugOrIdQuery,
    MarketGetVendorIdFromSlugOrIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    MarketGetVendorIdFromSlugOrIdQuery,
    MarketGetVendorIdFromSlugOrIdQueryVariables
  >(MarketGetVendorIdFromSlugOrIdDocument, options)
}
export function useMarketGetVendorIdFromSlugOrIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MarketGetVendorIdFromSlugOrIdQuery,
    MarketGetVendorIdFromSlugOrIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    MarketGetVendorIdFromSlugOrIdQuery,
    MarketGetVendorIdFromSlugOrIdQueryVariables
  >(MarketGetVendorIdFromSlugOrIdDocument, options)
}
export type MarketGetVendorIdFromSlugOrIdQueryHookResult = ReturnType<
  typeof useMarketGetVendorIdFromSlugOrIdQuery
>
export type MarketGetVendorIdFromSlugOrIdLazyQueryHookResult = ReturnType<
  typeof useMarketGetVendorIdFromSlugOrIdLazyQuery
>
export type MarketGetVendorIdFromSlugOrIdQueryResult = Apollo.QueryResult<
  MarketGetVendorIdFromSlugOrIdQuery,
  MarketGetVendorIdFromSlugOrIdQueryVariables
>
export function refetchMarketGetVendorIdFromSlugOrIdQuery(
  variables: MarketGetVendorIdFromSlugOrIdQueryVariables,
) {
  return { query: MarketGetVendorIdFromSlugOrIdDocument, variables: variables }
}
export const MarketGetCartsInfoForCheckoutButtonDocument = /*#__PURE__*/ gql`
  query Market_GetCartsInfoForCheckoutButton {
    me {
      user {
        id
        carts {
          id
          subTotal
          lineItemCount
          vendor {
            id
            slug
            isMarketEnabled
          }
        }
      }
    }
  }
`

/**
 * __useMarketGetCartsInfoForCheckoutButtonQuery__
 *
 * To run a query within a React component, call `useMarketGetCartsInfoForCheckoutButtonQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketGetCartsInfoForCheckoutButtonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketGetCartsInfoForCheckoutButtonQuery({
 *   variables: {
 *   },
 * });
 */
export function useMarketGetCartsInfoForCheckoutButtonQuery(
  baseOptions?: Apollo.QueryHookOptions<
    MarketGetCartsInfoForCheckoutButtonQuery,
    MarketGetCartsInfoForCheckoutButtonQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    MarketGetCartsInfoForCheckoutButtonQuery,
    MarketGetCartsInfoForCheckoutButtonQueryVariables
  >(MarketGetCartsInfoForCheckoutButtonDocument, options)
}
export function useMarketGetCartsInfoForCheckoutButtonLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MarketGetCartsInfoForCheckoutButtonQuery,
    MarketGetCartsInfoForCheckoutButtonQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    MarketGetCartsInfoForCheckoutButtonQuery,
    MarketGetCartsInfoForCheckoutButtonQueryVariables
  >(MarketGetCartsInfoForCheckoutButtonDocument, options)
}
export type MarketGetCartsInfoForCheckoutButtonQueryHookResult = ReturnType<
  typeof useMarketGetCartsInfoForCheckoutButtonQuery
>
export type MarketGetCartsInfoForCheckoutButtonLazyQueryHookResult = ReturnType<
  typeof useMarketGetCartsInfoForCheckoutButtonLazyQuery
>
export type MarketGetCartsInfoForCheckoutButtonQueryResult = Apollo.QueryResult<
  MarketGetCartsInfoForCheckoutButtonQuery,
  MarketGetCartsInfoForCheckoutButtonQueryVariables
>
export function refetchMarketGetCartsInfoForCheckoutButtonQuery(
  variables?: MarketGetCartsInfoForCheckoutButtonQueryVariables,
) {
  return {
    query: MarketGetCartsInfoForCheckoutButtonDocument,
    variables: variables,
  }
}
export const MarketGetCartsDocument = /*#__PURE__*/ gql`
  query Market_GetCarts {
    me {
      user {
        id
        carts {
          id
          store {
            id
          }
          vendor {
            email
            id
            imgURL
            isMarketEnabled
            name
            orderMin
            orderMinimums {
              orderMin
              storeID
            }
            slug
            disableOutOfStockPurchases
          }
          outOfStockProducts {
            nodes {
              id
            }
          }
          lineItemCount
          productCount
          subTotal
          totalDiscount
          lineItems {
            nodes {
              id
              price
              quantity
              vendorProduct {
                ...Market_VendorProductWithActiveDealFields
              }
            }
          }
        }
      }
    }
  }
  ${MarketVendorProductWithActiveDealFieldsFragmentDoc}
`

/**
 * __useMarketGetCartsQuery__
 *
 * To run a query within a React component, call `useMarketGetCartsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketGetCartsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketGetCartsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMarketGetCartsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    MarketGetCartsQuery,
    MarketGetCartsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<MarketGetCartsQuery, MarketGetCartsQueryVariables>(
    MarketGetCartsDocument,
    options,
  )
}
export function useMarketGetCartsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MarketGetCartsQuery,
    MarketGetCartsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<MarketGetCartsQuery, MarketGetCartsQueryVariables>(
    MarketGetCartsDocument,
    options,
  )
}
export type MarketGetCartsQueryHookResult = ReturnType<
  typeof useMarketGetCartsQuery
>
export type MarketGetCartsLazyQueryHookResult = ReturnType<
  typeof useMarketGetCartsLazyQuery
>
export type MarketGetCartsQueryResult = Apollo.QueryResult<
  MarketGetCartsQuery,
  MarketGetCartsQueryVariables
>
export function refetchMarketGetCartsQuery(
  variables?: MarketGetCartsQueryVariables,
) {
  return { query: MarketGetCartsDocument, variables: variables }
}
export const MarketGetOrderGuideDocument = /*#__PURE__*/ gql`
  query Market_GetOrderGuide($storeDepartmentID: ID!, $vendorID: ID!) {
    getVendorStoreDepartmentAccountForVendor(
      storeDepartmentID: $storeDepartmentID
      vendorID: $vendorID
    ) {
      id
      orderGuide {
        id
        vendorProductIDs
        vendorProducts(input: { limit: 1000 }) {
          nodes {
            ...Market_VendorProductWithActiveDealFields
          }
        }
      }
    }
  }
  ${MarketVendorProductWithActiveDealFieldsFragmentDoc}
`

/**
 * __useMarketGetOrderGuideQuery__
 *
 * To run a query within a React component, call `useMarketGetOrderGuideQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketGetOrderGuideQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketGetOrderGuideQuery({
 *   variables: {
 *      storeDepartmentID: // value for 'storeDepartmentID'
 *      vendorID: // value for 'vendorID'
 *   },
 * });
 */
export function useMarketGetOrderGuideQuery(
  baseOptions: Apollo.QueryHookOptions<
    MarketGetOrderGuideQuery,
    MarketGetOrderGuideQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    MarketGetOrderGuideQuery,
    MarketGetOrderGuideQueryVariables
  >(MarketGetOrderGuideDocument, options)
}
export function useMarketGetOrderGuideLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MarketGetOrderGuideQuery,
    MarketGetOrderGuideQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    MarketGetOrderGuideQuery,
    MarketGetOrderGuideQueryVariables
  >(MarketGetOrderGuideDocument, options)
}
export type MarketGetOrderGuideQueryHookResult = ReturnType<
  typeof useMarketGetOrderGuideQuery
>
export type MarketGetOrderGuideLazyQueryHookResult = ReturnType<
  typeof useMarketGetOrderGuideLazyQuery
>
export type MarketGetOrderGuideQueryResult = Apollo.QueryResult<
  MarketGetOrderGuideQuery,
  MarketGetOrderGuideQueryVariables
>
export function refetchMarketGetOrderGuideQuery(
  variables: MarketGetOrderGuideQueryVariables,
) {
  return { query: MarketGetOrderGuideDocument, variables: variables }
}
export const MarketGetVendorProductOrderHistoryDocument = /*#__PURE__*/ gql`
  query Market_GetVendorProductOrderHistory($productID: ID!, $limit: Int) {
    me {
      user {
        id
        retailUser {
          user {
            id
          }
          retailCompany {
            id
            store {
              id
              productOrderHistory(
                input: { productID: $productID, limit: $limit }
              ) {
                nodes {
                  orderID
                  vendorProduct {
                    ...Market_VendorProductWithActiveDealFields
                  }
                  orderDateTime
                  price
                  quantity
                  unitOfMeasure
                }
              }
            }
          }
        }
      }
    }
  }
  ${MarketVendorProductWithActiveDealFieldsFragmentDoc}
`

/**
 * __useMarketGetVendorProductOrderHistoryQuery__
 *
 * To run a query within a React component, call `useMarketGetVendorProductOrderHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketGetVendorProductOrderHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketGetVendorProductOrderHistoryQuery({
 *   variables: {
 *      productID: // value for 'productID'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useMarketGetVendorProductOrderHistoryQuery(
  baseOptions: Apollo.QueryHookOptions<
    MarketGetVendorProductOrderHistoryQuery,
    MarketGetVendorProductOrderHistoryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    MarketGetVendorProductOrderHistoryQuery,
    MarketGetVendorProductOrderHistoryQueryVariables
  >(MarketGetVendorProductOrderHistoryDocument, options)
}
export function useMarketGetVendorProductOrderHistoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MarketGetVendorProductOrderHistoryQuery,
    MarketGetVendorProductOrderHistoryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    MarketGetVendorProductOrderHistoryQuery,
    MarketGetVendorProductOrderHistoryQueryVariables
  >(MarketGetVendorProductOrderHistoryDocument, options)
}
export type MarketGetVendorProductOrderHistoryQueryHookResult = ReturnType<
  typeof useMarketGetVendorProductOrderHistoryQuery
>
export type MarketGetVendorProductOrderHistoryLazyQueryHookResult = ReturnType<
  typeof useMarketGetVendorProductOrderHistoryLazyQuery
>
export type MarketGetVendorProductOrderHistoryQueryResult = Apollo.QueryResult<
  MarketGetVendorProductOrderHistoryQuery,
  MarketGetVendorProductOrderHistoryQueryVariables
>
export function refetchMarketGetVendorProductOrderHistoryQuery(
  variables: MarketGetVendorProductOrderHistoryQueryVariables,
) {
  return {
    query: MarketGetVendorProductOrderHistoryDocument,
    variables: variables,
  }
}
export const MarketGetActivePromotionsDocument = /*#__PURE__*/ gql`
  query Market_GetActivePromotions {
    me {
      user {
        id
        retailUser {
          user {
            id
          }
          vendorStoreDepartmentAccounts(input: { marketEnabledOnly: true }) {
            nodes {
              accountNumber
              id
              activePromotions {
                nodes {
                  ...Market_PromotionFields
                }
              }
              vendor {
                id
                name
                slug
              }
            }
          }
          retailCompany {
            id
            store {
              id
            }
          }
        }
        vendorUser {
          vendor {
            activePromotions {
              nodes {
                ...Market_PromotionFields
              }
            }
          }
        }
      }
    }
  }
  ${MarketPromotionFieldsFragmentDoc}
`

/**
 * __useMarketGetActivePromotionsQuery__
 *
 * To run a query within a React component, call `useMarketGetActivePromotionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketGetActivePromotionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketGetActivePromotionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMarketGetActivePromotionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    MarketGetActivePromotionsQuery,
    MarketGetActivePromotionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    MarketGetActivePromotionsQuery,
    MarketGetActivePromotionsQueryVariables
  >(MarketGetActivePromotionsDocument, options)
}
export function useMarketGetActivePromotionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MarketGetActivePromotionsQuery,
    MarketGetActivePromotionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    MarketGetActivePromotionsQuery,
    MarketGetActivePromotionsQueryVariables
  >(MarketGetActivePromotionsDocument, options)
}
export type MarketGetActivePromotionsQueryHookResult = ReturnType<
  typeof useMarketGetActivePromotionsQuery
>
export type MarketGetActivePromotionsLazyQueryHookResult = ReturnType<
  typeof useMarketGetActivePromotionsLazyQuery
>
export type MarketGetActivePromotionsQueryResult = Apollo.QueryResult<
  MarketGetActivePromotionsQuery,
  MarketGetActivePromotionsQueryVariables
>
export function refetchMarketGetActivePromotionsQuery(
  variables?: MarketGetActivePromotionsQueryVariables,
) {
  return { query: MarketGetActivePromotionsDocument, variables: variables }
}
export const MarketGetAllVendorsDocument = /*#__PURE__*/ gql`
  query Market_GetAllVendors {
    me {
      user {
        id
        userType
        defaultDepartmentName
        storeDepartments {
          nodes {
            id
            name
            vendorStoreDepartmentAccounts(input: { marketEnabledOnly: true }) {
              nodes {
                id
                vendor {
                  ...Market_VendorFields
                }
              }
            }
          }
        }
        vendorUser {
          vendor {
            ...Market_VendorFields
          }
        }
      }
    }
  }
  ${MarketVendorFieldsFragmentDoc}
`

/**
 * __useMarketGetAllVendorsQuery__
 *
 * To run a query within a React component, call `useMarketGetAllVendorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketGetAllVendorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketGetAllVendorsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMarketGetAllVendorsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    MarketGetAllVendorsQuery,
    MarketGetAllVendorsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    MarketGetAllVendorsQuery,
    MarketGetAllVendorsQueryVariables
  >(MarketGetAllVendorsDocument, options)
}
export function useMarketGetAllVendorsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MarketGetAllVendorsQuery,
    MarketGetAllVendorsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    MarketGetAllVendorsQuery,
    MarketGetAllVendorsQueryVariables
  >(MarketGetAllVendorsDocument, options)
}
export type MarketGetAllVendorsQueryHookResult = ReturnType<
  typeof useMarketGetAllVendorsQuery
>
export type MarketGetAllVendorsLazyQueryHookResult = ReturnType<
  typeof useMarketGetAllVendorsLazyQuery
>
export type MarketGetAllVendorsQueryResult = Apollo.QueryResult<
  MarketGetAllVendorsQuery,
  MarketGetAllVendorsQueryVariables
>
export function refetchMarketGetAllVendorsQuery(
  variables?: MarketGetAllVendorsQueryVariables,
) {
  return { query: MarketGetAllVendorsDocument, variables: variables }
}
export const MarketGetVendorDetailsBySlugOrIdDocument = /*#__PURE__*/ gql`
  query Market_GetVendorDetailsBySlugOrID($slugOrID: String!) {
    vendorBySlug(slugOrID: $slugOrID) {
      headerImageURL
      id
      imgURL
      name
      orderDeadline
      orderMin
      orderMinimums {
        storeID
        orderMin
      }
    }
  }
`

/**
 * __useMarketGetVendorDetailsBySlugOrIdQuery__
 *
 * To run a query within a React component, call `useMarketGetVendorDetailsBySlugOrIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketGetVendorDetailsBySlugOrIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketGetVendorDetailsBySlugOrIdQuery({
 *   variables: {
 *      slugOrID: // value for 'slugOrID'
 *   },
 * });
 */
export function useMarketGetVendorDetailsBySlugOrIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    MarketGetVendorDetailsBySlugOrIdQuery,
    MarketGetVendorDetailsBySlugOrIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    MarketGetVendorDetailsBySlugOrIdQuery,
    MarketGetVendorDetailsBySlugOrIdQueryVariables
  >(MarketGetVendorDetailsBySlugOrIdDocument, options)
}
export function useMarketGetVendorDetailsBySlugOrIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MarketGetVendorDetailsBySlugOrIdQuery,
    MarketGetVendorDetailsBySlugOrIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    MarketGetVendorDetailsBySlugOrIdQuery,
    MarketGetVendorDetailsBySlugOrIdQueryVariables
  >(MarketGetVendorDetailsBySlugOrIdDocument, options)
}
export type MarketGetVendorDetailsBySlugOrIdQueryHookResult = ReturnType<
  typeof useMarketGetVendorDetailsBySlugOrIdQuery
>
export type MarketGetVendorDetailsBySlugOrIdLazyQueryHookResult = ReturnType<
  typeof useMarketGetVendorDetailsBySlugOrIdLazyQuery
>
export type MarketGetVendorDetailsBySlugOrIdQueryResult = Apollo.QueryResult<
  MarketGetVendorDetailsBySlugOrIdQuery,
  MarketGetVendorDetailsBySlugOrIdQueryVariables
>
export function refetchMarketGetVendorDetailsBySlugOrIdQuery(
  variables: MarketGetVendorDetailsBySlugOrIdQueryVariables,
) {
  return {
    query: MarketGetVendorDetailsBySlugOrIdDocument,
    variables: variables,
  }
}
export const MarketGetVendorProductsDocument = /*#__PURE__*/ gql`
  query Market_GetVendorProducts(
    $vendorID: ID!
    $query: String
    $cursor: ID
    $limit: Int
  ) {
    vendorProducts(
      input: {
        vendorID: $vendorID
        search: $query
        pagination: { cursor: $cursor }
        limit: $limit
      }
    ) {
      cursor
      hasMore
      nodes {
        ...Market_VendorProductWithActiveDealFields
      }
    }
  }
  ${MarketVendorProductWithActiveDealFieldsFragmentDoc}
`

/**
 * __useMarketGetVendorProductsQuery__
 *
 * To run a query within a React component, call `useMarketGetVendorProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketGetVendorProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketGetVendorProductsQuery({
 *   variables: {
 *      vendorID: // value for 'vendorID'
 *      query: // value for 'query'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useMarketGetVendorProductsQuery(
  baseOptions: Apollo.QueryHookOptions<
    MarketGetVendorProductsQuery,
    MarketGetVendorProductsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    MarketGetVendorProductsQuery,
    MarketGetVendorProductsQueryVariables
  >(MarketGetVendorProductsDocument, options)
}
export function useMarketGetVendorProductsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MarketGetVendorProductsQuery,
    MarketGetVendorProductsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    MarketGetVendorProductsQuery,
    MarketGetVendorProductsQueryVariables
  >(MarketGetVendorProductsDocument, options)
}
export type MarketGetVendorProductsQueryHookResult = ReturnType<
  typeof useMarketGetVendorProductsQuery
>
export type MarketGetVendorProductsLazyQueryHookResult = ReturnType<
  typeof useMarketGetVendorProductsLazyQuery
>
export type MarketGetVendorProductsQueryResult = Apollo.QueryResult<
  MarketGetVendorProductsQuery,
  MarketGetVendorProductsQueryVariables
>
export function refetchMarketGetVendorProductsQuery(
  variables: MarketGetVendorProductsQueryVariables,
) {
  return { query: MarketGetVendorProductsDocument, variables: variables }
}
export const MarketGetActivePromotionsForVendorDocument = /*#__PURE__*/ gql`
  query Market_GetActivePromotionsForVendor($vendorID: ID!) {
    vendorByID(id: $vendorID) {
      id
      activePromotions {
        nodes {
          id
          name
          deals {
            nodes {
              displayName
              id
              type
              vendorProducts {
                nodes {
                  ...Market_VendorProductFields
                }
              }
              ... on PercentageDeal {
                basisPoints
              }
              ... on FixedDeal {
                dealValue
                unitOfMeasure
              }
              ... on BuyXGetYFreeDeal {
                freeCount
                threshold
                unitOfMeasure
              }
            }
          }
        }
      }
    }
  }
  ${MarketVendorProductFieldsFragmentDoc}
`

/**
 * __useMarketGetActivePromotionsForVendorQuery__
 *
 * To run a query within a React component, call `useMarketGetActivePromotionsForVendorQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketGetActivePromotionsForVendorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketGetActivePromotionsForVendorQuery({
 *   variables: {
 *      vendorID: // value for 'vendorID'
 *   },
 * });
 */
export function useMarketGetActivePromotionsForVendorQuery(
  baseOptions: Apollo.QueryHookOptions<
    MarketGetActivePromotionsForVendorQuery,
    MarketGetActivePromotionsForVendorQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    MarketGetActivePromotionsForVendorQuery,
    MarketGetActivePromotionsForVendorQueryVariables
  >(MarketGetActivePromotionsForVendorDocument, options)
}
export function useMarketGetActivePromotionsForVendorLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MarketGetActivePromotionsForVendorQuery,
    MarketGetActivePromotionsForVendorQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    MarketGetActivePromotionsForVendorQuery,
    MarketGetActivePromotionsForVendorQueryVariables
  >(MarketGetActivePromotionsForVendorDocument, options)
}
export type MarketGetActivePromotionsForVendorQueryHookResult = ReturnType<
  typeof useMarketGetActivePromotionsForVendorQuery
>
export type MarketGetActivePromotionsForVendorLazyQueryHookResult = ReturnType<
  typeof useMarketGetActivePromotionsForVendorLazyQuery
>
export type MarketGetActivePromotionsForVendorQueryResult = Apollo.QueryResult<
  MarketGetActivePromotionsForVendorQuery,
  MarketGetActivePromotionsForVendorQueryVariables
>
export function refetchMarketGetActivePromotionsForVendorQuery(
  variables: MarketGetActivePromotionsForVendorQueryVariables,
) {
  return {
    query: MarketGetActivePromotionsForVendorDocument,
    variables: variables,
  }
}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string
  String: string
  Boolean: boolean
  Int: number
  Float: number
  Currency: number
  Cursor: any
  DateTime: any
  Decimal: any
  Timestamp: Date | string
  Upload: any
}

export type AccountSpecificPrice = {
  __typename?: 'AccountSpecificPrice'
  accountID: Scalars['String']
  price: Scalars['Currency']
}

export type AccountSpecificPriceInput = {
  accountID: Scalars['String']
  price?: InputMaybe<Scalars['Currency']>
}

/**
 * ****************************
 *     Accounting Integration
 * ****************************
 */
export type AccountingIntegration = {
  __typename?: 'AccountingIntegration'
  complete: Scalars['Boolean']
  vendorMappingOneWay: Scalars['Boolean']
}

export type AccountingIntegrationMappingConfig = {
  __typename?: 'AccountingIntegrationMappingConfig'
  tabs: Array<AccountingIntegrationModelMapping>
}

export type AccountingIntegrationModelMapping = {
  __typename?: 'AccountingIntegrationModelMapping'
  source: AccountingIntegrationSourceModel
  target: AccountingIntegrationTargetModel
}

export type AccountingIntegrationRecords = {
  __typename?: 'AccountingIntegrationRecords'
  sourceRecords: Array<AccountingIntegrationSourceRecord>
  targetRecords: Array<AccountingIntegrationTargetRecord>
}

export type AccountingIntegrationRecordsInput = {
  sourceType: AccountingIntegrationSourceType
  storeIDs?: InputMaybe<Array<Scalars['ID']>>
  targetType: AccountingIntegrationTargetType
}

export type AccountingIntegrationSourceDetails = {
  __typename?: 'AccountingIntegrationSourceDetails'
  header: Scalars['String']
  subtitle?: Maybe<Scalars['String']>
  title: Scalars['String']
}

export type AccountingIntegrationSourceModel = {
  __typename?: 'AccountingIntegrationSourceModel'
  name: Scalars['String']
  type: AccountingIntegrationSourceType
}

export type AccountingIntegrationSourceRecord = {
  __typename?: 'AccountingIntegrationSourceRecord'
  details: AccountingIntegrationSourceDetails
  id: Scalars['ID']
  imageURL: Scalars['String']
  name: Scalars['String']
  targetRecordID?: Maybe<Scalars['ID']>
}

export enum AccountingIntegrationSourceType {
  Department = 'DEPARTMENT',
  Store = 'STORE',
  StoreVendor = 'STORE_VENDOR',
  Vendor = 'VENDOR',
}

export type AccountingIntegrationTargetModel = {
  __typename?: 'AccountingIntegrationTargetModel'
  name: Scalars['String']
  type: AccountingIntegrationTargetType
}

export type AccountingIntegrationTargetRecord = {
  __typename?: 'AccountingIntegrationTargetRecord'
  id: Scalars['ID']
  name: Scalars['String']
}

export enum AccountingIntegrationTargetType {
  CodatAccount = 'CODAT_ACCOUNT',
  CodatSupplier = 'CODAT_SUPPLIER',
  CodatTrackingCategory = 'CODAT_TRACKING_CATEGORY',
  FmsDepartment = 'FMS_DEPARTMENT',
  FmsStore = 'FMS_STORE',
  FmsVendor = 'FMS_VENDOR',
}

export enum AccountingPlatformInvoiceSyncStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Success = 'SUCCESS',
}

export enum AcquisitionSource {
  EmailCampaign = 'EMAIL_CAMPAIGN',
  Event = 'EVENT',
  ListPurchase = 'LIST_PURCHASE',
  Partner = 'PARTNER',
  SalesOutbound = 'SALES_OUTBOUND',
  StoreReferral = 'STORE_REFERRAL',
  ThirdPartyDigitalAd = 'THIRD_PARTY_DIGITAL_AD',
  VendorReferral = 'VENDOR_REFERRAL',
  Webinar = 'WEBINAR',
  Website = 'WEBSITE',
}

export type AddProductsToOrderGuideInput = {
  productIDs: Array<Scalars['ID']>
  storeID: Scalars['ID']
  /** Optional: which user's OrderGuide to update. If not provided, this mutation defaults to the authenticated user. */
  userID?: InputMaybe<Scalars['ID']>
  vendorID: Scalars['ID']
}

export type AddProductsToV2OrderGuideForStoreDepartmentInput = {
  searchID?: InputMaybe<Scalars['String']>
  storeDepartmentID: Scalars['ID']
  vendorProductIDs: Array<Scalars['ID']>
}

export type AddProductsToV2OrderGuideInput = {
  vendorProductIDs: Array<Scalars['ID']>
  vendorStoreDepartmentAccountID: Scalars['ID']
}

export type AddProductsToV2OrderGuideResult = {
  __typename?: 'AddProductsToV2OrderGuideResult'
  addedVendorProducts: Array<VendorProduct>
  orderGuide: V2OrderGuide
}

export type AddressComponents = {
  __typename?: 'AddressComponents'
  addressLine1?: Maybe<Scalars['String']>
  addressLine2?: Maybe<Scalars['String']>
  city?: Maybe<Scalars['String']>
  county?: Maybe<Scalars['String']>
  postalCode?: Maybe<Scalars['String']>
  state?: Maybe<Scalars['String']>
}

export type AdminAllOrdersInput = {
  limit?: InputMaybe<Scalars['Int']>
  orderDateSince?: InputMaybe<Scalars['Timestamp']>
  storeID?: InputMaybe<Scalars['ID']>
  vendorID?: InputMaybe<Scalars['ID']>
}

export type AdminAllStoresInput = {
  /** Filter stores by name, address, email, placeID or geographicCoordinates */
  query?: InputMaybe<Scalars['String']>
}

export type AdminAllUsersInput = {
  companyID?: InputMaybe<Scalars['String']>
  storeID?: InputMaybe<Scalars['String']>
  /** Optional list of user types to filter by */
  userTypeFilter?: InputMaybe<Array<UserType>>
}

/**
 * ****************************
 *     EDI Service Admin
 * ****************************
 */
export type AdminCreateEdiPartnerInput = {
  ediPartnerName: Scalars['ID']
  interchangeNumber?: InputMaybe<Scalars['Int']>
  vendorID: Scalars['ID']
}

export type AdminCreateFeatureFlagInput = {
  /** The name=ID of the feature flag. This is the string clients use to check a user's access to the flagged feature. */
  name: Scalars['String']
}

export type AdminCreateSftpGoUserInput = {
  description?: InputMaybe<Scalars['String']>
  fileType: SftpFileType
  password: Scalars['String']
  username: Scalars['String']
}

export type AdminSimilarStoresInput = {
  address: Scalars['String']
  geographicCoordinates?: InputMaybe<Scalars['String']>
  /** Find similar / duplicate stores by name, address, email, geographicCoordinates or placeID */
  name: Scalars['String']
  placeID: Scalars['String']
}

export type AdminStoreInvitationsInput = {
  cursor?: InputMaybe<Scalars['ID']>
  email?: InputMaybe<Scalars['String']>
  invitedByUserEmail?: InputMaybe<Scalars['String']>
  limit?: InputMaybe<Scalars['Int']>
  signedUpEmail?: InputMaybe<Scalars['String']>
  status?: InputMaybe<InvitationStatus>
  storeID?: InputMaybe<Scalars['ID']>
  vendorID?: InputMaybe<Scalars['ID']>
}

export type AdminStoreVendorProductsQueryResult = {
  __typename?: 'AdminStoreVendorProductsQueryResult'
  cursor: Scalars['Float']
  hasMore: Scalars['Boolean']
  nodes: Array<StoreVendorProductResult>
  totalCount: Scalars['Float']
}

export type AdminStoreVendorsQueryResult = {
  __typename?: 'AdminStoreVendorsQueryResult'
  cursor: Scalars['Float']
  hasMore: Scalars['Boolean']
  nodes: Array<StoreVendorResult>
  totalCount: Scalars['Float']
}

export type AdminStoresResult = {
  __typename?: 'AdminStoresResult'
  nodes: Array<Store>
}

export type AdminUpdateFeatureFlagInput = {
  defaultBehavior?: InputMaybe<FeatureFlagDefaultBehavior>
  description?: InputMaybe<Scalars['String']>
  excludedLaneIDs?: InputMaybe<Array<Scalars['ID']>>
  excludedUserIDs?: InputMaybe<Array<Scalars['ID']>>
  id: Scalars['ID']
  includedLaneIDs?: InputMaybe<Array<Scalars['ID']>>
  includedUserIDs?: InputMaybe<Array<Scalars['ID']>>
  rules?: InputMaybe<Array<FeatureFlagRuleInput>>
}

export type AdminUsersPaginatedFilters = {
  companyID?: InputMaybe<Scalars['ID']>
  displayName?: InputMaybe<Scalars['String']>
  email?: InputMaybe<Scalars['String']>
  userTypes?: InputMaybe<Array<UserType>>
}

export type AdminUsersPaginatedInput = {
  cursor?: InputMaybe<Scalars['ID']>
  filter?: InputMaybe<AdminUsersPaginatedFilters>
  limit?: InputMaybe<Scalars['Int']>
}

export type AdminVendorInvitationsInput = {
  cursor?: InputMaybe<Scalars['ID']>
  inviteEmail?: InputMaybe<Scalars['String']>
  invitedByUserEmail?: InputMaybe<Scalars['String']>
  limit?: InputMaybe<Scalars['Int']>
  status?: InputMaybe<InvitationStatus>
  storeID?: InputMaybe<Scalars['ID']>
  vendorID?: InputMaybe<Scalars['ID']>
}

export type AdminVendorInvitationsResult = {
  __typename?: 'AdminVendorInvitationsResult'
  cursor?: Maybe<Scalars['ID']>
  hasMore: Scalars['Boolean']
  nodes: Array<VendorInvitation>
  totalCount: Scalars['Int']
}

export type AdminVendorStoreDepartmentAccountsResult = {
  __typename?: 'AdminVendorStoreDepartmentAccountsResult'
  nodes: Array<VendorStoreDepartmentAccount>
}

export type AdminVendorsResult = {
  __typename?: 'AdminVendorsResult'
  nodes: Array<Maybe<Vendor>>
}

export type AllBannersResult = {
  __typename?: 'AllBannersResult'
  cursor: Scalars['String']
  hasMore: Scalars['Boolean']
  nodes: Array<Banner>
  totalCount: Scalars['Int']
}

export type AllOrderGuideProductsInput = {
  productIDs?: InputMaybe<Array<Scalars['ID']>>
}

export type AllOrderGuideProductsResult = {
  __typename?: 'AllOrderGuideProductsResult'
  nodes: Array<VendorProduct>
  totalCount: Scalars['Int']
}

export type AllStoresResult = {
  __typename?: 'AllStoresResult'
  cursor: Scalars['String']
  hasMore: Scalars['Boolean']
  nodes: Array<Store>
  totalCount: Scalars['Int']
}

export type AllVendorsResult = {
  __typename?: 'AllVendorsResult'
  cursor: Scalars['String']
  hasMore: Scalars['Boolean']
  nodes: Array<Vendor>
  totalCount: Scalars['Int']
}

export type ArchivedOrderGuide = {
  __typename?: 'ArchivedOrderGuide'
  added?: Maybe<Array<Scalars['String']>>
  orderGuide?: Maybe<Array<Scalars['String']>>
  removed?: Maybe<Array<Scalars['String']>>
  timestamp: Scalars['String']
  timestampFull?: Maybe<Scalars['Timestamp']>
}

export type ArchivedOrderGuidesResult = {
  __typename?: 'ArchivedOrderGuidesResult'
  nodes: Array<ArchivedOrderGuide>
  totalCount: Scalars['Int']
}

export type Audience = {
  __typename?: 'Audience'
  id: Scalars['ID']
  name: Scalars['String']
  prospectiveStoreAccounts: StoresResult
  storeAccounts: VendorStoreAccountsResult
  vendor: Vendor
}

export type AudiencesResult = {
  __typename?: 'AudiencesResult'
  nodes: Array<Audience>
}

export type AuthorizedVendorsInput = {
  cursor?: InputMaybe<Scalars['String']>
  limit?: InputMaybe<Scalars['Int']>
  query?: InputMaybe<Scalars['String']>
}

export enum BillingType {
  FlatCharge = 'FLAT_CHARGE',
  PercentageCharge = 'PERCENTAGE_CHARGE',
  PerOrderCharge = 'PER_ORDER_CHARGE',
  PerStoreCharge = 'PER_STORE_CHARGE',
}

export type Banner = {
  __typename?: 'Banner'
  acquisitionDetail?: Maybe<Scalars['String']>
  acquisitionSource?: Maybe<AcquisitionSource>
  authorizedVendors: VendorsResult
  bannerType?: Maybe<StoreType>
  billingInfo?: Maybe<BillingInfo>
  discoverableVendors: VendorsResult
  frontOfficeURL?: Maybe<Scalars['String']>
  id: Scalars['ID']
  imageURL?: Maybe<Scalars['String']>
  name?: Maybe<Scalars['String']>
  orders: BannerOrdersResult
  paymentProfile?: Maybe<PaymentProfile>
  referredByCompany?: Maybe<Company>
  serialID?: Maybe<Scalars['ID']>
  status?: Maybe<BannerStatus>
  stores: BannerStoresResult
  /** @deprecated Use vendorStoreDepartmentAccounts instead */
  vendorAccounts: BannerVendorStoreAccountsResult
  /** All vendorProducts for a given Vendor, including store-private products across all of the banner's stores */
  vendorProducts: VendorProductsResult
  /** Returns VendorStoreDepartmentAccounts across all stores. */
  vendorStoreDepartmentAccounts: BannerVendorStoreDepartmentAccountsResult
  /** Returns a deduped list of Vendors across all stores based on all VendorStoreDepartmentAccounts. */
  vendors: BannerVendorsResult
}

export type BannerAuthorizedVendorsArgs = {
  input?: InputMaybe<AuthorizedVendorsInput>
}

export type BannerDiscoverableVendorsArgs = {
  input?: InputMaybe<DiscoverableVendorsInput>
}

export type BannerOrdersArgs = {
  input?: InputMaybe<BannerOrdersInput>
}

export type BannerStoresArgs = {
  input?: InputMaybe<BannerStoresInput>
}

export type BannerVendorAccountsArgs = {
  input?: InputMaybe<BannerVendorStoreAccountInput>
}

export type BannerVendorProductsArgs = {
  input: BannerVendorProductsInput
}

export type BannerVendorStoreDepartmentAccountsArgs = {
  input?: InputMaybe<BannerVendorStoreDepartmentAccountsInput>
}

export type BannerVendorsArgs = {
  input?: InputMaybe<BannerVendorsInput>
}

export type BannerOrderGuideUpdateResult = {
  __typename?: 'BannerOrderGuideUpdateResult'
  bannerStores: Array<Store>
  productsAddedToOrderGuide: Array<VendorProduct>
  users: Array<User>
}

export type BannerOrdersInput = {
  filterByActionRequired?: InputMaybe<Scalars['Boolean']>
  /**
   * Use the buyer's email address or their id, to apply this filter; This is due
   * to the data structure of orders, only saving the buyer's email as an identifier.
   */
  filterByBuyer?: InputMaybe<Scalars['ID']>
  filterByConfirmed?: InputMaybe<Scalars['Boolean']>
  filterBySent?: InputMaybe<Scalars['Boolean']>
  filterByStore?: InputMaybe<Scalars['ID']>
  filterByStoreDepartmentID?: InputMaybe<Scalars['ID']>
  filterByVendor?: InputMaybe<Scalars['ID']>
  limit?: InputMaybe<Scalars['Int']>
  pagination?: InputMaybe<PaginationInput>
  receivingStatus?: InputMaybe<OrderReceivingStatus>
}

export type BannerOrdersInputRoot = {
  bannerID: Scalars['ID']
  filterByActionRequired?: InputMaybe<Scalars['Boolean']>
  /**
   * Use the buyer's email address or their id, to apply this filter; This is due
   * to the data structure of orders, only saving the buyer's email as an identifier.
   */
  filterByBuyer?: InputMaybe<Scalars['ID']>
  filterByConfirmed?: InputMaybe<Scalars['Boolean']>
  filterBySent?: InputMaybe<Scalars['Boolean']>
  filterByStore?: InputMaybe<Scalars['ID']>
  filterByVendor?: InputMaybe<Scalars['ID']>
  limit?: InputMaybe<Scalars['Int']>
  pagination?: InputMaybe<PaginationInput>
}

export type BannerOrdersResult = {
  __typename?: 'BannerOrdersResult'
  cursor?: Maybe<Scalars['ID']>
  hasMore?: Maybe<Scalars['Boolean']>
  nodes: Array<Order>
}

export enum BannerStatus {
  Certified = 'CERTIFIED',
  None = 'NONE',
}

export type BannerStoresInput = {
  limit?: InputMaybe<Scalars['Int']>
  pagination?: InputMaybe<PaginationInput>
  search?: InputMaybe<Scalars['String']>
  sortBy?: InputMaybe<BannerStoresSortingInput>
}

export type BannerStoresResult = {
  __typename?: 'BannerStoresResult'
  cursor?: Maybe<Scalars['ID']>
  hasMore: Scalars['Boolean']
  nodes: Array<Store>
}

export enum BannerStoresSortingField {
  Name = 'NAME',
}

export type BannerStoresSortingInput = {
  direction?: InputMaybe<SortingDirection>
  field: BannerStoresSortingField
}

export type BannerV2OrderGuidesUpdateResult = {
  __typename?: 'BannerV2OrderGuidesUpdateResult'
  nodes: Array<V2OrderGuide>
  updatedVendorStoreDepartmentAccounts: Array<Scalars['String']>
}

export type BannerVendorProductsInput = {
  cursor?: InputMaybe<Scalars['String']>
  filterBySource?: InputMaybe<ProductSourceFilter>
  lastRequestedAt?: InputMaybe<Scalars['Timestamp']>
  limit?: InputMaybe<Scalars['Int']>
  query?: InputMaybe<Scalars['String']>
  vendorID: Scalars['ID']
}

export type BannerVendorStoreAccount = {
  __typename?: 'BannerVendorStoreAccount'
  vendor: Vendor
}

export type BannerVendorStoreAccountInput = {
  query?: InputMaybe<Scalars['String']>
}

export type BannerVendorStoreAccountsResult = {
  __typename?: 'BannerVendorStoreAccountsResult'
  nodes: Array<BannerVendorStoreAccount>
  totalCount: Scalars['Int']
}

export type BannerVendorStoreDepartmentAccountsInput = {
  filterByStatus?: InputMaybe<VendorStoreDepartmentAccountStatus>
  includeInactive?: InputMaybe<Scalars['Boolean']>
  marketEnabledOnly?: InputMaybe<Scalars['Boolean']>
  /** Note: This input will be superseded by any given `searchByVendor` input */
  query?: InputMaybe<Scalars['String']>
  /** Note: This input will supersede any given `query` input */
  searchByVendor?: InputMaybe<Scalars['String']>
}

export type BannerVendorStoreDepartmentAccountsResult = {
  __typename?: 'BannerVendorStoreDepartmentAccountsResult'
  nodes: Array<VendorStoreDepartmentAccount>
  totalCount: Scalars['Int']
}

export type BannerVendorsInput = {
  marketEnabledOnly?: InputMaybe<Scalars['Boolean']>
  query?: InputMaybe<Scalars['String']>
}

export type BannerVendorsResult = {
  __typename?: 'BannerVendorsResult'
  nodes: Array<Vendor>
  totalCount: Scalars['Int']
}

export type BannersResult = {
  __typename?: 'BannersResult'
  nodes: Array<Banner>
}

export type BillingInfo = {
  __typename?: 'BillingInfo'
  billingEmail: Scalars['String']
  billingType: BillingType
  perOrderCharge: Scalars['Currency']
  rate?: Maybe<Scalars['Int']>
  stripeBillingID?: Maybe<Scalars['String']>
}

export type BillingInfoInput = {
  billingEmail: Scalars['String']
  billingType: BillingType
  perOrderCharge: Scalars['Currency']
  rate?: InputMaybe<Scalars['Int']>
  stripeBillingID?: InputMaybe<Scalars['String']>
}

export type BulkAddProductsToV2OrderGuideInput = {
  addOrderGuideProductsInput: Array<AddProductsToV2OrderGuideInput>
}

export type BulkAddProductsToV2OrderGuideResult = {
  __typename?: 'BulkAddProductsToV2OrderGuideResult'
  nodes?: Maybe<Array<AddProductsToV2OrderGuideResult>>
}

export type BulkCopyUserAccount = {
  copyToUserID: Scalars['String']
  storeID: Scalars['String']
}

export type BulkCopyUserOrderGuideInput = {
  accounts: Array<BulkCopyUserAccount>
  productIDs: Array<Scalars['String']>
  vendorID: Scalars['ID']
}

export type BulkCopyV2OrderGuideInput = {
  fromVendorStoreDepartmentAccountIDs: Array<Scalars['ID']>
  toStoreDepartmentIDs: Array<Scalars['ID']>
}

export type BulkCreateOrUpdateVendorStoreDepartmentAccountsResult = {
  __typename?: 'BulkCreateOrUpdateVendorStoreDepartmentAccountsResult'
  createdNodes?: Maybe<Array<VendorStoreDepartmentAccount>>
  errors?: Maybe<Array<BulkCreateVendorStoreDepartmentAccountsErrors>>
  updatedNodes?: Maybe<Array<VendorStoreDepartmentAccount>>
}

export type BulkCreateStoreFields = {
  acquisitionDetail?: InputMaybe<Scalars['String']>
  acquisitionSource?: InputMaybe<AcquisitionSource>
  address?: InputMaybe<Scalars['String']>
  bannerID?: InputMaybe<Scalars['String']>
  bannerStoreID?: InputMaybe<Scalars['String']>
  emails?: InputMaybe<Array<Scalars['String']>>
  geographicCoordinates?: InputMaybe<Scalars['String']>
  name: Scalars['String']
  placeID?: InputMaybe<Scalars['String']>
  referredByCompanyID?: InputMaybe<Scalars['ID']>
  storeType?: InputMaybe<StoreType>
  vendorIDs?: InputMaybe<Array<Scalars['String']>>
}

export type BulkCreateStoresInput = {
  storesInput: Array<BulkCreateStoreFields>
}

export type BulkCreateStoresResult = {
  __typename?: 'BulkCreateStoresResult'
  nodes?: Maybe<Array<Store>>
}

export type BulkCreateTaskInput = {
  payloadJsons: Array<Scalars['String']>
  taskName: Scalars['String']
}

export type BulkCreateVendorInvitationInput = {
  invitedByStoreID: Scalars['ID']
  invitedByUserID: Scalars['ID']
  uploadList: Array<SendBulkVendorInvitationInput>
}

export type BulkCreateVendorStoreDepartmentAccountsErrors = {
  __typename?: 'BulkCreateVendorStoreDepartmentAccountsErrors'
  errors?: Maybe<Array<Scalars['String']>>
  storeDepartmentID: Scalars['String']
  vendorID: Scalars['String']
}

export type BulkCreateVendorStoreDepartmentAccountsResult = {
  __typename?: 'BulkCreateVendorStoreDepartmentAccountsResult'
  errors?: Maybe<Array<BulkCreateVendorStoreDepartmentAccountsErrors>>
  nodes?: Maybe<Array<VendorStoreDepartmentAccount>>
}

export type BulkGetOrderStoreCountByVendorIDsResult = {
  __typename?: 'BulkGetOrderStoreCountByVendorIDsResult'
  nodes: Array<BulkGetOrderStoreCountResult>
}

export type BulkGetOrderStoreCountResult = {
  __typename?: 'BulkGetOrderStoreCountResult'
  numOfOrders: Scalars['Int']
  numOfStores: Scalars['Int']
  vendorID: Scalars['ID']
}

export type BulkGetVsdAsOrderGuidesInput = {
  vendorStoreDepartmentAccountIDs: Array<Scalars['ID']>
}

export type BulkParseCsvOrderGuidesInput = {
  vendors: Array<ParseCsvOrderGuideInput>
}

export type BulkParsedOrderGuidesResult = {
  __typename?: 'BulkParsedOrderGuidesResult'
  nodes: Array<ParsedOrderGuideResult>
}

export type BulkStoreVendorProductInput = {
  active?: InputMaybe<Scalars['Boolean']>
  ageRestriction?: InputMaybe<Scalars['Int']>
  barcode: Scalars['String']
  brandName?: InputMaybe<Scalars['String']>
  category?: InputMaybe<Scalars['String']>
  departmentName: Scalars['String']
  ebtEnabled?: InputMaybe<Scalars['Boolean']>
  ecommEnabled?: InputMaybe<Scalars['Boolean']>
  eslEnabled?: InputMaybe<Scalars['Boolean']>
  existingProductID?: InputMaybe<Scalars['ID']>
  name: Scalars['String']
  primaryVendorCost?: InputMaybe<Scalars['Float']>
  primaryVendorItemCode?: InputMaybe<Scalars['String']>
  primaryVendorName?: InputMaybe<Scalars['String']>
  printPhysicalTag?: InputMaybe<Scalars['Boolean']>
  promptForQuantity?: InputMaybe<Scalars['Boolean']>
  receiptDescription?: InputMaybe<Scalars['String']>
  retailPrice?: InputMaybe<Scalars['Float']>
  snapEnabled?: InputMaybe<Scalars['Boolean']>
  soldByWeight?: InputMaybe<Scalars['Boolean']>
  targetMargin?: InputMaybe<Scalars['Float']>
  taxRateID?: InputMaybe<Scalars['Int']>
  taxRateID2?: InputMaybe<Scalars['Int']>
  taxRateID3?: InputMaybe<Scalars['Int']>
  unitOfMeasure?: InputMaybe<Scalars['String']>
  unitOfMeasureAmount?: InputMaybe<Scalars['Float']>
  unitVolume?: InputMaybe<Scalars['String']>
  wicEnabled?: InputMaybe<Scalars['Boolean']>
}

export type BulkSuggestStoresInput = {
  stores: Array<BulkSuggestStoresInputStore>
  vendorID: Scalars['ID']
}

export type BulkSuggestStoresInputStore = {
  address?: InputMaybe<Scalars['String']>
  name?: InputMaybe<Scalars['String']>
  placeID?: InputMaybe<Scalars['String']>
}

export type BulkSuggestStoresResult = {
  __typename?: 'BulkSuggestStoresResult'
  suggestions: Array<SuggestStoresResult>
}

export type BulkUpdateStoreDepartmentsInput = {
  deactivatedAt?: InputMaybe<Scalars['DateTime']>
  excludeFromSalesReporting?: InputMaybe<Scalars['Boolean']>
  imageURL?: InputMaybe<Scalars['String']>
  imageURLFile?: InputMaybe<Scalars['Upload']>
  name?: InputMaybe<Scalars['String']>
  parentDepartmentID?: InputMaybe<Scalars['ID']>
  storeDepartmentIDs: Array<Scalars['ID']>
}

export type BulkUpdateUserAccountListInput = {
  overwriteExisting?: InputMaybe<Scalars['Boolean']>
  storesInput: Array<BulkUpdateUserAccountStoresInput>
  userID: Scalars['ID']
  vendorIDs?: InputMaybe<Array<Scalars['ID']>>
}

export type BulkUpdateUserAccountListResult = {
  __typename?: 'BulkUpdateUserAccountListResult'
  nodes?: Maybe<Array<User>>
}

export type BulkUpdateUserAccountStoresInput = {
  accountNumber?: InputMaybe<Scalars['String']>
  address: Scalars['String']
  departmentName?: InputMaybe<DepartmentName>
  dunsNumber?: InputMaybe<Scalars['String']>
  name: Scalars['String']
}

export type BulkUpdateUserOrderGuideInput = {
  accounts: Array<UpdateUserOrderGuideAccountInput>
}

export type BulkUpdateUserOrderGuideResult = {
  __typename?: 'BulkUpdateUserOrderGuideResult'
  nodes: Array<OrderGuide>
}

export type BulkUpdateV2OrderGuidesInput = {
  updateOrderGuideProductsInput: Array<UpdateV2OrderGuideInput>
}

export type BulkUpdateV2OrderGuidesResult = {
  __typename?: 'BulkUpdateV2OrderGuidesResult'
  nodes?: Maybe<Array<V2OrderGuide>>
}

export type BulkUpdateVendorProductsInput = {
  vendorProducts: Array<UpdateVendorProductInput>
}

export type BulkUpdateVendorProductsResult = {
  __typename?: 'BulkUpdateVendorProductsResult'
  nodes: Array<VendorProduct>
}

export type BulkUploadMultiVendorProductsInput = {
  catalogSource?: InputMaybe<VendorProductCatalogSource>
  inputProducts: Array<BulkVendorProductInput>
  isBannerUpload: Scalars['Boolean']
  overwrite: Scalars['Boolean']
  privateLabelUpload?: InputMaybe<Scalars['Boolean']>
  retailAccountID?: InputMaybe<Scalars['ID']>
}

export type BulkUploadSingleVendorProductsInput = {
  catalogSource?: InputMaybe<VendorProductCatalogSource>
  discontinueMissingProducts?: InputMaybe<Scalars['Boolean']>
  inputProducts: Array<BulkVendorProductInput>
  isBannerUpload: Scalars['Boolean']
  overwrite: Scalars['Boolean']
  privateLabelUpload?: InputMaybe<Scalars['Boolean']>
  retailAccountID?: InputMaybe<Scalars['ID']>
  vendorID: Scalars['ID']
}

export type BulkUploadStoreVendorProductsInput = {
  bannerSQLID: Scalars['ID']
  inputProducts: Array<BulkStoreVendorProductInput>
  overwrite: Scalars['Boolean']
  storeSQLIDs?: InputMaybe<Array<Scalars['ID']>>
}

export type BulkUploadStoreVendorProductsResult = {
  __typename?: 'BulkUploadStoreVendorProductsResult'
  bannerSQLID: Scalars['ID']
  errors: Array<UploadError>
  id: Scalars['ID']
  newBannerAplSize: Scalars['Int']
  numStoreProductsCreated: Scalars['Int']
  numStoreProductsOverwritten: Scalars['Int']
  spreadsheetURL: Scalars['String']
  storeSQLIDs: Array<Scalars['String']>
}

export type BulkUploadVendorProductsResult = {
  __typename?: 'BulkUploadVendorProductsResult'
  catalogSize: Scalars['Int']
  errors: Array<UploadError>
  id: Scalars['ID']
  numProductsCreated: Scalars['Int']
  numProductsOverwritten: Scalars['Int']
  spreadsheetURL: Scalars['String']
  uploadedProducts: Array<VendorProduct>
  vendor: Vendor
}

export type BulkVendorInventationResult = {
  __typename?: 'BulkVendorInventationResult'
  hasExistingUser: Scalars['Boolean']
  invitation: VendorInvitation
}

export type BulkVendorInvitationError = {
  __typename?: 'BulkVendorInvitationError'
  email: Scalars['String']
  message: Scalars['String']
}

export type BulkVendorInvitationsResult = {
  __typename?: 'BulkVendorInvitationsResult'
  errors?: Maybe<Array<BulkVendorInvitationError>>
  nodes: Array<BulkVendorInventationResult>
}

export type BulkVendorProductInput = {
  brandName?: InputMaybe<Scalars['String']>
  caseCRV?: InputMaybe<Scalars['Currency']>
  casePrice?: InputMaybe<Scalars['Currency']>
  caseSize?: InputMaybe<Scalars['Float']>
  caseUPC?: InputMaybe<Scalars['String']>
  category?: InputMaybe<Scalars['String']>
  departmentName?: InputMaybe<Scalars['String']>
  description: Scalars['String']
  imgURL?: InputMaybe<Scalars['String']>
  inventory?: InputMaybe<Scalars['Int']>
  itemCode: Scalars['String']
  notes?: InputMaybe<Scalars['String']>
  packUPC?: InputMaybe<Scalars['String']>
  sizing?: InputMaybe<Scalars['String']>
  status?: InputMaybe<VendorProductStatus>
  unitCRV?: InputMaybe<Scalars['Currency']>
  unitPrice?: InputMaybe<Scalars['Currency']>
  unitUPC?: InputMaybe<Scalars['String']>
  unitVolume?: InputMaybe<Scalars['String']>
  vendorID?: InputMaybe<Scalars['ID']>
}

export type BuyXGetYFreeDeal = Deal & {
  __typename?: 'BuyXGetYFreeDeal'
  displayName: Scalars['String']
  freeCount: Scalars['Int']
  id: Scalars['ID']
  promotion: Promotion
  threshold: Scalars['Int']
  type: DealType
  unitOfMeasure: UnitOfMeasure
  vendorDiscountCode?: Maybe<Scalars['String']>
  vendorProducts: DealVendorProductsResult
  vendorProductsByBrand?: Maybe<VendorProductsByBrandResult>
}

export type BuyXGetYFreeDealVendorProductsArgs = {
  input?: InputMaybe<VendorProductsInput>
}

export type BuyXGetYFreeDealVendorProductsByBrandArgs = {
  input?: InputMaybe<DealVendorProductsByBrandInput>
}

export type BuyerUsersInput = {
  query?: InputMaybe<Scalars['String']>
}

export type BuyerUsersResult = {
  __typename?: 'BuyerUsersResult'
  nodes: Array<User>
  totalCount: Scalars['Int']
}

/**
 * ****************************
 *       CSV Upload Log
 * ****************************
 */
export type CsvUploadLog = {
  __typename?: 'CSVUploadLog'
  additions: Scalars['Int']
  id: Scalars['ID']
  overwrites: Scalars['Int']
  progress: Scalars['Int']
  restoredBy?: Maybe<User>
  restoredOn?: Maybe<Scalars['Timestamp']>
  retailAccounts: Array<RetailCompany>
  rowCount: Scalars['Int']
  spreadsheetURL?: Maybe<Scalars['String']>
  status: CsvUploadLogStatus
  type?: Maybe<CsvUploadLogType>
  uploadedBy?: Maybe<User>
  uploadedOn: Scalars['Timestamp']
  vendors: Array<Vendor>
}

export enum CsvUploadLogStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Idle = 'IDLE',
  InProgress = 'IN_PROGRESS',
}

export enum CsvUploadLogType {
  AuthorizedFile = 'AUTHORIZED_FILE',
  CatalogUpdate = 'CATALOG_UPDATE',
  PrivateLabel = 'PRIVATE_LABEL',
}

export type CartLineItem = {
  __typename?: 'CartLineItem'
  deal?: Maybe<Deal>
  id: Scalars['ID']
  price: Scalars['Currency']
  quantity: Scalars['Int']
  unitOfMeasure: UnitOfMeasure
  vendorProduct: VendorProduct
}

export type CartLineItemInput = {
  quantity: Scalars['Int']
  unitOfMeasure: UnitOfMeasure
  vendorProductID: Scalars['ID']
}

export type CartLineItems = {
  __typename?: 'CartLineItems'
  nodes: Array<CartLineItem>
}

export type CartOrderResult = {
  __typename?: 'CartOrderResult'
  cart: VendorCart
  order: Order
}

export type CartOutOfStockProductsResult = {
  __typename?: 'CartOutOfStockProductsResult'
  nodes: Array<VendorProduct>
}

export type CartReviewItem = {
  /** Message explaining the reason for this alert, eg 'Usually ordered in eaches'. Clients should only use this field as a fallback when structured fields are not available */
  fallbackMessage: Scalars['String']
  lineItem: CartLineItem
  type: CartReviewItemType
}

export enum CartReviewItemType {
  UnusualQuantity = 'UNUSUAL_QUANTITY',
  UnusualUom = 'UNUSUAL_UOM',
}

export type CartReviewItemUnusualQuantity = CartReviewItem & {
  __typename?: 'CartReviewItemUnusualQuantity'
  /** Message explaining the reason for this alert, eg 'Typical order is 12 cases'. Clients should only use this field as a fallback when structured fields are not available */
  fallbackMessage: Scalars['String']
  lineItem: CartLineItem
  suggestedQuantity: LineItemQuantity
  type: CartReviewItemType
}

export type CartReviewItemUnusualUom = CartReviewItem & {
  __typename?: 'CartReviewItemUnusualUOM'
  /** Message explaining the reason for this alert, eg 'Usually ordered in eaches'. Clients should only use this field as a fallback when structured fields are not available */
  fallbackMessage: Scalars['String']
  lineItem: CartLineItem
  suggestedQuantity: LineItemQuantity
  type: CartReviewItemType
}

export type CartReviewItemsResult = {
  __typename?: 'CartReviewItemsResult'
  nodes: Array<CartReviewItem>
}

export type CartSuggestedProductsResult = {
  __typename?: 'CartSuggestedProductsResult'
  nodes: Array<VendorProduct>
}

export type CartUnavailableProductsResult = {
  __typename?: 'CartUnavailableProductsResult'
  nodes: Array<VendorProduct>
}

export type CatalogRequest = {
  __typename?: 'CatalogRequest'
  fromStore: Store
  id: Scalars['ID']
  requestedAt?: Maybe<Scalars['Timestamp']>
  requestedBy: User
  toVendor: Vendor
}

export type CatalogRequestsResult = {
  __typename?: 'CatalogRequestsResult'
  nodes: Array<CatalogRequest>
  totalCount: Scalars['Int']
}

export enum CatalogSortType {
  Brand = 'BRAND',
  Category = 'CATEGORY',
  Description = 'DESCRIPTION',
  ItemCode = 'ITEM_CODE',
}

export enum Client {
  Ios = 'IOS',
  Market = 'MARKET',
}

/**
 * ****************************
 *      Order Mutations
 * ****************************
 */
export enum ClientType {
  Ios = 'IOS',
  Market = 'MARKET',
}

export type Company = Store | Vendor

export type CompanyFtpConfig = {
  __typename?: 'CompanyFTPConfig'
  companyID: Scalars['String']
  companyType: CompanyType
  id: Scalars['String']
  userName: Scalars['String']
}

export type CompanyFtpConfigResult = {
  __typename?: 'CompanyFTPConfigResult'
  nodes: Array<CompanyFtpConfig>
}

export enum CompanyType {
  Banner = 'BANNER',
  Store = 'STORE',
  Vendor = 'VENDOR',
}

export enum CompanyUserType {
  RetailUser = 'RETAIL_USER',
  Unknown = 'UNKNOWN',
  VendorUser = 'VENDOR_USER',
}

export type ConfirmOrderInput = {
  orderID: Scalars['ID']
  removeMisscans?: InputMaybe<Scalars['Boolean']>
  /** A JSON map where keys are misscanVendorProduct ids and values are vendorProduct ids used to resolve the misscan, e.g., `"{ yoInrkQ1Cd2IacpBTywO: '9qMMbKbTHl96bdBAaSlR' }"`. */
  resolvedProducts?: InputMaybe<Scalars['String']>
}

export type CopyAllUserOrderGuideInput = {
  copyFromUserID: Scalars['ID']
  copyToUserIDs: Array<Scalars['ID']>
  storeID: Scalars['ID']
}

export type CopyUserOrderGuideInput = {
  copyFromUserID: Scalars['ID']
  copyToUserIDs: Array<Scalars['ID']>
  storeID: Scalars['ID']
  vendorID: Scalars['ID']
}

export type CopyUserOrderGuideResult = {
  __typename?: 'CopyUserOrderGuideResult'
  updatedUsers: Array<User>
}

export type CopyV2OrderGuideInput = {
  fromVendorStoreDepartmentAccountID: Scalars['ID']
  toStoreDepartmentIDs: Array<Scalars['ID']>
}

export type CopyV2OrderGuideResult = {
  __typename?: 'CopyV2OrderGuideResult'
  vendorStoreDepartmentAccounts: Array<VendorStoreDepartmentAccount>
}

export type CreateAndSubmitOrderFromCartInput = {
  client: Client
  deliveryDate?: InputMaybe<Scalars['Timestamp']>
  idempotencyKey: Scalars['String']
  noteToVendor?: InputMaybe<Scalars['String']>
  placedViaOnePassScan?: InputMaybe<Scalars['Boolean']>
  storeID: Scalars['String']
  vendorID: Scalars['String']
}

export type CreateAudienceInput = {
  name: Scalars['String']
  storeIDs: Array<Scalars['ID']>
  vendorID: Scalars['ID']
}

export type CreateBannerInput = {
  acquisitionDetail?: InputMaybe<Scalars['String']>
  acquisitionSource?: InputMaybe<AcquisitionSource>
  bannerType?: InputMaybe<StoreType>
  billingInfo?: InputMaybe<BillingInfoInput>
  frontOfficeURL?: InputMaybe<Scalars['String']>
  imageURL?: InputMaybe<Scalars['String']>
  imageURLFile?: InputMaybe<Scalars['Upload']>
  name: Scalars['String']
  referredByCompanyID?: InputMaybe<Scalars['ID']>
  status?: InputMaybe<BannerStatus>
  storeIDs?: InputMaybe<Array<Scalars['ID']>>
}

export type CreateBuyerAccountInput = {
  defaultDepartmentName?: InputMaybe<Scalars['String']>
  displayName?: InputMaybe<Scalars['String']>
  email: Scalars['String']
  password: Scalars['String']
  phoneNumber?: InputMaybe<Scalars['String']>
  readOnlyOrderGuides?: InputMaybe<Scalars['Boolean']>
  storeID: Scalars['ID']
}

export type CreateCodatCompanyMutationInput = {
  bannerFirestoreID?: InputMaybe<Scalars['ID']>
  name: Scalars['String']
  storeFirestoreID?: InputMaybe<Scalars['ID']>
}

export type CreateDealInput = {
  basisPoints?: InputMaybe<Scalars['Int']>
  dealValue?: InputMaybe<Scalars['Currency']>
  freeCount?: InputMaybe<Scalars['Int']>
  promotionID: Scalars['ID']
  threshold?: InputMaybe<Scalars['Int']>
  type: DealType
  unitOfMeasure?: InputMaybe<UnitOfMeasure>
  vendorDiscountCode?: InputMaybe<Scalars['String']>
  vendorProductIDs: Array<Scalars['ID']>
}

export type CreateInvoiceForNonVoriOrderMutationInput = {
  idempotencyKey: Scalars['String']
  invoiceBottleDeposit?: InputMaybe<MoneyInput>
  invoiceCases?: InputMaybe<Scalars['Int']>
  invoiceDate: Scalars['DateTime']
  invoiceEaches?: InputMaybe<Scalars['Int']>
  invoiceFreight?: InputMaybe<MoneyInput>
  invoiceNumber: Scalars['String']
  invoicePDFUrl: Scalars['String']
  invoiceTax?: InputMaybe<MoneyInput>
  invoiceTotal: MoneyInput
  storeID: Scalars['ID']
  vendorID: Scalars['ID']
}

export type CreateLineItemCreditRequestMutationInput = {
  amount: MoneyInput
  lineItemID: Scalars['ID']
  notes: Scalars['String']
}

export type CreateMisscanInput = {
  associatedProductID?: InputMaybe<Scalars['String']>
  description?: InputMaybe<Scalars['String']>
  photoURL?: InputMaybe<Scalars['String']>
  storeID: Scalars['ID']
  type: MisscanType
  upc: Scalars['String']
  vendorID: Scalars['ID']
}

export type CreateOrUpdateVendorStoreDepartmentAccountForm = {
  accountNumber?: InputMaybe<Scalars['String']>
  defaultUnitOfMeasure?: InputMaybe<UnitOfMeasure>
  departmentName: Scalars['String']
  dunsNumber?: InputMaybe<Scalars['String']>
  orderDeadline?: InputMaybe<Scalars['String']>
  orderSubmissionMethod?: InputMaybe<SubmissionMethod>
  orderSubmissionUOMLock?: InputMaybe<UomLock>
  status: VendorStoreDepartmentAccountStatus
  storeEmails?: InputMaybe<Array<StoreEmailInput>>
  storeID: Scalars['String']
  vendorEmails?: InputMaybe<Array<VendorEmailInput>>
  vendorID: Scalars['String']
}

export type CreateOrderInput = {
  client: Client
  deliveryDate?: InputMaybe<Scalars['Timestamp']>
  idempotencyKey: Scalars['String']
  misscans?: InputMaybe<Array<OrderMisscanLineItemInput>>
  noteToVendor?: InputMaybe<Scalars['String']>
  orderContents: Array<OrderLineItemInput>
  placedViaOnePassScan?: InputMaybe<Scalars['Boolean']>
  storeID: Scalars['String']
  suggestedCartsModelTimestamp?: InputMaybe<Scalars['String']>
  vendorID: Scalars['String']
}

export type CreateOrderReceivingLineItemInput = {
  brandName?: InputMaybe<Scalars['String']>
  createMispickItem?: InputMaybe<Scalars['Boolean']>
  description?: InputMaybe<Scalars['String']>
  details?: InputMaybe<Scalars['String']>
  idempotencyKey?: InputMaybe<Scalars['String']>
  imageURLs?: InputMaybe<Array<Scalars['String']>>
  issueQuantity?: InputMaybe<Scalars['Int']>
  orderID: Scalars['ID']
  quantity: Scalars['Int']
  status: OrderReceivingLineItemStatus
  unitOfMeasure: UnitOfMeasure
  upc?: InputMaybe<Scalars['String']>
  vendorProductID?: InputMaybe<Scalars['ID']>
}

export type CreatePaymentProfileJwtInput = {
  bannerID?: InputMaybe<Scalars['String']>
  deviceBillingInfo?: InputMaybe<DeviceBillingInfoInput>
  email: Scalars['String']
  name: Scalars['String']
  orderBillingInfo?: InputMaybe<OrderBillingInfoInput>
  setupFee?: InputMaybe<SetupFeeInput>
  storeID?: InputMaybe<Scalars['String']>
  vendorID?: InputMaybe<Scalars['String']>
}

export type CreatePaymentProfileJwtResult = {
  __typename?: 'CreatePaymentProfileJWTResult'
  email: Scalars['String']
  token: Scalars['String']
}

export type CreateProductSampleRequest = {
  status?: InputMaybe<SampleRequestStatus>
  storeID: Scalars['ID']
  vendorID: Scalars['ID']
}

export type CreateProductSampleRequestsInput = {
  requests: Array<CreateProductSampleRequest>
}

export type CreatePromotionInput = {
  allAccounts?: InputMaybe<Scalars['Boolean']>
  audienceID?: InputMaybe<Scalars['ID']>
  endDate?: InputMaybe<Scalars['Timestamp']>
  isPublished: Scalars['Boolean']
  name: Scalars['String']
  startDate?: InputMaybe<Scalars['Timestamp']>
  vendorID: Scalars['ID']
}

export type CreateSftpConnectionInput = {
  SQLBannerID?: InputMaybe<Scalars['String']>
  SQLStoreID?: InputMaybe<Scalars['String']>
  SQLUserID: Scalars['String']
  SQLVendorID?: InputMaybe<Scalars['String']>
  description: Scalars['String']
  direction: Scalars['String']
  path: Scalars['String']
}

export type CreateSftpUserInput = {
  SQLBannerID?: InputMaybe<Scalars['String']>
  SQLStoreID?: InputMaybe<Scalars['String']>
  SQLVendorID?: InputMaybe<Scalars['String']>
  description: Scalars['String']
  homeDir: Scalars['String']
  host: Scalars['String']
  port: Scalars['Float']
  userName: Scalars['String']
}

export type CreateStoreAccountForVendorError = {
  __typename?: 'CreateStoreAccountForVendorError'
  error: CreateStoreAccountForVendorErrorType
  /** In case of DUPLICATE_STORE errors, the ID of the existing store. */
  existingStoreID?: Maybe<Scalars['ID']>
  /** The index of the errored CreateStoreAccountsForVendorAccountInput object */
  inputAccountIndex: Scalars['Int']
  /** Details about the input failure, eg 'Email a@b.com is already in use' */
  message: Scalars['String']
}

export enum CreateStoreAccountForVendorErrorType {
  DuplicateAccountNumber = 'DUPLICATE_ACCOUNT_NUMBER',
  DuplicateStore = 'DUPLICATE_STORE',
  InvalidAddress = 'INVALID_ADDRESS',
  InvalidEmail = 'INVALID_EMAIL',
}

export type CreateStoreAccountsForVendorAccountInput = {
  accountNumber?: InputMaybe<Scalars['String']>
  address?: InputMaybe<Scalars['String']>
  dunsNumber?: InputMaybe<Scalars['String']>
  placeID?: InputMaybe<Scalars['String']>
  storeEmails?: InputMaybe<Array<Scalars['String']>>
  /** Optional storeID, if the store is already known. If not specified, we create a new store from name+address+email+placeID, (assuming the store input passes dupe checks). */
  storeID?: InputMaybe<Scalars['ID']>
  storeName?: InputMaybe<Scalars['String']>
}

export type CreateStoreAccountsForVendorInput = {
  accounts: Array<CreateStoreAccountsForVendorAccountInput>
  skipDuplicateCheck?: InputMaybe<Scalars['Boolean']>
  /**
   * If true, does not create any stores or accounts, and only validates the input.
   * If true, the `accounts` field in the response contains existing accounts.
   */
  validateOnly?: InputMaybe<Scalars['Boolean']>
  vendorID: Scalars['ID']
}

export type CreateStoreAccountsForVendorResult = {
  __typename?: 'CreateStoreAccountsForVendorResult'
  accounts: Array<VendorStoreDepartmentAccount>
  errors: Array<CreateStoreAccountForVendorError>
}

/**
 * ****************************
 *       StoreDepartment
 * ****************************
 */
export type CreateStoreDepartmentInput = {
  departmentName: Scalars['String']
  email?: InputMaybe<Scalars['String']>
  storeID: Scalars['ID']
}

export type CreateStoreDepartmentsInput = {
  bannerID: Scalars['String']
  excludeFromSalesReporting?: InputMaybe<Scalars['Boolean']>
  imageURL?: InputMaybe<Scalars['String']>
  imageURLFile?: InputMaybe<Scalars['Upload']>
  name: Scalars['String']
  parentDepartmentID?: InputMaybe<Scalars['ID']>
  storeIDs?: InputMaybe<Array<Scalars['ID']>>
}

export type CreateStoreInput = {
  acquisitionDetail?: InputMaybe<Scalars['String']>
  acquisitionSource?: InputMaybe<AcquisitionSource>
  address?: InputMaybe<Scalars['String']>
  bannerID?: InputMaybe<Scalars['String']>
  bannerStoreID?: InputMaybe<Scalars['String']>
  emails?: InputMaybe<Array<Scalars['String']>>
  geographicCoordinates?: InputMaybe<Scalars['String']>
  name?: InputMaybe<Scalars['String']>
  placeID?: InputMaybe<Scalars['String']>
  referredByCompanyID?: InputMaybe<Scalars['ID']>
  storeType?: InputMaybe<StoreType>
  vendorIDs?: InputMaybe<Array<Scalars['String']>>
}

export type CreateStoreProductFields = {
  active?: InputMaybe<Scalars['Boolean']>
  additionalBarcodes?: InputMaybe<Array<Scalars['String']>>
  alcoholByVolume?: InputMaybe<Scalars['Float']>
  barcode: Scalars['String']
  brand?: InputMaybe<Scalars['String']>
  caseSize?: InputMaybe<Scalars['Float']>
  countryOfOrigin?: InputMaybe<Scalars['String']>
  ebtEnabled?: InputMaybe<Scalars['Boolean']>
  ecommerceEnabled?: InputMaybe<Scalars['Boolean']>
  eslEnabled?: InputMaybe<Scalars['Boolean']>
  isTippable?: InputMaybe<Scalars['Boolean']>
  itemModifierIDs?: InputMaybe<Array<Scalars['String']>>
  longDescription?: InputMaybe<Scalars['String']>
  loyaltyPoints?: InputMaybe<Scalars['Decimal']>
  manualItem?: InputMaybe<Scalars['Boolean']>
  minCustomerAge?: InputMaybe<Scalars['Int']>
  name: Scalars['String']
  packSize?: InputMaybe<Scalars['Float']>
  price?: InputMaybe<Scalars['Decimal']>
  priceInputMethod?: InputMaybe<StoreProductPriceInputMethod>
  priceSource?: InputMaybe<StoreProductPriceSource>
  priceSourcePlatform?: InputMaybe<StoreProductPriceSourcePlatform>
  printPhysicalTag?: InputMaybe<Scalars['Boolean']>
  promptForQuantity?: InputMaybe<Scalars['Boolean']>
  receiptDescription?: InputMaybe<Scalars['String']>
  retailPriceUnitOfMeasureID?: InputMaybe<Scalars['String']>
  snapEnabled?: InputMaybe<Scalars['Boolean']>
  soldByWeight?: InputMaybe<Scalars['Boolean']>
  storeDepartmentID?: InputMaybe<Scalars['String']>
  syncToDeliScales?: Scalars['Boolean']
  targetMargin?: InputMaybe<Scalars['Float']>
  taxRateIDs?: InputMaybe<Array<Scalars['String']>>
  unitOfMeasure?: InputMaybe<Scalars['String']>
  unitOfMeasureAmount?: InputMaybe<Scalars['Decimal']>
  upc?: InputMaybe<Scalars['String']>
  variableSalePrice?: InputMaybe<Scalars['Boolean']>
  variableWeightIDs?: InputMaybe<Array<Scalars['String']>>
  wicEnabled?: InputMaybe<Scalars['Boolean']>
}

export type CreateStoreProductsInput = {
  data: CreateStoreProductFields
  storeDepartmentIDs: Array<Scalars['ID']>
}

export type CreateStoreReceiverInput = {
  storeID: Scalars['ID']
  userID: Scalars['ID']
}

export type CreateTaskInput = {
  payloadJson: Scalars['String']
  taskName: Scalars['String']
}

export type CreateUserInput = {
  companyID?: InputMaybe<Scalars['String']>
  defaultDepartmentName?: InputMaybe<Scalars['String']>
  displayName?: InputMaybe<Scalars['String']>
  email: Scalars['String']
  password: Scalars['String']
  phoneNumber?: InputMaybe<Scalars['String']>
  readOnlyOrderGuides?: InputMaybe<Scalars['Boolean']>
  userType: UserType
}

export type CreateUserStoreDepartmentInput = {
  storeDepartmentID: Scalars['ID']
  userID: Scalars['ID']
}

export type CreateVendorInput = {
  acquisitionDetail?: InputMaybe<Scalars['String']>
  acquisitionSource?: InputMaybe<AcquisitionSource>
  address?: InputMaybe<Scalars['String']>
  billingInfo?: InputMaybe<BillingInfoInput>
  defaultOrderSubmissionMethod?: InputMaybe<SubmissionMethod>
  departmentTags?: InputMaybe<Array<DepartmentName>>
  description?: InputMaybe<Scalars['String']>
  disableDiscontinuedPurchases?: InputMaybe<Scalars['Boolean']>
  disableOutOfStockPurchases?: InputMaybe<Scalars['Boolean']>
  distributionCenterID?: InputMaybe<Scalars['String']>
  email?: InputMaybe<Scalars['String']>
  headerImageURL?: InputMaybe<Scalars['String']>
  headerImageURLFile?: InputMaybe<Scalars['Upload']>
  hideWholesalePricing?: InputMaybe<Scalars['Boolean']>
  imgURL?: InputMaybe<Scalars['String']>
  imgURLFile?: InputMaybe<Scalars['Upload']>
  isInventoryEnabled?: InputMaybe<Scalars['Boolean']>
  lockUOMSelection?: InputMaybe<UomLock>
  misscanPolicy?: InputMaybe<VendorMisscanPolicy>
  name: Scalars['String']
  orderDeadline?: InputMaybe<Scalars['String']>
  orderMin?: InputMaybe<Scalars['Currency']>
  orderMinimums?: InputMaybe<Array<VendorOrderMinimumInput>>
  orderSubmissionUOMLock?: InputMaybe<UomLock>
  referredByCompanyID?: InputMaybe<Scalars['ID']>
  retailerPricing?: InputMaybe<Scalars['Boolean']>
  showImages?: InputMaybe<Scalars['Boolean']>
  skipEmailWithEDIOrderSubmission?: InputMaybe<Scalars['Boolean']>
  spsTenetID?: InputMaybe<Scalars['String']>
  status?: InputMaybe<VendorStatus>
  trueCommerceTenetID?: InputMaybe<Scalars['String']>
  useAccountMetadataEmailOverVendorEmail?: InputMaybe<Scalars['Boolean']>
  vendorManagedCatalog?: InputMaybe<Scalars['Boolean']>
}

/**
 * ****************************
 *      Product Mutations
 * ****************************
 */
export type CreateVendorProductInput = {
  accountSpecificCasePrice?: InputMaybe<Array<AccountSpecificPriceInput>>
  accountSpecificUnitPrice?: InputMaybe<Array<AccountSpecificPriceInput>>
  brand?: InputMaybe<Scalars['String']>
  caseCRV?: InputMaybe<Scalars['Currency']>
  casePrice?: InputMaybe<Scalars['Currency']>
  caseSize?: InputMaybe<Scalars['Float']>
  caseUPC?: InputMaybe<Scalars['String']>
  category?: InputMaybe<Scalars['String']>
  crvCost?: InputMaybe<Scalars['Currency']>
  departmentName?: InputMaybe<Scalars['String']>
  description: Scalars['String']
  erpID?: InputMaybe<Scalars['String']>
  imgURL?: InputMaybe<Scalars['String']>
  imgURLFile?: InputMaybe<Scalars['Upload']>
  inventory?: InputMaybe<Scalars['Int']>
  isDeleted?: InputMaybe<Scalars['Boolean']>
  isDiscontinued?: InputMaybe<Scalars['Boolean']>
  isStoreSpecific?: InputMaybe<Scalars['Boolean']>
  itemCode: Scalars['String']
  missScanMethod?: InputMaybe<MissScanMethod>
  notes?: InputMaybe<Scalars['String']>
  packUPC?: InputMaybe<Scalars['String']>
  privateLabelProductBannerIDs?: InputMaybe<Array<Scalars['ID']>>
  privateLabelProductStoreIDs?: InputMaybe<Array<Scalars['ID']>>
  sizing?: InputMaybe<Scalars['String']>
  srp?: InputMaybe<Scalars['String']>
  status?: InputMaybe<VendorProductStatus>
  storeID?: InputMaybe<Scalars['String']>
  unitCRV?: InputMaybe<Scalars['Currency']>
  unitPrice?: InputMaybe<Scalars['Currency']>
  unitUPC?: InputMaybe<Scalars['String']>
  unitVolume?: InputMaybe<Scalars['String']>
  upc?: InputMaybe<Scalars['String']>
  vendorID: Scalars['String']
  wholesaleCasePrice?: InputMaybe<Scalars['Currency']>
  wholesaleUnitPrice?: InputMaybe<Scalars['Currency']>
}

export type CreateVendorStoreDepartmentAccountForm = {
  accountNumber?: InputMaybe<Scalars['String']>
  defaultUnitOfMeasure?: InputMaybe<UnitOfMeasure>
  dunsNumber?: InputMaybe<Scalars['String']>
  orderDeadline?: InputMaybe<Scalars['String']>
  orderSubmissionMethod?: InputMaybe<SubmissionMethod>
  orderSubmissionUOMLock?: InputMaybe<UomLock>
  storeDepartmentID: Scalars['String']
  storeEmails?: InputMaybe<Array<StoreEmailInput>>
  vendorEmails?: InputMaybe<Array<VendorEmailInput>>
  vendorID: Scalars['String']
}

export type CreditRequest = {
  __typename?: 'CreditRequest'
  amount: Money
  createdAt: Scalars['DateTime']
  createdBy: Scalars['String']
  id: Scalars['ID']
  note: Scalars['String']
  quantity: Scalars['Int']
  unitOfMeasure: UnitOfMeasure
  userName?: Maybe<Scalars['String']>
  userType?: Maybe<Scalars['String']>
}

export enum CurrencyFormat {
  Short = 'SHORT',
}

export type CustomerInviteResult = {
  __typename?: 'CustomerInviteResult'
  errors: Array<InviteResult>
  existingUsers: Array<InviteResult>
  numInvalidStores: Scalars['Int']
  numStoresCreated: Scalars['Int']
  numStoresInvited: Scalars['Int']
  numStoresUpdated: Scalars['Int']
  storesStatus: Array<InviteResult>
}

export type DateRangeBetweenFilter = {
  endDate?: InputMaybe<Scalars['Timestamp']>
  startDate: Scalars['Timestamp']
}

export enum DayOfWeek {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY',
}

export type Deal = {
  displayName: Scalars['String']
  id: Scalars['ID']
  promotion: Promotion
  type: DealType
  vendorDiscountCode?: Maybe<Scalars['String']>
  vendorProducts: DealVendorProductsResult
  vendorProductsByBrand?: Maybe<VendorProductsByBrandResult>
}

export type DealVendorProductsArgs = {
  input?: InputMaybe<VendorProductsInput>
}

export type DealVendorProductsByBrandArgs = {
  input?: InputMaybe<DealVendorProductsByBrandInput>
}

export enum DealType {
  BuyXGetYFree = 'BUY_X_GET_Y_FREE',
  Discount = 'DISCOUNT',
  Fixed = 'FIXED',
}

export type DealVendorProductsByBrandInput = {
  brandName?: InputMaybe<Scalars['String']>
  limit?: InputMaybe<Scalars['Int']>
}

export type DealVendorProductsResult = {
  __typename?: 'DealVendorProductsResult'
  nodes: Array<VendorProduct>
  totalCount: Scalars['Int']
}

export type DealsResults = {
  __typename?: 'DealsResults'
  nodes: Array<Deal>
}

export type DeleteBannerInput = {
  bannerID: Scalars['ID']
}

export type DeleteBannerResult = {
  __typename?: 'DeleteBannerResult'
  deletedBannerID: Scalars['ID']
}

export type DeleteDealInput = {
  id: Scalars['ID']
}

export type DeleteDealResult = {
  __typename?: 'DeleteDealResult'
  deletedDealID: Scalars['ID']
  updatedPromotion?: Maybe<Promotion>
}

export type DeleteMisscansInput = {
  productIDs: Array<Scalars['ID']>
  storeID: Scalars['ID']
  vendorID?: InputMaybe<Scalars['ID']>
}

export type DeleteMisscansResult = {
  __typename?: 'DeleteMisscansResult'
  deletedProductIDs: Array<Scalars['ID']>
}

export type DeletePromotionInput = {
  id: Scalars['ID']
}

export type DeletePromotionResult = {
  __typename?: 'DeletePromotionResult'
  deletedDealIDs: Array<Scalars['ID']>
  deletedPromotionID?: Maybe<Scalars['ID']>
}

export type DeleteStoreInput = {
  storeID: Scalars['ID']
}

export type DeleteStoreResult = {
  __typename?: 'DeleteStoreResult'
  storeID: Scalars['ID']
}

export type DeleteUserInput = {
  id: Scalars['ID']
}

export type DeleteUserResult = {
  __typename?: 'DeleteUserResult'
  deletedUserID: Scalars['ID']
}

export type DeleteUserStoreDepartmentInput = {
  userStoreDepartmentID: Scalars['ID']
}

export type DeleteVendorProductInput = {
  productID: Scalars['ID']
  storeID?: InputMaybe<Scalars['ID']>
  vendorID?: InputMaybe<Scalars['ID']>
}

export type DeleteVendorProductResult = {
  __typename?: 'DeleteVendorProductResult'
  deletedProductID: Scalars['ID']
}

export type DeletedVendorProductsInput = {
  deletedAfter?: InputMaybe<Scalars['Timestamp']>
  vendorID?: InputMaybe<Scalars['ID']>
}

export type Department = {
  __typename?: 'Department'
  email?: Maybe<Scalars['String']>
  id: Scalars['ID']
  name?: Maybe<Scalars['String']>
  store: Store
}

export enum DepartmentName {
  Asian = 'ASIAN',
  Bakery = 'BAKERY',
  Beer = 'BEER',
  Beverage = 'BEVERAGE',
  Bulk = 'BULK',
  Cafe = 'CAFE',
  Cheese = 'CHEESE',
  Confectionary = 'CONFECTIONARY',
  Dairy = 'DAIRY',
  Deli = 'DELI',
  Default = 'Default',
  Floral = 'FLORAL',
  FoodService = 'FOOD_SERVICE',
  FrontEnd = 'FRONT_END',
  Frozen = 'FROZEN',
  Grocery = 'GROCERY',
  Haba = 'HABA',
  HomeGoods = 'HOME_GOODS',
  Maintenance = 'MAINTENANCE',
  Meat = 'MEAT',
  NaturalGrocery = 'NATURAL_GROCERY',
  PetStore = 'PET_STORE',
  Produce = 'PRODUCE',
  Retail = 'RETAIL',
  Seafood = 'SEAFOOD',
  SpecialtyGrocery = 'SPECIALTY_GROCERY',
  Wine = 'WINE',
}

export type DepartmentsResult = {
  __typename?: 'DepartmentsResult'
  nodes: Array<Department>
}

export type DeviceBillingInfoInput = {
  bundles: Array<DeviceBundleInput>
}

export type DeviceBundleInput = {
  cost: Scalars['Currency']
  deviceBundleID: Scalars['String']
}

export type DiscoverableVendorsInput = {
  cursor?: InputMaybe<Scalars['String']>
  limit?: InputMaybe<Scalars['Int']>
  query?: InputMaybe<Scalars['String']>
}

export type EslConfigInput = {
  storeID: Scalars['String']
}

export enum EslType {
  Danavation = 'DANAVATION',
  Ses = 'SES',
}

export type EdiPartner = {
  __typename?: 'EdiPartner'
  ediPartnerName: Scalars['String']
  id: Scalars['Int']
  interchangeNumber: Scalars['Int']
  vendorID: Scalars['ID']
}

export type EditableStoreProductFields = {
  active?: InputMaybe<Scalars['Boolean']>
  additionalBarcodes?: InputMaybe<Array<Scalars['String']>>
  alcoholByVolume?: InputMaybe<Scalars['Float']>
  barcode?: InputMaybe<Scalars['String']>
  brand?: InputMaybe<Scalars['String']>
  caseSize?: InputMaybe<Scalars['Float']>
  countryOfOrigin?: InputMaybe<Scalars['String']>
  ebtEnabled?: InputMaybe<Scalars['Boolean']>
  ecommerceEnabled?: InputMaybe<Scalars['Boolean']>
  eslEnabled?: InputMaybe<Scalars['Boolean']>
  isTippable?: InputMaybe<Scalars['Boolean']>
  itemModifierIDs?: InputMaybe<Array<Scalars['String']>>
  longDescription?: InputMaybe<Scalars['String']>
  loyaltyPoints?: InputMaybe<Scalars['Decimal']>
  manualItem?: InputMaybe<Scalars['Boolean']>
  minCustomerAge?: InputMaybe<Scalars['Int']>
  name?: InputMaybe<Scalars['String']>
  packSize?: InputMaybe<Scalars['Float']>
  price?: InputMaybe<Scalars['Decimal']>
  priceInputMethod?: InputMaybe<StoreProductPriceInputMethod>
  priceSource?: InputMaybe<StoreProductPriceSource>
  priceSourcePlatform?: InputMaybe<StoreProductPriceSourcePlatform>
  printPhysicalTag?: InputMaybe<Scalars['Boolean']>
  promptForQuantity?: InputMaybe<Scalars['Boolean']>
  receiptDescription?: InputMaybe<Scalars['String']>
  retailPriceUnitOfMeasureID?: InputMaybe<Scalars['String']>
  snapEnabled?: InputMaybe<Scalars['Boolean']>
  soldByWeight?: InputMaybe<Scalars['Boolean']>
  storeDepartmentID?: InputMaybe<Scalars['String']>
  syncToDeliScales?: Scalars['Boolean']
  targetMargin?: InputMaybe<Scalars['Float']>
  taxRateIDs?: InputMaybe<Array<Scalars['String']>>
  unitOfMeasure?: InputMaybe<Scalars['String']>
  unitOfMeasureAmount?: InputMaybe<Scalars['Decimal']>
  upc?: InputMaybe<Scalars['String']>
  variableSalePrice?: InputMaybe<Scalars['Boolean']>
  variableWeightIDs?: InputMaybe<Array<Scalars['String']>>
  wicEnabled?: InputMaybe<Scalars['Boolean']>
}

export type ExploConfig = {
  __typename?: 'ExploConfig'
  customerToken: Scalars['String']
  eodURL: Scalars['String']
  loyaltyURL: Scalars['String']
  metricsURL: Scalars['String']
  overviewURL: Scalars['String']
  promotionsURL: Scalars['String']
  reportBuilderURL: Scalars['String']
  tillsURL: Scalars['String']
  timezone: Scalars['String']
  transactionsURL: Scalars['String']
}

export enum FtpFileType {
  MovementReport = 'MOVEMENT_REPORT',
  ProductUpdates = 'PRODUCT_UPDATES',
}

export type FeatureFlag = {
  __typename?: 'FeatureFlag'
  /** Whether the flag is on or off by default */
  defaultBehavior: FeatureFlagDefaultBehavior
  description: Scalars['String']
  excludedLaneIDs: Array<Scalars['ID']>
  excludedUserIDs: Array<Scalars['ID']>
  /** Same as name. Exposed for caching only */
  id: Scalars['ID']
  includedLaneIDs: Array<Scalars['ID']>
  includedUserIDs: Array<Scalars['ID']>
  /** Human-readable, unique handle for the feature. Clients can use feature flags by writing conditional code against specific names, which are obtained from User.enabledFeatures at run-time */
  name: Scalars['String']
  /** Pass rules that are executed against a given user in specific order. */
  rules: Array<FeatureFlagRule>
}

export enum FeatureFlagDefaultBehavior {
  ExcludeAll = 'EXCLUDE_ALL',
  IncludeAll = 'INCLUDE_ALL',
}

export type FeatureFlagRule = {
  __typename?: 'FeatureFlagRule'
  /** A list of conditions that are combined via logical AND */
  andConditions: Array<FeatureFlagRuleCondition>
  type: FeatureFlagRuleType
}

export type FeatureFlagRuleCondition = {
  __typename?: 'FeatureFlagRuleCondition'
  companyIDs?: Maybe<Array<Scalars['ID']>>
  companyTypes?: Maybe<Array<FeatureFlagRuleConditionCompanyType>>
  scope: FeatureFlagRuleConditionScope
  userTypes?: Maybe<Array<UserType>>
}

export enum FeatureFlagRuleConditionCompanyType {
  Banner = 'BANNER',
  Store = 'STORE',
  Vendor = 'VENDOR',
}

export type FeatureFlagRuleConditionInput = {
  companyIDs?: InputMaybe<Array<Scalars['ID']>>
  companyTypes?: InputMaybe<Array<FeatureFlagRuleConditionCompanyType>>
  scope: FeatureFlagRuleConditionScope
  userTypes?: InputMaybe<Array<UserType>>
}

export enum FeatureFlagRuleConditionScope {
  Company = 'COMPANY',
  CompanyType = 'COMPANY_TYPE',
  UserType = 'USER_TYPE',
}

export type FeatureFlagRuleInput = {
  andConditions: Array<FeatureFlagRuleConditionInput>
  type: FeatureFlagRuleType
}

export enum FeatureFlagRuleType {
  Exclude = 'EXCLUDE',
  Include = 'INCLUDE',
}

export type FeatureFlagsResult = {
  __typename?: 'FeatureFlagsResult'
  nodes: Array<FeatureFlag>
}

export type File = {
  __typename?: 'File'
  encoding: Scalars['String']
  filename: Scalars['String']
  mimetype: Scalars['String']
}

export type FixMisscanInput = {
  productID: Scalars['String']
  storeID: Scalars['ID']
  upc: Scalars['String']
  vendorID: Scalars['ID']
}

export type FixedDeal = Deal & {
  __typename?: 'FixedDeal'
  dealValue: Scalars['Currency']
  displayName: Scalars['String']
  id: Scalars['ID']
  promotion: Promotion
  type: DealType
  unitOfMeasure: UnitOfMeasure
  vendorDiscountCode?: Maybe<Scalars['String']>
  vendorProducts: DealVendorProductsResult
  vendorProductsByBrand?: Maybe<VendorProductsByBrandResult>
}

export type FixedDealVendorProductsArgs = {
  input?: InputMaybe<VendorProductsInput>
}

export type FixedDealVendorProductsByBrandArgs = {
  input?: InputMaybe<DealVendorProductsByBrandInput>
}

export type GqleslConfig = {
  __typename?: 'GQLESLConfig'
  apiKey?: Maybe<Scalars['String']>
  eslStoreID: Scalars['String']
  storeID: Scalars['String']
  type: Scalars['String']
}

export type GqlLineItemIssueBase = {
  createdBy: Scalars['String']
  creditRequest?: Maybe<CreditRequest>
  id: Scalars['ID']
}

export type GqlLineItemStatusCount = {
  __typename?: 'GQLLineItemStatusCount'
  count: Scalars['Int']
  status: ReconciledLineItemStatus
}

export type GqlMasterCatalogProductMetadata = {
  __typename?: 'GQLMasterCatalogProductMetadata'
  barcode: Scalars['String']
  brandName?: Maybe<Scalars['String']>
  caseSize?: Maybe<Scalars['Float']>
  name: Scalars['String']
  photoURL?: Maybe<Scalars['String']>
  source: Scalars['String']
  timestamp: Scalars['DateTime']
  unitOfMeasure?: Maybe<Scalars['String']>
  unitOfMeasureAmount?: Maybe<Scalars['String']>
  unitVolume?: Maybe<Scalars['String']>
  wholesaleEachCost?: Maybe<Scalars['Float']>
}

export type GqlOrderHistoryEventBase = {
  createdAt: Scalars['DateTime']
  id: Scalars['ID']
  status: OrderReceivingStatus
  userName?: Maybe<Scalars['String']>
  userType?: Maybe<Scalars['String']>
}

export type GqlStoreProduct = {
  __typename?: 'GQLStoreProduct'
  active: Scalars['Boolean']
  additionalBarcodes: Array<Scalars['String']>
  barcode: Scalars['String']
  brand?: Maybe<Scalars['String']>
  caseSize?: Maybe<Scalars['Float']>
  countryOfOrigin?: Maybe<Scalars['String']>
  createdAt: Scalars['DateTime']
  ebtEnabled: Scalars['Boolean']
  ecommerceEnabled: Scalars['Boolean']
  eslEnabled: Scalars['Boolean']
  id: Scalars['String']
  isTippable: Scalars['Boolean']
  itemModifierIDs: Array<Scalars['String']>
  longDescription?: Maybe<Scalars['String']>
  loyaltyPoints?: Maybe<Scalars['Decimal']>
  manualItem: Scalars['Boolean']
  minCustomerAge: Scalars['Int']
  name: Scalars['String']
  packSize?: Maybe<Scalars['Float']>
  price?: Maybe<Scalars['Decimal']>
  priceInputMethod?: Maybe<StoreProductPriceInputMethod>
  priceSource?: Maybe<StoreProductPriceSource>
  priceSourcePlatform?: Maybe<StoreProductPriceSourcePlatform>
  printPhysicalTag: Scalars['Boolean']
  promptForQuantity: Scalars['Boolean']
  receiptDescription?: Maybe<Scalars['String']>
  retailPriceUnitOfMeasureID?: Maybe<Scalars['String']>
  snapEnabled: Scalars['Boolean']
  soldByWeight: Scalars['Boolean']
  storeDepartmentID: Scalars['String']
  storeID: Scalars['String']
  targetMargin?: Maybe<Scalars['Float']>
  taxRates: Array<GqlTaxRate>
  unitOfMeasure?: Maybe<Scalars['String']>
  unitOfMeasureAmount?: Maybe<Scalars['Decimal']>
  upc: Scalars['String']
  updatedAt: Scalars['DateTime']
  variableSalePrice: Scalars['Boolean']
  variableWeightIDs: Array<Scalars['String']>
  wicEnabled: Scalars['Boolean']
}

export type GqlStoreVendor = {
  __typename?: 'GQLStoreVendor'
  accountNumber?: Maybe<Scalars['String']>
  billingAddress?: Maybe<AddressComponents>
  billingName?: Maybe<Scalars['String']>
  contactName?: Maybe<Scalars['String']>
  contactPhone?: Maybe<Scalars['String']>
  deactivatedAt?: Maybe<Scalars['DateTime']>
  id: Scalars['ID']
  invoicesEmail?: Maybe<Scalars['String']>
  minOrderValue?: Maybe<Scalars['Decimal']>
  name: Scalars['String']
  notes?: Maybe<Scalars['String']>
  ordersEmail?: Maybe<Scalars['String']>
  store: Store
  taxID?: Maybe<Scalars['String']>
  vendorCode?: Maybe<Scalars['String']>
  vendorID?: Maybe<Scalars['String']>
}

export type GqlTaxRate = {
  __typename?: 'GQLTaxRate'
  bannerSerialID: Scalars['String']
  createdAt: Scalars['DateTime']
  id: Scalars['ID']
  name: Scalars['String']
  productCount: Scalars['Float']
  status: Scalars['Boolean']
  taxType: TaxType
  type: TaxRateType
  updatedAt: Scalars['DateTime']
  value: Scalars['String']
}

export type GetCsvUploadLogsInput = {
  filterByVendorID?: InputMaybe<Scalars['String']>
  limit?: InputMaybe<Scalars['Int']>
  pagination?: InputMaybe<PaginationInput>
}

export type GetCsvUploadLogsResult = {
  __typename?: 'GetCSVUploadLogsResult'
  cursor?: Maybe<Scalars['ID']>
  hasMore: Scalars['Boolean']
  nodes: Array<CsvUploadLog>
}

export type GetDiscontinuedVendorProductsForRetailCompanyInput = {
  limit?: InputMaybe<Scalars['Int']>
  pagination?: InputMaybe<PaginationInput>
  retailCompanyID: Scalars['ID']
}

export type GetDiscontinuedVendorProductsForRetailCompanyResult = {
  __typename?: 'GetDiscontinuedVendorProductsForRetailCompanyResult'
  cursor?: Maybe<Scalars['ID']>
  hasMore?: Maybe<Scalars['Boolean']>
  nodes: Array<VendorProduct>
  totalCount?: Maybe<Scalars['Int']>
}

export type GetMatchingVendorProductsInput = {
  UPC?: InputMaybe<Scalars['String']>
  itemCode?: InputMaybe<Scalars['String']>
  vendorID: Scalars['ID']
}

export type GetMatchingVendorProductsResult = {
  __typename?: 'GetMatchingVendorProductsResult'
  nodes: Array<MatchingVendorProduct>
  totalCount: Scalars['Int']
}

export type GetNewVendorProductsForRetailCompanyInput = {
  limit?: InputMaybe<Scalars['Int']>
  pagination?: InputMaybe<PaginationInput>
  retailCompanyID: Scalars['ID']
}

export type GetNewVendorProductsForRetailCompanyResult = {
  __typename?: 'GetNewVendorProductsForRetailCompanyResult'
  cursor?: Maybe<Scalars['ID']>
  hasMore?: Maybe<Scalars['Boolean']>
  nodes: Array<VendorProduct>
  totalCount?: Maybe<Scalars['Int']>
}

export type GetStoreDepartmentsInput = {
  bannerID: Scalars['ID']
  filterByStoreID?: InputMaybe<Scalars['ID']>
}

export type GetUserAbandonedCartsInput = {
  endDate: Scalars['Timestamp']
  startDate: Scalars['Timestamp']
  storeID?: InputMaybe<Scalars['ID']>
  userID?: InputMaybe<Scalars['ID']>
}

export type GetUserAbandonedCartsResult = {
  __typename?: 'GetUserAbandonedCartsResult'
  nodes: Array<UserCart>
}

export type GetVendorAbandonedCartsInput = {
  endDate: Scalars['Timestamp']
  startDate: Scalars['Timestamp']
  storeID?: InputMaybe<Scalars['ID']>
  userID?: InputMaybe<Scalars['ID']>
  vendorID?: InputMaybe<Scalars['ID']>
}

export type GetVendorAbandonedCartsResult = {
  __typename?: 'GetVendorAbandonedCartsResult'
  nodes: Array<VendorCart>
}

export type GetVendorProductsInput = {
  filterByBrand?: InputMaybe<Scalars['String']>
  filterByCategory?: InputMaybe<Scalars['String']>
  filterByCustomPricing?: InputMaybe<Scalars['Boolean']>
  filterByPrivateLabel?: InputMaybe<Scalars['Boolean']>
  filterByRetailerIDs?: InputMaybe<Array<Scalars['ID']>>
  filterByStatus?: InputMaybe<Array<VendorProductStatus>>
  limit?: InputMaybe<Scalars['Int']>
  pagination?: InputMaybe<PaginationInput>
  search?: InputMaybe<Scalars['String']>
  /** By default, VendorProducts are sorted by vendorName -> itemCode */
  sortBy?: InputMaybe<VendorProductsSortingInput>
  vendorID?: InputMaybe<Scalars['ID']>
}

export type GetWholesaleProductsQueryInput = {
  lastRequestedAt?: InputMaybe<Scalars['String']>
}

export type InventoryHubOrderQueryFilters = {
  dateRange?: InputMaybe<DateRangeBetweenFilter>
  departmentIDs?: InputMaybe<Array<Scalars['ID']>>
  orderStatus?: InputMaybe<OrderReceivingStatus>
  searchString?: InputMaybe<Scalars['String']>
  storeIDs?: InputMaybe<Array<Scalars['ID']>>
  vendorIDs?: InputMaybe<Array<Scalars['ID']>>
}

export type InventoryHubOrderQueryInput = {
  after?: InputMaybe<Scalars['Cursor']>
  filters: InventoryHubOrderQueryFilters
  first: Scalars['Int']
}

export type InventoryHubOrdersViewConnection = {
  __typename?: 'InventoryHubOrdersViewConnection'
  creditRequestTotal: Money
  edges: Array<OrderEdge>
  invoiceTotal: Money
  orderTotal: Money
  pageInfo: PageInfo
}

export enum InventoryLevelStatus {
  InStock = 'IN_STOCK',
  LowStock = 'LOW_STOCK',
  OutOfStock = 'OUT_OF_STOCK',
  Unknown = 'UNKNOWN',
}

export type InvitationOrderGuide = {
  __typename?: 'InvitationOrderGuide'
  departmentName?: Maybe<Scalars['String']>
  id: Scalars['ID']
  orderGuideName: Scalars['String']
  products: Array<VendorProduct>
  vendor: Vendor
}

export type InvitationOrderGuideInput = {
  departmentName?: InputMaybe<Scalars['String']>
  orderGuideName: Scalars['String']
  productIDs: Array<Scalars['ID']>
  vendorID: Scalars['ID']
}

export enum InvitationStatus {
  Invited = 'INVITED',
  ManuallyInvited = 'MANUALLY_INVITED',
  NotInvited = 'NOT_INVITED',
  SignedUp = 'SIGNED_UP',
}

export type InviteResult = {
  __typename?: 'InviteResult'
  deepLink?: Maybe<Scalars['String']>
  email?: Maybe<Scalars['String']>
  index: Scalars['Int']
  status: InviteStatus
  storeName: Scalars['String']
}

export enum InviteStatus {
  DuplicateStore = 'DUPLICATE_STORE',
  ExistingUser = 'EXISTING_USER',
  Failed = 'FAILED',
  InvalidAccountNum = 'INVALID_ACCOUNT_NUM',
  InvalidAddress = 'INVALID_ADDRESS',
  InvalidEmail = 'INVALID_EMAIL',
  InvalidStoreName = 'INVALID_STORE_NAME',
  InviteSent = 'INVITE_SENT',
  ManualInvite = 'MANUAL_INVITE',
  StoreCreated = 'STORE_CREATED',
  StoreUpdated = 'STORE_UPDATED',
}

export type InviteStoreAccountInput = {
  emailToInvite: Scalars['String']
  storeID: Scalars['ID']
}

export type InviteStoreAccountsInput = {
  accounts: Array<InviteStoreAccountInput>
  vendorID: Scalars['ID']
}

export type InviteStoreAccountsResult = {
  __typename?: 'InviteStoreAccountsResult'
  accounts: Array<VendorStoreAccount>
}

export type Invoice = {
  __typename?: 'Invoice'
  accountingFilePath?: Maybe<Scalars['String']>
  accountingMappingComplete: Scalars['Boolean']
  accountingPlatformSyncStatus?: Maybe<AccountingPlatformInvoiceSyncStatus>
  accountingPlatformSyncedAt?: Maybe<Scalars['Timestamp']>
  billTo: AddressComponents
  billingDate: Scalars['DateTime']
  bottleDeposit?: Maybe<Money>
  caseCount?: Maybe<Scalars['Int']>
  creditRequestedTotal: Money
  dueDate: Scalars['DateTime']
  eachCount?: Maybe<Scalars['Int']>
  freight?: Maybe<Money>
  id: Scalars['ID']
  imageURL: Scalars['String']
  invoiceNumber?: Maybe<Scalars['String']>
  lineItems: Array<InvoiceLineItem>
  orderID: Scalars['ID']
  paymentMethod: InvoicePaymentMethod
  receivedAt?: Maybe<Scalars['DateTime']>
  receivedBy?: Maybe<Scalars['String']>
  receivedByName?: Maybe<Scalars['String']>
  receivingLineItems: Array<OrderReceivingLineItem>
  receivingReportID?: Maybe<Scalars['String']>
  remainingItemsReceived?: Maybe<Scalars['Boolean']>
  shipTo: AddressComponents
  status: InvoiceStatus
  tax?: Maybe<Money>
  term: Scalars['String']
  total: Money
}

export type InvoiceReceivingLineItemsArgs = {
  status?: InputMaybe<Array<OrderReceivingLineItemStatus>>
}

export type InvoiceLineItem = {
  __typename?: 'InvoiceLineItem'
  brandName?: Maybe<Scalars['String']>
  description: Scalars['String']
  id: Scalars['ID']
  invoiceID: Scalars['ID']
  itemCode?: Maybe<Scalars['String']>
  numberDelivered?: Maybe<Scalars['Float']>
  numberOrdered?: Maybe<Scalars['Float']>
  quantity: Scalars['Int']
  unitOfMeasure: ReceivingUnitOfMeasure
  upc?: Maybe<Scalars['String']>
  upcVariants: Array<Scalars['String']>
  vendorProduct?: Maybe<VendorProduct>
  vendorProductID?: Maybe<Scalars['ID']>
}

export enum InvoicePaymentMethod {
  Ach = 'ACH',
  Cash = 'CASH',
  Check = 'CHECK',
  Credit = 'CREDIT',
}

export enum InvoiceStatus {
  Approved = 'APPROVED',
  Paid = 'PAID',
  Pending = 'PENDING',
}

export type LineItemQuantity = {
  __typename?: 'LineItemQuantity'
  quantity: Scalars['Int']
  uom: UnitOfMeasure
}

export type MapAccountingIntegrationMutationInput = {
  sourceID: Scalars['ID']
  sourceType: AccountingIntegrationSourceType
  targetID?: InputMaybe<Scalars['ID']>
  targetType: AccountingIntegrationTargetType
}

export type MarkInvoiceApprovedMutationInput = {
  invoiceID: Scalars['ID']
}

export type MarkInvoicePaidMutationInput = {
  invoiceID: Scalars['ID']
  notes: Scalars['String']
  paymentMethod: InvoicePaymentMethod
}

export type MatchError = {
  __typename?: 'MatchError'
  error: Scalars['String']
  index: Scalars['Int']
}

export type MatchingVendorProduct = {
  __typename?: 'MatchingVendorProduct'
  matchedBy: MatchingVendorProductReason
  vendorProduct: VendorProduct
}

export enum MatchingVendorProductReason {
  ItemCode = 'ITEM_CODE',
  Upc = 'UPC',
}

export enum MissScanMethod {
  Barebones = 'BAREBONES',
  Copy = 'COPY',
  Gs1 = 'GS1',
  NotMissScan = 'NOT_MISS_SCAN',
  Nutritionix = 'NUTRITIONIX',
}

export type Misscan = {
  id: Scalars['ID']
  misscanType: MisscanType
  misscanVendorProduct: MisscanVendorProduct
  store: Store
  time: Scalars['Timestamp']
  user: User
  vendor: Vendor
}

export type MisscanByIdInput = {
  id: Scalars['ID']
}

export type MisscanLineItem = {
  __typename?: 'MisscanLineItem'
  misscan: MisscanSubmission
  quantity: Scalars['Int']
  unitOfMeasure: UnitOfMeasure
}

export type MisscanLineItemInput = {
  misscanID: Scalars['ID']
  quantity: Scalars['Int']
  unitOfMeasure: UnitOfMeasure
}

export type MisscanLineItems = {
  __typename?: 'MisscanLineItems'
  nodes: Array<MisscanLineItem>
}

export type MisscanResolution = Misscan & {
  __typename?: 'MisscanResolution'
  associatedProduct?: Maybe<VendorProduct>
  id: Scalars['ID']
  misscanType: MisscanType
  misscanVendorProduct: MisscanVendorProduct
  store: Store
  time: Scalars['Timestamp']
  user: User
  vendor: Vendor
}

export type MisscanSubmission = Misscan & {
  __typename?: 'MisscanSubmission'
  description: Scalars['String']
  id: Scalars['ID']
  misscanType: MisscanType
  misscanVendorProduct: MisscanVendorProduct
  photoURL?: Maybe<Scalars['String']>
  store: Store
  time: Scalars['Timestamp']
  user: User
  vendor: Vendor
}

export enum MisscanType {
  Resolution = 'RESOLUTION',
  Submission = 'SUBMISSION',
}

/**
 * ****************************
 *      Misscans
 * ****************************
 */
export type MisscanVendorProduct = {
  __typename?: 'MisscanVendorProduct'
  associatedProduct?: Maybe<VendorProduct>
  firstScanDate: Scalars['Timestamp']
  id: Scalars['ID']
  misscanByID?: Maybe<Misscan>
  misscans: MisscansResult
  upc: Scalars['String']
  vendor: Vendor
}

/**
 * ****************************
 *      Misscans
 * ****************************
 */
export type MisscanVendorProductMisscanByIdArgs = {
  input: MisscanByIdInput
}

export type MisscansResult = {
  __typename?: 'MisscansResult'
  nodes: Array<Misscan>
  totalCount: Scalars['Int']
}

export type MissingCartItem = {
  /** Message explaining the reason for this alert, eg 'In Order Guide, but not ordered recently'. Clients should only use this field as a fallback when structured fields are not available */
  fallbackMessage: Scalars['String']
  suggestedQuantity: LineItemQuantity
  type: MissingCartItemType
  vendorProduct: VendorProduct
}

export type MissingCartItemStockedNotScanned = MissingCartItem & {
  __typename?: 'MissingCartItemStockedNotScanned'
  /** Message explaining the reason for this alert, eg 'In Order Guide, but not ordered recently'. Clients should only use this field as a fallback when structured fields are not available */
  fallbackMessage: Scalars['String']
  suggestedQuantity: LineItemQuantity
  type: MissingCartItemType
  vendorProduct: VendorProduct
}

export enum MissingCartItemType {
  StockedNotScanned = 'STOCKED_NOT_SCANNED',
}

export type MissingItemSuggestionsResult = {
  __typename?: 'MissingItemSuggestionsResult'
  nodes: Array<MissingCartItem>
}

export type Money = {
  __typename?: 'Money'
  /** Returns the amount as a signed decimal number. ex. 20.41, -29.21 */
  amount: Scalars['Float']
  display: Scalars['String']
}

export type MoneyDisplayArgs = {
  format: CurrencyFormat
}

export type MoneyInput = {
  amount: Scalars['Float']
}

export type MutateTaxRateInput = {
  name: Scalars['String']
  status: Scalars['Boolean']
  taxType: TaxType
  type: TaxRateType
  value: Scalars['String']
}

export type Mutation = {
  __typename?: 'Mutation'
  /** @deprecated Use addProductsToV2OrderGuide */
  addProductsToUserOrderGuide: OrderGuide
  addProductsToV2OrderGuide: AddProductsToV2OrderGuideResult
  addProductsToV2OrderGuideForStoreDepartment: AddProductsToV2OrderGuideResult
  adminBulkEnqueueTasks: Array<TaskResponse>
  adminCreateEdiPartner: EdiPartner
  adminCreateFeatureFlag: FeatureFlag
  adminCreateSFTPConnection: SftpConnectionGql
  adminCreateSFTPGoUser: SftpUser
  adminCreateSFTPUser: SftpUserGql
  adminEnqueueTask: TaskResponse
  adminSyncStediUsers: Array<SyncStediUsersResultGql>
  adminUpdateFeatureFlag: FeatureFlag
  adminUpdateSFTPConnection: SftpConnectionGql
  bulkAddProductsToV2OrderGuide: BulkAddProductsToV2OrderGuideResult
  /** @deprecated Use v2 order guide resolvers */
  bulkCopyUserOrderGuide: CopyUserOrderGuideResult
  bulkCopyV2OrderGuide: CopyV2OrderGuideResult
  bulkCreateOrUpdateVendorStoreDepartmentAccounts: BulkCreateOrUpdateVendorStoreDepartmentAccountsResult
  bulkCreateStores: BulkCreateStoresResult
  bulkCreateVendorInvitation?: Maybe<BulkVendorInvitationsResult>
  bulkCreateVendorStoreDepartmentAccounts: BulkCreateVendorStoreDepartmentAccountsResult
  bulkParseCSVOrderGuides: BulkParsedOrderGuidesResult
  bulkUpdatePointOfSaleDepartmentNameValidationTable: Array<ValidatedPointOfSaleDepartmentName>
  bulkUpdatePointOfSaleItemCodeValidationTable: Array<ValidatedPointOfSaleItemCode>
  bulkUpdatePointOfSaleVendorNameValidationTable: Array<ValidatedPointOfSaleVendorName>
  bulkUpdateStoreDepartments: Array<StoreDepartment>
  bulkUpdateStoreProducts: Array<GqlStoreProduct>
  bulkUpdateUserAccountList: BulkUpdateUserAccountListResult
  /** @deprecated Use addProductsToV2OrderGuide */
  bulkUpdateUserOrderGuide: BulkUpdateUserOrderGuideResult
  bulkUpdateV2OrderGuides: BulkUpdateV2OrderGuidesResult
  bulkUpdateVendorProducts: BulkUpdateVendorProductsResult
  bulkUploadMultiVendorProducts: Array<BulkUploadVendorProductsResult>
  bulkUploadMultiVendorProductsWorker: Array<TaskResponse>
  bulkUploadSingleVendorProducts: BulkUploadVendorProductsResult
  bulkUploadSingleVendorProductsWorker: TaskResponse
  /** For bulk product uploads */
  bulkUploadStoreVendorProducts: BulkUploadStoreVendorProductsResult
  bulkUploadStoreVendorProductsWorker: TaskResponse
  /**
   * Confirms an order with the option to resolve misscans or remove them from
   * the order.
   */
  confirmOrder: Order
  /** @deprecated Use v2 order guide resolvers */
  copyAllUserOrderGuides: CopyUserOrderGuideResult
  /** @deprecated Use v2 order guide resolvers */
  copyUserOrderGuide: CopyUserOrderGuideResult
  copyV2OrderGuide: CopyV2OrderGuideResult
  createAndSubmitOrderFromCart: CartOrderResult
  createAndSubmitTestTrueCommerceOrder: Order
  createAudience: Audience
  createBanner: Banner
  /** Allows store admins to create buyer accounts tied to a specific store. */
  createBuyerAccount: RetailUser
  createCodatCompany: Scalars['Boolean']
  createCustomerInvite: CustomerInviteResult
  createDeal: Deal
  createInvitationOrderGuide: InvitationOrderGuide
  createLineItemCreditRequest: ReconciledLineItem
  createMisscan: Misscan
  createOrder: Order
  createOrderAndSubmit: Order
  createOrderReceivingLineItem: OrderReceivingLineItemListItem
  createPaymentProfile: PaymentProfile
  createPaymentProfileJWT: CreatePaymentProfileJwtResult
  createPlaidLinkToken: PlaidLinkTokenResponse
  /** Used by vori admins to create new (requestable by the store) sample requests */
  createProductSampleRequests: Array<ProductSampleRequest>
  createPromotion: Promotion
  createStore: Store
  /**
   * Allows Vendors to create new Vendor<>Store Accounts.
   * If the stores provided do not match, we create a new store for that account.
   */
  createStoreAccountsForVendor: CreateStoreAccountsForVendorResult
  createStoreDepartment: StoreDepartment
  createStoreDepartments: Array<StoreDepartment>
  createStoreProducts: Array<GqlStoreProduct>
  createStoreReceiver: StoreReceiver
  createStoreVendors: Array<GqlStoreVendor>
  createStripeBankAccountToken: StripeBankAccountTokenResponse
  createTaxRate: GqlTaxRate
  createUser: User
  createUserStoreDepartment: UserStoreDepartment
  createVendor: Vendor
  createVendorProduct: VendorProduct
  createVendorStoreDepartmentAccount: VendorStoreDepartmentAccount
  deleteBanner: DeleteBannerResult
  deleteDeal: DeleteDealResult
  deleteMisscanProducts: DeleteMisscansResult
  deleteOrderReceivingLineItem: OrderReceivingLineItemListItem
  deletePromotion: DeletePromotionResult
  deleteStore: DeleteStoreResult
  deleteUser: DeleteUserResult
  deleteUserStoreDepartment: UserStoreDepartment
  deleteVendorProduct: DeleteVendorProductResult
  exportStoreVendorProductsToCSV: Scalars['String']
  exportV2OrderGuideToCSV: V2OrderGuideCsvResult
  exportVendorCatalogToCSV: Scalars['String']
  fixMisscanVendorProduct: VendorProduct
  getPointOfSaleLogProductsByDepartmentSpreadsheet: Scalars['String']
  /** Allows vendors to send invites to their store customers */
  inviteStoreAccounts: InviteStoreAccountsResult
  mapAccountingIntegrationRecords: Scalars['Boolean']
  markInvoiceAsApproved: Scalars['Boolean']
  markInvoiceAsPaid: Scalars['Boolean']
  parseCSVOrderGuide: ParsedOrderGuideResult
  receivingAppCreateOrderWithInvoiceMutation: Order
  /** @deprecated Use removeProductsFromV2OrderGuide */
  removeProductsFromUserOrderGuide: OrderGuide
  removeProductsFromV2OrderGuide: RemoveProductsFromV2OrderGuideResult
  removeProductsFromV2OrderGuideForStoreDepartment: RemoveProductsFromV2OrderGuideResult
  /** Allows stores to request a catalog from a Vendor. */
  requestCatalog: CatalogRequest
  requestInvoiceForOrder: Scalars['Boolean']
  restoreOrderGuide: Scalars['String']
  sendCreatePaymentProfileEmail: SendCreatePaymentProfileEmailResult
  sendESLConfigUpdate: Scalars['Boolean']
  sendESLFileUpdate: Array<SendEslFileUpdateResult>
  sendESLItemFileRefresh: Array<Scalars['String']>
  sendVendorInvitation?: Maybe<VendorInvitation>
  /** (Re)submits the given order. If no submissionMethod is provided, the vendors' default method is used; otherwise we default to email. */
  submitOrder: Order
  submitOrderReceivingReport: Order
  triggerSESProductSync: Scalars['Boolean']
  undoVendorCatalogCSVUpload: UndoVendorCatalogCsvUploadResult
  /** @deprecated Use updateBannerV2OrderGuides */
  updateAllBannerUsersOrderGuide: BannerOrderGuideUpdateResult
  updateAudience: Audience
  updateBanner: Banner
  updateBannerAuthFileV2OrderGuides: BannerV2OrderGuidesUpdateResult
  updateBannerV2OrderGuides: BannerV2OrderGuidesUpdateResult
  updateBannerVendorEmails: UpdateBannerVendorEmailsResult
  /**
   * Allows store admins to update certain aspects of the buyer accounts they
   * manage.
   */
  updateBuyerProfile: RetailUser
  updateCartMisscanQuantity: UpdateCartMisscanQuantityResult
  /** Update cart quantity for a specific VendorProduct */
  updateCartProductQuantity: UpdateCartProductQuantityResult
  updateCompanyFTPConfig: CompanyFtpConfig
  updateDeal: Deal
  updateLineItemCreditRequest: ReconciledLineItem
  updateOrder: Order
  updateOrderAsDelivered: Order
  updateOrderAsReceived: Order
  updateOrderReceivingLineItem: OrderReceivingLineItemListItem
  updatePointOfSaleIngestLog: PointOfSaleIngestLog
  updateProductSampleRequest: ProductSampleRequest
  updateProfile: User
  updatePromotion: Promotion
  updateStore: Store
  updateStoreDepartmentsSuggestedVendorList: UpdateStoreDepartmentsSuggestedVendorListResult
  updateStoreProduct: GqlStoreProduct
  updateStoreVendor: GqlStoreVendor
  /**
   * Allows store admins to update a store's vendor list. Removing vendors from a
   * store's vendorList will also remove the vendor from all the buyers of
   * the given store.
   */
  updateStoreVendorList: Store
  updateStoreVendorMapping: StoreVendorResult
  /** Allows store admins to update certain store-related data from vendor products. */
  updateStoreVendorProduct: VendorProduct
  updateStoreVendorProductMapping: StoreVendorProductResult
  updateTaxRate: GqlTaxRate
  updateUser: User
  updateUserAccountList: User
  /** @deprecated Use updateV2OrderGuide */
  updateUserOrderGuide: OrderGuide
  updateV2OrderGuide: V2OrderGuide
  updateVendor: Vendor
  /**
   * Update all of the contents of a VendorCart at once
   * @deprecated Use updateVendorCartV2
   */
  updateVendorCart: VendorCart
  /** Update all of the contents of a VendorCart at once */
  updateVendorCartV2: UpdateVendorCartResult
  updateVendorProduct: VendorProduct
  /** @deprecated Use updateVendorStoreDepartmentAccount instead. */
  updateVendorStoreAccount: VendorStoreAccount
  updateVendorStoreDepartmentAccount: VendorStoreDepartmentAccount
  updateVendorStoreDepartmentAccountForVendor: VendorStoreDepartmentAccount
  updateVendorStoreDepartmentAccountStatus: VendorStoreDepartmentAccount
  updateVendorsForStoreDepartment: UpdateVendorsForStoreDepartmentResult
  uploadInvoiceFileForOrder: Array<Scalars['String']>
  uploadPointOfSaleIngest: Array<BulkUploadVendorProductsResult>
}

export type MutationAddProductsToUserOrderGuideArgs = {
  input: AddProductsToOrderGuideInput
}

export type MutationAddProductsToV2OrderGuideArgs = {
  input: AddProductsToV2OrderGuideInput
}

export type MutationAddProductsToV2OrderGuideForStoreDepartmentArgs = {
  input: AddProductsToV2OrderGuideForStoreDepartmentInput
}

export type MutationAdminBulkEnqueueTasksArgs = {
  input: BulkCreateTaskInput
}

export type MutationAdminCreateEdiPartnerArgs = {
  input: AdminCreateEdiPartnerInput
}

export type MutationAdminCreateFeatureFlagArgs = {
  input: AdminCreateFeatureFlagInput
}

export type MutationAdminCreateSftpConnectionArgs = {
  input: CreateSftpConnectionInput
}

export type MutationAdminCreateSftpGoUserArgs = {
  input: AdminCreateSftpGoUserInput
}

export type MutationAdminCreateSftpUserArgs = {
  input: CreateSftpUserInput
}

export type MutationAdminEnqueueTaskArgs = {
  input: CreateTaskInput
}

export type MutationAdminUpdateFeatureFlagArgs = {
  input: AdminUpdateFeatureFlagInput
}

export type MutationAdminUpdateSftpConnectionArgs = {
  input: UpdateSftpConnectionInput
}

export type MutationBulkAddProductsToV2OrderGuideArgs = {
  input: BulkAddProductsToV2OrderGuideInput
}

export type MutationBulkCopyUserOrderGuideArgs = {
  input: BulkCopyUserOrderGuideInput
}

export type MutationBulkCopyV2OrderGuideArgs = {
  input: BulkCopyV2OrderGuideInput
}

export type MutationBulkCreateOrUpdateVendorStoreDepartmentAccountsArgs = {
  input: Array<CreateOrUpdateVendorStoreDepartmentAccountForm>
}

export type MutationBulkCreateStoresArgs = {
  input: BulkCreateStoresInput
}

export type MutationBulkCreateVendorInvitationArgs = {
  input: BulkCreateVendorInvitationInput
}

export type MutationBulkCreateVendorStoreDepartmentAccountsArgs = {
  input: Array<CreateVendorStoreDepartmentAccountForm>
}

export type MutationBulkParseCsvOrderGuidesArgs = {
  input: BulkParseCsvOrderGuidesInput
}

export type MutationBulkUpdatePointOfSaleDepartmentNameValidationTableArgs = {
  bannerID?: InputMaybe<Scalars['ID']>
  input: Array<ValidatedPointOfSaleDepartmentNameInput>
  storeID?: InputMaybe<Scalars['ID']>
}

export type MutationBulkUpdatePointOfSaleItemCodeValidationTableArgs = {
  bannerID?: InputMaybe<Scalars['ID']>
  input: Array<ValidatedPointOfSaleItemCodeInput>
  storeID?: InputMaybe<Scalars['ID']>
}

export type MutationBulkUpdatePointOfSaleVendorNameValidationTableArgs = {
  bannerID?: InputMaybe<Scalars['ID']>
  input: Array<ValidatedPointOfSaleVendorNameInput>
  storeID?: InputMaybe<Scalars['ID']>
}

export type MutationBulkUpdateStoreDepartmentsArgs = {
  data: BulkUpdateStoreDepartmentsInput
}

export type MutationBulkUpdateStoreProductsArgs = {
  data: EditableStoreProductFields
  ids: Array<Scalars['ID']>
}

export type MutationBulkUpdateUserAccountListArgs = {
  input: Array<BulkUpdateUserAccountListInput>
}

export type MutationBulkUpdateUserOrderGuideArgs = {
  input: BulkUpdateUserOrderGuideInput
}

export type MutationBulkUpdateV2OrderGuidesArgs = {
  input: BulkUpdateV2OrderGuidesInput
}

export type MutationBulkUpdateVendorProductsArgs = {
  input: BulkUpdateVendorProductsInput
}

export type MutationBulkUploadMultiVendorProductsArgs = {
  input: BulkUploadMultiVendorProductsInput
}

export type MutationBulkUploadMultiVendorProductsWorkerArgs = {
  input: BulkUploadMultiVendorProductsInput
}

export type MutationBulkUploadSingleVendorProductsArgs = {
  input: BulkUploadSingleVendorProductsInput
}

export type MutationBulkUploadSingleVendorProductsWorkerArgs = {
  input: BulkUploadSingleVendorProductsInput
}

export type MutationBulkUploadStoreVendorProductsArgs = {
  input: BulkUploadStoreVendorProductsInput
}

export type MutationBulkUploadStoreVendorProductsWorkerArgs = {
  input: BulkUploadStoreVendorProductsInput
}

export type MutationConfirmOrderArgs = {
  input: ConfirmOrderInput
}

export type MutationCopyAllUserOrderGuidesArgs = {
  input: CopyAllUserOrderGuideInput
}

export type MutationCopyUserOrderGuideArgs = {
  input: CopyUserOrderGuideInput
}

export type MutationCopyV2OrderGuideArgs = {
  input: CopyV2OrderGuideInput
}

export type MutationCreateAndSubmitOrderFromCartArgs = {
  input: CreateAndSubmitOrderFromCartInput
}

export type MutationCreateAndSubmitTestTrueCommerceOrderArgs = {
  accountNumber: Scalars['String']
  dunsNumber?: InputMaybe<Scalars['String']>
  sampleVendorProductFirestoreID: Scalars['ID']
  storeFirestoreID?: InputMaybe<Scalars['ID']>
  trueCommerceTenetID: Scalars['ID']
  userEmail?: InputMaybe<Scalars['String']>
  vendorFirestoreID: Scalars['ID']
}

export type MutationCreateAudienceArgs = {
  input: CreateAudienceInput
}

export type MutationCreateBannerArgs = {
  input: CreateBannerInput
}

export type MutationCreateBuyerAccountArgs = {
  input: CreateBuyerAccountInput
}

export type MutationCreateCodatCompanyArgs = {
  input: CreateCodatCompanyMutationInput
}

export type MutationCreateCustomerInviteArgs = {
  skipEmail?: InputMaybe<Scalars['Boolean']>
  stores: Array<StoreInviteInput>
  vendorID: Scalars['ID']
}

export type MutationCreateDealArgs = {
  input: CreateDealInput
}

export type MutationCreateInvitationOrderGuideArgs = {
  input: InvitationOrderGuideInput
}

export type MutationCreateLineItemCreditRequestArgs = {
  input: CreateLineItemCreditRequestMutationInput
}

export type MutationCreateMisscanArgs = {
  input: CreateMisscanInput
}

export type MutationCreateOrderArgs = {
  input: CreateOrderInput
}

export type MutationCreateOrderAndSubmitArgs = {
  input: CreateOrderInput
}

export type MutationCreateOrderReceivingLineItemArgs = {
  input: CreateOrderReceivingLineItemInput
}

export type MutationCreatePaymentProfileArgs = {
  input: PaymentProfileInput
}

export type MutationCreatePaymentProfileJwtArgs = {
  input: CreatePaymentProfileJwtInput
}

export type MutationCreatePlaidLinkTokenArgs = {
  clientUserID: Scalars['String']
}

export type MutationCreateProductSampleRequestsArgs = {
  input: CreateProductSampleRequestsInput
}

export type MutationCreatePromotionArgs = {
  input: CreatePromotionInput
}

export type MutationCreateStoreArgs = {
  input: CreateStoreInput
}

export type MutationCreateStoreAccountsForVendorArgs = {
  input: CreateStoreAccountsForVendorInput
}

export type MutationCreateStoreDepartmentArgs = {
  input: CreateStoreDepartmentInput
}

export type MutationCreateStoreDepartmentsArgs = {
  data: CreateStoreDepartmentsInput
}

export type MutationCreateStoreProductsArgs = {
  data: CreateStoreProductsInput
}

export type MutationCreateStoreReceiverArgs = {
  input: CreateStoreReceiverInput
}

export type MutationCreateStoreVendorsArgs = {
  bannerFirestoreID: Scalars['String']
  data: StoreVendorCreateFields
  storeSerialIDs?: InputMaybe<Array<Scalars['String']>>
}

export type MutationCreateStripeBankAccountTokenArgs = {
  input: StripeBankAccountTokenForm
}

export type MutationCreateTaxRateArgs = {
  data: MutateTaxRateInput
}

export type MutationCreateUserArgs = {
  input: CreateUserInput
}

export type MutationCreateUserStoreDepartmentArgs = {
  input: CreateUserStoreDepartmentInput
}

export type MutationCreateVendorArgs = {
  input: CreateVendorInput
}

export type MutationCreateVendorProductArgs = {
  input: CreateVendorProductInput
}

export type MutationCreateVendorStoreDepartmentAccountArgs = {
  input: CreateVendorStoreDepartmentAccountForm
}

export type MutationDeleteBannerArgs = {
  input: DeleteBannerInput
}

export type MutationDeleteDealArgs = {
  input: DeleteDealInput
}

export type MutationDeleteMisscanProductsArgs = {
  input: DeleteMisscansInput
}

export type MutationDeleteOrderReceivingLineItemArgs = {
  id: Scalars['ID']
}

export type MutationDeletePromotionArgs = {
  input: DeletePromotionInput
}

export type MutationDeleteStoreArgs = {
  input: DeleteStoreInput
}

export type MutationDeleteUserArgs = {
  input: DeleteUserInput
}

export type MutationDeleteUserStoreDepartmentArgs = {
  input: DeleteUserStoreDepartmentInput
}

export type MutationDeleteVendorProductArgs = {
  input: DeleteVendorProductInput
}

export type MutationExportStoreVendorProductsToCsvArgs = {
  adminOverideCompanyFirestoreID?: InputMaybe<Scalars['String']>
  endDate?: InputMaybe<Scalars['Timestamp']>
  filterByStoreProductSQLIDs?: InputMaybe<Array<Scalars['String']>>
  filterByStoreSQLIDs?: InputMaybe<Array<Scalars['String']>>
  isSESExport?: InputMaybe<Scalars['Boolean']>
  startDate?: InputMaybe<Scalars['Timestamp']>
}

export type MutationExportV2OrderGuideToCsvArgs = {
  id: Scalars['ID']
}

export type MutationExportVendorCatalogToCsvArgs = {
  vendorID: Scalars['String']
}

export type MutationFixMisscanVendorProductArgs = {
  input: FixMisscanInput
}

export type MutationGetPointOfSaleLogProductsByDepartmentSpreadsheetArgs = {
  logID: Scalars['String']
}

export type MutationInviteStoreAccountsArgs = {
  input: InviteStoreAccountsInput
}

export type MutationMapAccountingIntegrationRecordsArgs = {
  input: MapAccountingIntegrationMutationInput
}

export type MutationMarkInvoiceAsApprovedArgs = {
  input: MarkInvoiceApprovedMutationInput
}

export type MutationMarkInvoiceAsPaidArgs = {
  input: MarkInvoicePaidMutationInput
}

export type MutationParseCsvOrderGuideArgs = {
  input: ParseCsvOrderGuideInput
}

export type MutationReceivingAppCreateOrderWithInvoiceMutationArgs = {
  input: CreateInvoiceForNonVoriOrderMutationInput
}

export type MutationRemoveProductsFromUserOrderGuideArgs = {
  input: RemoveProductsFromOrderGuideInput
}

export type MutationRemoveProductsFromV2OrderGuideArgs = {
  input: RemoveProductsFromV2OrderGuideInput
}

export type MutationRemoveProductsFromV2OrderGuideForStoreDepartmentArgs = {
  input: RemoveProductsFromV2OrderGuideForStoreDepartmentInput
}

export type MutationRequestCatalogArgs = {
  input: RequestCatalogInput
}

export type MutationRequestInvoiceForOrderArgs = {
  input: RequestInvoiceForOrderMutationInput
}

export type MutationRestoreOrderGuideArgs = {
  input: RestoreOrderGuideInput
}

export type MutationSendCreatePaymentProfileEmailArgs = {
  input: SendCreatePaymentProfileEmailInput
}

export type MutationSendEslConfigUpdateArgs = {
  input: UpdateEslConfigInput
}

export type MutationSendEslFileUpdateArgs = {
  input: SendEslFileUpdateInput
}

export type MutationSendEslItemFileRefreshArgs = {
  input: SendEslFileRefreshInput
}

export type MutationSendVendorInvitationArgs = {
  input: SendVendorInvitationInput
}

export type MutationSubmitOrderArgs = {
  orderID: Scalars['ID']
  skipEmailWithEDIOrderReSubmission?: InputMaybe<Scalars['Boolean']>
  submissionMethod?: InputMaybe<SubmissionMethod>
}

export type MutationSubmitOrderReceivingReportArgs = {
  input: SubmitOrderReceivingReportInput
}

export type MutationTriggerSesProductSyncArgs = {
  storeID: Scalars['ID']
}

export type MutationUndoVendorCatalogCsvUploadArgs = {
  input?: InputMaybe<UndoVendorCatalogCsvUploadInput>
}

export type MutationUpdateAllBannerUsersOrderGuideArgs = {
  input: UpdateAllBannerUsersOrderGuideInput
}

export type MutationUpdateAudienceArgs = {
  input: UpdateAudienceInput
}

export type MutationUpdateBannerArgs = {
  input: UpdateBannerInput
}

export type MutationUpdateBannerAuthFileV2OrderGuidesArgs = {
  input: UpdateBannerAuthFileV2OrderGuidesInput
}

export type MutationUpdateBannerV2OrderGuidesArgs = {
  input: UpdateBannerV2OrderGuidesInput
}

export type MutationUpdateBannerVendorEmailsArgs = {
  input: UpdateBannerVendorEmailsInput
}

export type MutationUpdateBuyerProfileArgs = {
  input: UpdateBuyerProfileInput
}

export type MutationUpdateCartMisscanQuantityArgs = {
  input: UpdateCartMisscanQuantityInput
}

export type MutationUpdateCartProductQuantityArgs = {
  input: UpdateCartProductQuantityInput
}

export type MutationUpdateCompanyFtpConfigArgs = {
  companyID: Scalars['String']
  companyType: CompanyType
  userName: Scalars['String']
}

export type MutationUpdateDealArgs = {
  input: UpdateDealInput
}

export type MutationUpdateLineItemCreditRequestArgs = {
  input: UpdateLineItemCreditRequestMutationInput
}

export type MutationUpdateOrderArgs = {
  input: UpdateOrderInput
}

export type MutationUpdateOrderAsDeliveredArgs = {
  orderID: Scalars['ID']
}

export type MutationUpdateOrderAsReceivedArgs = {
  orderID: Scalars['ID']
}

export type MutationUpdateOrderReceivingLineItemArgs = {
  id: Scalars['ID']
  input: UpdateOrderReceivingLineItemInput
}

export type MutationUpdatePointOfSaleIngestLogArgs = {
  input?: InputMaybe<PointOfSaleIngestLogInput>
}

export type MutationUpdateProductSampleRequestArgs = {
  input: UpdateProductSampleRequestInput
}

export type MutationUpdateProfileArgs = {
  input?: InputMaybe<UpdateProfileInput>
}

export type MutationUpdatePromotionArgs = {
  input: UpdatePromotionInput
}

export type MutationUpdateStoreArgs = {
  input: UpdateStoreInput
}

export type MutationUpdateStoreDepartmentsSuggestedVendorListArgs = {
  input: UpdateStoreDepartmentsSuggestedVendorListInput
}

export type MutationUpdateStoreProductArgs = {
  data: EditableStoreProductFields
  id: Scalars['String']
}

export type MutationUpdateStoreVendorArgs = {
  data: StoreVendorEditableFields
  id: Scalars['ID']
}

export type MutationUpdateStoreVendorListArgs = {
  input: UpdateStoreVendorListInput
}

export type MutationUpdateStoreVendorMappingArgs = {
  input: StoreVendorMappingUpdateInput
}

export type MutationUpdateStoreVendorProductArgs = {
  input: UpdateStoreVendorProductInput
}

export type MutationUpdateStoreVendorProductMappingArgs = {
  input: StoreVendorProductsMappingUpdateInput
}

export type MutationUpdateTaxRateArgs = {
  data: MutateTaxRateInput
  id: Scalars['String']
}

export type MutationUpdateUserArgs = {
  input: UpdateUserInput
}

export type MutationUpdateUserAccountListArgs = {
  input: UpdateUserAccountListInput
}

export type MutationUpdateUserOrderGuideArgs = {
  input: UpdateUserOrderGuideInput
}

export type MutationUpdateV2OrderGuideArgs = {
  input: UpdateV2OrderGuideInput
}

export type MutationUpdateVendorArgs = {
  input: UpdateVendorInput
}

export type MutationUpdateVendorCartArgs = {
  input: UpdateVendorCartInput
}

export type MutationUpdateVendorCartV2Args = {
  input: UpdateVendorCartInput
}

export type MutationUpdateVendorProductArgs = {
  input: UpdateVendorProductInput
}

export type MutationUpdateVendorStoreAccountArgs = {
  input: UpdateVendorStoreAccountInput
}

export type MutationUpdateVendorStoreDepartmentAccountArgs = {
  id: Scalars['ID']
  input: UpdateVendorStoreDepartmentAccountForm
}

export type MutationUpdateVendorStoreDepartmentAccountForVendorArgs = {
  input: UpdateVendorStoreDepartmentAccountForm
  storeDepartmentID: Scalars['ID']
  vendorID: Scalars['ID']
}

export type MutationUpdateVendorStoreDepartmentAccountStatusArgs = {
  id: Scalars['ID']
  status: VendorStoreDepartmentAccountStatus
}

export type MutationUpdateVendorsForStoreDepartmentArgs = {
  input: UpdateVendorsForStoreDepartmentInput
}

export type MutationUploadInvoiceFileForOrderArgs = {
  input: UploadInvoiceFileForOrderMutationInput
}

export type MutationUploadPointOfSaleIngestArgs = {
  logID: Scalars['String']
}

export type Order = {
  __typename?: 'Order'
  accountNumber: Scalars['String']
  buyerName: Scalars['String']
  caseCount: Scalars['Int']
  client?: Maybe<ClientType>
  deliveredAt?: Maybe<Scalars['Timestamp']>
  deliveredAtUser?: Maybe<User>
  deliveryDate?: Maybe<Scalars['Timestamp']>
  eachCount: Scalars['Int']
  erpOrderSent: Scalars['Boolean']
  /** Boolean flag that indicates if the order currently contains any misscans. */
  hasMisscans: Scalars['Boolean']
  id: Scalars['ID']
  invoice?: Maybe<Invoice>
  invoicePDFUrl?: Maybe<Scalars['String']>
  isVoriOrder: Scalars['Boolean']
  itemCount: Scalars['Int']
  /** List of misscan products */
  misscans: Array<OrderMisscanLineItem>
  noteToVendor?: Maybe<Scalars['String']>
  orderConfirmed: Scalars['Boolean']
  orderConfirmedBy?: Maybe<Scalars['String']>
  orderContents: Array<OrderLineItem>
  orderDateTime: Scalars['Timestamp']
  orderEmailOpened: Scalars['Boolean']
  orderPlaced: Scalars['Boolean']
  orderPlacedByUserEmail: Scalars['String']
  orderReceivingLineItemList: OrderReceivingLineItemListResult
  orderTotal: Money
  purchaseOrderNum: Scalars['String']
  receivedAt?: Maybe<Scalars['Timestamp']>
  receivedByUser?: Maybe<User>
  receivingAppStatus: OrderReceivingStatus
  receivingStatus: OrderReceivingStatus
  statusHistory: Array<GqlOrderHistoryEventBase>
  storeAddress: Scalars['String']
  storeID: Scalars['String']
  storeName: Scalars['String']
  submissionMethod: SubmissionMethod
  subtotal: Scalars['Currency']
  totalPrice: Scalars['Float']
  user: User
  vendor: Vendor
  vendorID: Scalars['String']
  vendorStoreDepartmentAccount?: Maybe<VendorStoreDepartmentAccount>
}

export type OrderOrderReceivingLineItemListArgs = {
  input?: InputMaybe<OrderReceivingLineItemListInput>
}

export type OrderBillingInfoInput = {
  basisPoints?: InputMaybe<Scalars['Int']>
  billingType: BillingType
  cost?: InputMaybe<Scalars['Currency']>
}

export type OrderEdge = {
  __typename?: 'OrderEdge'
  cursor: Scalars['Cursor']
  node: Order
}

export type OrderGuide = {
  __typename?: 'OrderGuide'
  defaultUOM?: Maybe<UnitOfMeasure>
  products?: Maybe<OrderGuideProductsResult>
  readOnly?: Maybe<Scalars['Boolean']>
  retailUser?: Maybe<RetailUser>
}

export type OrderGuideCsvInput = {
  itemCode?: InputMaybe<Scalars['String']>
  upc?: InputMaybe<Scalars['String']>
}

export type OrderGuideProductsQueryInput = {
  cursor?: InputMaybe<Scalars['ID']>
  limit?: InputMaybe<Scalars['Int']>
  query?: InputMaybe<Scalars['String']>
  storeID: Scalars['ID']
  vendorID: Scalars['ID']
}

export type OrderGuideProductsResult = {
  __typename?: 'OrderGuideProductsResult'
  cursor?: Maybe<Scalars['ID']>
  hasMore: Scalars['Boolean']
  nodes: Array<VendorProduct>
  totalCount: Scalars['Int']
}

export type OrderGuideResult = {
  __typename?: 'OrderGuideResult'
  vendorProductIDs: Array<Scalars['String']>
}

export type OrderGuideVendorProductIDsResult = {
  __typename?: 'OrderGuideVendorProductIDsResult'
  cursor?: Maybe<Scalars['ID']>
  hasMore: Scalars['Boolean']
  totalCount: Scalars['Int']
  vendorProductIDs: Array<Scalars['String']>
}

export type OrderGuideVendorProductsQueryInput = {
  cursor?: InputMaybe<Scalars['ID']>
  limit?: InputMaybe<Scalars['Int']>
  query?: InputMaybe<Scalars['String']>
  storeDepartmentID?: InputMaybe<Scalars['ID']>
  storeID?: InputMaybe<Scalars['ID']>
  vendorID: Scalars['ID']
}

export type OrderGuidesResult = {
  __typename?: 'OrderGuidesResult'
  nodes: Array<OrderGuideResult>
  totalCount: Scalars['Int']
}

export type OrderHistoryEventInvoiceApproved = GqlOrderHistoryEventBase & {
  __typename?: 'OrderHistoryEventInvoiceApproved'
  createdAt: Scalars['DateTime']
  id: Scalars['ID']
  note: Scalars['String']
  pendingCredits: Money
  status: OrderReceivingStatus
  userName?: Maybe<Scalars['String']>
  userType?: Maybe<Scalars['String']>
}

export type OrderHistoryEventInvoicePaid = GqlOrderHistoryEventBase & {
  __typename?: 'OrderHistoryEventInvoicePaid'
  createdAt: Scalars['DateTime']
  id: Scalars['ID']
  paymentMethod: InvoicePaymentMethod
  paymentNotes: Scalars['String']
  status: OrderReceivingStatus
  totalPaid: Money
  userName?: Maybe<Scalars['String']>
  userType?: Maybe<Scalars['String']>
}

export type OrderHistoryEventOrdered = GqlOrderHistoryEventBase & {
  __typename?: 'OrderHistoryEventOrdered'
  caseCount: Scalars['Float']
  createdAt: Scalars['DateTime']
  departmentName: Scalars['String']
  eachCount: Scalars['Float']
  id: Scalars['ID']
  status: OrderReceivingStatus
  total: Money
  userName?: Maybe<Scalars['String']>
  userType?: Maybe<Scalars['String']>
}

export type OrderHistoryEventReceived = GqlOrderHistoryEventBase & {
  __typename?: 'OrderHistoryEventReceived'
  caseCount: Scalars['Float']
  createdAt: Scalars['DateTime']
  eachCount: Scalars['Float']
  fillRate: Scalars['Float']
  id: Scalars['ID']
  issueCount: Scalars['Float']
  status: OrderReceivingStatus
  userName?: Maybe<Scalars['String']>
  userType?: Maybe<Scalars['String']>
}

export type OrderLineItem = {
  __typename?: 'OrderLineItem'
  deal?: Maybe<Deal>
  orderReceivingLineItem?: Maybe<OrderReceivingLineItem>
  price: Scalars['Int']
  product?: Maybe<VendorProduct>
  quantity: Scalars['Int']
  unitOfMeasure: UnitOfMeasure
}

export type OrderLineItemInput = {
  dealID?: InputMaybe<Scalars['ID']>
  price: Scalars['Int']
  promotion?: InputMaybe<Scalars['String']>
  quantity: Scalars['Int']
  uom: UnitOfMeasure
  vendorProductID: Scalars['ID']
}

export type OrderMispick = {
  __typename?: 'OrderMispick'
  brandName?: Maybe<Scalars['String']>
  createMispickItem?: Maybe<Scalars['Boolean']>
  description?: Maybe<Scalars['String']>
  details: Scalars['String']
  id: Scalars['ID']
  idempotencyKey?: Maybe<Scalars['String']>
  imageURLs: Array<Scalars['String']>
  issueQuantity?: Maybe<Scalars['Int']>
  quantity: Scalars['Int']
  status: OrderReceivingLineItemStatus
  unitOfMeasure: UnitOfMeasure
  upc?: Maybe<Scalars['String']>
  vendorProduct?: Maybe<VendorProduct>
}

export type OrderMispickInput = {
  brandName?: InputMaybe<Scalars['String']>
  createMispickItem?: InputMaybe<Scalars['Boolean']>
  description?: InputMaybe<Scalars['String']>
  details?: InputMaybe<Scalars['String']>
  idempotencyKey: Scalars['String']
  imageURLs?: InputMaybe<Array<Scalars['String']>>
  quantity: Scalars['Int']
  unitOfMeasure: UnitOfMeasure
  upc?: InputMaybe<Scalars['String']>
  vendorProductID?: InputMaybe<Scalars['String']>
}

export type OrderMisscanLineItem = {
  __typename?: 'OrderMisscanLineItem'
  misscanVendorProduct: MisscanVendorProduct
  quantity: Scalars['Int']
  resolution: MisscanSubmission
  unitOfMeasure: UnitOfMeasure
}

export type OrderMisscanLineItemInput = {
  misscanVendorProductID: Scalars['ID']
  quantity: Scalars['Int']
  resolutionID: Scalars['ID']
  unitOfMeasure: UnitOfMeasure
}

export type OrderReceivingLineItem = {
  __typename?: 'OrderReceivingLineItem'
  brandName?: Maybe<Scalars['String']>
  description?: Maybe<Scalars['String']>
  details: Scalars['String']
  id: Scalars['ID']
  imageURLs: Array<Scalars['String']>
  issueQuantity?: Maybe<Scalars['Int']>
  quantity: Scalars['Int']
  status: OrderReceivingLineItemStatus
  unitOfMeasure: UnitOfMeasure
  upc?: Maybe<Scalars['String']>
}

export type OrderReceivingLineItemInput = {
  issueQuantity?: InputMaybe<Scalars['Int']>
  quantity: Scalars['Int']
  status: OrderReceivingLineItemStatus
  unitOfMeasure: UnitOfMeasure
  vendorProductID: Scalars['String']
}

export type OrderReceivingLineItemListInput = {
  limit?: InputMaybe<Scalars['Int']>
  pagination?: InputMaybe<PaginationInput>
  query?: InputMaybe<Scalars['String']>
  sortBy?: InputMaybe<OrderReceivingLineItemListSortingInput>
  status?: InputMaybe<Array<OrderReceivingLineItemStatus>>
}

export type OrderReceivingLineItemListItem = OrderLineItem | OrderMispick

export type OrderReceivingLineItemListResult = {
  __typename?: 'OrderReceivingLineItemListResult'
  cursor?: Maybe<Scalars['ID']>
  hasMore?: Maybe<Scalars['Boolean']>
  nodes: Array<OrderReceivingLineItemListItem>
}

export enum OrderReceivingLineItemListSortingField {
  Brand = 'BRAND',
  Description = 'DESCRIPTION',
  ItemCode = 'ITEM_CODE',
}

export type OrderReceivingLineItemListSortingInput = {
  field: OrderReceivingLineItemListSortingField
}

export enum OrderReceivingLineItemStatus {
  Damaged = 'DAMAGED',
  Mispick = 'MISPICK',
  NotDelivered = 'NOT_DELIVERED',
  Ok = 'OK',
  Outdated = 'OUTDATED',
  Short = 'SHORT',
}

export enum OrderReceivingStatus {
  Approved = 'APPROVED',
  InProgress = 'IN_PROGRESS',
  Open = 'OPEN',
  Paid = 'PAID',
  /** V2 */
  Pending = 'PENDING',
  Received = 'RECEIVED',
}

export type OrdersResult = {
  __typename?: 'OrdersResult'
  nodes: Array<Order>
  totalCount: Scalars['Int']
}

export type PageInfo = {
  __typename?: 'PageInfo'
  endCursor: Scalars['Cursor']
  hasNextPage: Scalars['Boolean']
  startCursor: Scalars['Cursor']
}

export type PaginatedInput = {
  cursor?: InputMaybe<Scalars['String']>
  limit?: InputMaybe<Scalars['Int']>
  search?: InputMaybe<Scalars['String']>
}

export enum PaginationDirection {
  Backward = 'BACKWARD',
  Forward = 'FORWARD',
}

export type PaginationInput = {
  cursor?: InputMaybe<Scalars['ID']>
  direction?: InputMaybe<PaginationDirection>
}

export type ParseCsvOrderGuideInput = {
  forInvitationOrderGuide?: InputMaybe<Scalars['Boolean']>
  forRetailAccountIDs?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>
  orderGuideCSVInput: Array<OrderGuideCsvInput>
  vendorID: Scalars['ID']
}

export type ParsedOrderGuideResult = {
  __typename?: 'ParsedOrderGuideResult'
  errors: Array<Maybe<Scalars['Int']>>
  hasErrors: Scalars['Boolean']
  retailAccountIDs?: Maybe<Array<Scalars['String']>>
  vendorID: Scalars['String']
  vendorProductIDs: Array<Scalars['String']>
}

export type ParsedProduct = {
  __typename?: 'ParsedProduct'
  errors?: Maybe<Array<ParsedProductErrorCode>>
  product?: Maybe<PointOfSaleVendorProduct>
  skipped?: Maybe<Scalars['Boolean']>
}

export enum ParsedProductErrorCode {
  MissingItemCode = 'MISSING_ITEM_CODE',
  UnmatchedDepartment = 'UNMATCHED_DEPARTMENT',
  UnmatchedVendorName = 'UNMATCHED_VENDOR_NAME',
}

export type ParsedProductInput = {
  errors?: InputMaybe<Array<ParsedProductErrorCode>>
  product?: InputMaybe<PointOfSaleVendorProductInput>
  skipped?: InputMaybe<Scalars['Boolean']>
}

export enum ParsedProductsFilters {
  InvalidProducts = 'INVALID_PRODUCTS',
  MissingItemCode = 'MISSING_ITEM_CODE',
  Skipped = 'SKIPPED',
  UnmatchedDepartment = 'UNMATCHED_DEPARTMENT',
  UnmatchedVendorName = 'UNMATCHED_VENDOR_NAME',
  ValidProducts = 'VALID_PRODUCTS',
}

export type ParsedProductsInput = {
  cursor?: InputMaybe<Scalars['Int']>
  filterBy?: InputMaybe<ParsedProductsFilters>
  limit?: InputMaybe<Scalars['Int']>
}

export type ParsedProductsResult = {
  __typename?: 'ParsedProductsResult'
  cursor: Scalars['Int']
  hasMore: Scalars['Boolean']
  nodes: Array<ParsedProduct>
  totalCount: Scalars['Int']
}

export type PaymentMethod = {
  __typename?: 'PaymentMethod'
  accountHolderName?: Maybe<Scalars['String']>
  accountHolderType?: Maybe<Scalars['String']>
  bankName?: Maybe<Scalars['String']>
  brand?: Maybe<Scalars['String']>
  expMonth?: Maybe<Scalars['Int']>
  expYear?: Maybe<Scalars['Int']>
  last4: Scalars['String']
  paymentMethodType: PaymentMethodType
  routingNumber?: Maybe<Scalars['String']>
  stripeID: Scalars['String']
}

export enum PaymentMethodType {
  BankAccount = 'bank_account',
  Card = 'card',
}

/**
 * ****************************
 *       Payment Profile
 * ****************************
 */
export type PaymentProfile = {
  __typename?: 'PaymentProfile'
  bannerID?: Maybe<Scalars['String']>
  email: Scalars['String']
  id: Scalars['String']
  paymentMethods: Array<PaymentMethod>
  storeID?: Maybe<Scalars['String']>
  stripeCustomerID: Scalars['String']
  vendorID?: Maybe<Scalars['String']>
}

export type PaymentProfileInput = {
  bannerID?: InputMaybe<Scalars['String']>
  email: Scalars['String']
  name: Scalars['String']
  paymentMethodType: PaymentMethodType
  storeID?: InputMaybe<Scalars['String']>
  stripeBankAccountTokenID?: InputMaybe<Scalars['String']>
  stripeCardTokenID?: InputMaybe<Scalars['String']>
  vendorID?: InputMaybe<Scalars['String']>
}

export type PercentageDeal = Deal & {
  __typename?: 'PercentageDeal'
  basisPoints: Scalars['Int']
  displayName: Scalars['String']
  id: Scalars['ID']
  promotion: Promotion
  type: DealType
  vendorDiscountCode?: Maybe<Scalars['String']>
  vendorProducts: DealVendorProductsResult
  vendorProductsByBrand?: Maybe<VendorProductsByBrandResult>
}

export type PercentageDealVendorProductsArgs = {
  input?: InputMaybe<VendorProductsInput>
}

export type PercentageDealVendorProductsByBrandArgs = {
  input?: InputMaybe<DealVendorProductsByBrandInput>
}

/**
 * ****************************
 *       Bank Account
 * ****************************
 */
export type PlaidLinkTokenResponse = {
  __typename?: 'PlaidLinkTokenResponse'
  expiration: Scalars['Timestamp']
  plaidLinkToken: Scalars['String']
  requestID: Scalars['String']
}

export type PointOfSaleIngestLog = {
  __typename?: 'PointOfSaleIngestLog'
  banner?: Maybe<Banner>
  filePath: Scalars['String']
  id: Scalars['String']
  numOfStoreDiscontinuedProducts: Scalars['Int']
  numProducts: Scalars['Int']
  parsedProducts: ParsedProductsResult
  parsedProductsJSONFilePath: Scalars['String']
  skipped: Scalars['Boolean']
  store?: Maybe<Store>
  timestamp: Scalars['Timestamp']
  type: FtpFileType
  uploaded: Scalars['Boolean']
}

export type PointOfSaleIngestLogParsedProductsArgs = {
  input?: InputMaybe<ParsedProductsInput>
}

export type PointOfSaleIngestLogInput = {
  id: Scalars['String']
  parsedProducts?: InputMaybe<Array<ParsedProductInput>>
  skipProduct?: InputMaybe<PointOfSaleVendorProductInput>
  skipped?: InputMaybe<Scalars['Boolean']>
  unskipProduct?: InputMaybe<PointOfSaleVendorProductInput>
  uploaded?: InputMaybe<Scalars['Boolean']>
}

export type PointOfSaleIngestLogMetaData = {
  __typename?: 'PointOfSaleIngestLogMetaData'
  banner?: Maybe<Banner>
  filePath: Scalars['String']
  id: Scalars['String']
  numOfStoreDiscontinuedProducts: Scalars['Int']
  numProducts: Scalars['Int']
  parsedProductsJSONFilePath: Scalars['String']
  skipped: Scalars['Boolean']
  store?: Maybe<Store>
  timestamp: Scalars['Timestamp']
  type: FtpFileType
  uploaded: Scalars['Boolean']
}

export type PointOfSaleVendorProduct = {
  __typename?: 'PointOfSaleVendorProduct'
  brandName?: Maybe<Scalars['String']>
  casePrice?: Maybe<Scalars['Currency']>
  caseSize?: Maybe<Scalars['Float']>
  caseUPC?: Maybe<Scalars['String']>
  category?: Maybe<Scalars['String']>
  departmentName?: Maybe<Scalars['String']>
  description?: Maybe<Scalars['String']>
  discontinuedDate?: Maybe<Scalars['Timestamp']>
  fuzzyMatchedVendorID?: Maybe<Scalars['String']>
  fuzzyMatchedVendorName?: Maybe<Scalars['String']>
  imgURL?: Maybe<Scalars['String']>
  inventory?: Maybe<Scalars['Int']>
  itemCode?: Maybe<Scalars['String']>
  notes?: Maybe<Scalars['String']>
  packUPC?: Maybe<Scalars['String']>
  pointOfSaleDepartmentName?: Maybe<Scalars['String']>
  pointOfSaleVendorName?: Maybe<Scalars['String']>
  sizing?: Maybe<Scalars['String']>
  startDate?: Maybe<Scalars['Timestamp']>
  status?: Maybe<VendorProductStatus>
  unitPrice?: Maybe<Scalars['Currency']>
  unitUPC?: Maybe<Scalars['String']>
  unitVolume?: Maybe<Scalars['String']>
  vendor?: Maybe<Vendor>
  vendorID?: Maybe<Scalars['ID']>
}

export type PointOfSaleVendorProductInput = {
  brandName?: InputMaybe<Scalars['String']>
  casePrice?: InputMaybe<Scalars['Currency']>
  caseSize?: InputMaybe<Scalars['Float']>
  caseUPC?: InputMaybe<Scalars['String']>
  category?: InputMaybe<Scalars['String']>
  departmentName?: InputMaybe<Scalars['String']>
  description?: InputMaybe<Scalars['String']>
  discontinuedDate?: InputMaybe<Scalars['Timestamp']>
  fuzzyMatchedVendorID?: InputMaybe<Scalars['ID']>
  fuzzyMatchedVendorName?: InputMaybe<Scalars['String']>
  imgURL?: InputMaybe<Scalars['String']>
  inventory?: InputMaybe<Scalars['Int']>
  itemCode?: InputMaybe<Scalars['String']>
  notes?: InputMaybe<Scalars['String']>
  packUPC?: InputMaybe<Scalars['String']>
  pointOfSaleDepartmentName?: InputMaybe<Scalars['String']>
  pointOfSaleVendorName?: InputMaybe<Scalars['String']>
  sizing?: InputMaybe<Scalars['String']>
  startDate?: InputMaybe<Scalars['Timestamp']>
  status?: InputMaybe<VendorProductStatus>
  unitPrice?: InputMaybe<Scalars['Currency']>
  unitUPC?: InputMaybe<Scalars['String']>
  unitVolume?: InputMaybe<Scalars['String']>
  vendorID?: InputMaybe<Scalars['ID']>
  vendorName?: InputMaybe<Scalars['String']>
}

export type PotentialPromotionConflictsInput = {
  /** Check for conflicts against all the vendor's store accounts. This flag will override any given `audienceID` */
  allAccounts?: InputMaybe<Scalars['Boolean']>
  /** Check for conflicts assuming a hypothetical audience. Defaults to the Promotion's existing deals. */
  audienceID?: InputMaybe<Scalars['ID']>
  /** Check for conflicts with a hypothetical end date. Defaults to the Promotion's existing endDate. */
  endDate: Scalars['Timestamp']
  /** Check for conflicts with a hypothetical start date. Defaults to the Promotion's existing startDate. */
  startDate: Scalars['Timestamp']
}

export type PotentialPromotionConflictsResult = {
  __typename?: 'PotentialPromotionConflictsResult'
  nodes: Array<VendorProductPromotionConflict>
  totalCount: Scalars['Int']
}

export type PricingInfo = {
  __typename?: 'PricingInfo'
  casePrice?: Maybe<Scalars['Currency']>
  unitPrice?: Maybe<Scalars['Currency']>
}

export type Product = {
  __typename?: 'Product'
  /** All VendorProducts (across all accessible Vendors) matching this Product's UPCs */
  allVendorProducts: ProductAllVendorProductsResult
  brandName?: Maybe<Scalars['String']>
  caseUPC?: Maybe<Scalars['String']>
  category?: Maybe<Scalars['String']>
  /** @deprecated Use top-level MissScan resolvers */
  createdInApp?: Maybe<Scalars['String']>
  departmentName?: Maybe<Scalars['String']>
  description?: Maybe<Scalars['String']>
  id: Scalars['ID']
  imgURL?: Maybe<Scalars['String']>
  /** @deprecated Use top-level MissScan resolvers */
  isMissScan?: Maybe<Scalars['Boolean']>
  /** @deprecated Use top-level MissScan resolvers */
  missScanMethod?: Maybe<MissScanMethod>
  packUPC?: Maybe<Scalars['String']>
  unitUPC?: Maybe<Scalars['String']>
  unitUPCVariants?: Maybe<Array<Maybe<Scalars['String']>>>
  unitVolume?: Maybe<Scalars['String']>
  /** @deprecated Use unitUPC instead */
  upc?: Maybe<Scalars['String']>
}

export type ProductAllVendorProductsResult = {
  __typename?: 'ProductAllVendorProductsResult'
  nodes: Array<VendorProduct>
}

export type ProductLookupMetadata = {
  __typename?: 'ProductLookupMetadata'
  brandName?: Maybe<Scalars['String']>
  description?: Maybe<Scalars['String']>
  photoURL?: Maybe<Scalars['String']>
  unitVolume?: Maybe<Scalars['String']>
  upc: Scalars['String']
}

/**
 * ****************************
 *      Product Order History
 * ****************************
 */
export type ProductOrderHistory = {
  __typename?: 'ProductOrderHistory'
  order?: Maybe<Order>
  orderDateTime: Scalars['Timestamp']
  orderID: Scalars['ID']
  price: Scalars['Currency']
  quantity: Scalars['Int']
  unitOfMeasure: UnitOfMeasure
  vendorProduct?: Maybe<VendorProduct>
}

export type ProductOrderHistoryInput = {
  limit?: InputMaybe<Scalars['Int']>
  productID: Scalars['ID']
}

export type ProductOrderHistoryResult = {
  __typename?: 'ProductOrderHistoryResult'
  nodes: Array<ProductOrderHistory>
}

export type ProductSampleRequest = {
  __typename?: 'ProductSampleRequest'
  id: Scalars['ID']
  /** null if PSR hasn't been requested yet */
  requestedAt?: Maybe<Scalars['Timestamp']>
  /** null if PSR hasn't been requested yet */
  requestedByUser?: Maybe<User>
  status: SampleRequestStatus
  store: Store
  vendor: Vendor
}

export type ProductSamplesResult = {
  __typename?: 'ProductSamplesResult'
  nodes: Array<ProductSampleRequest>
}

export enum ProductSourceFilter {
  StoreSpecific = 'STORE_SPECIFIC',
  Wholesale = 'WHOLESALE',
}

export type Promotion = {
  __typename?: 'Promotion'
  /** A boolean flag that determines if the promotion is to be applied to all the vendor store accounts. When `true` this flag will override any value defined on the `Promotion.audience` field. */
  allAccounts?: Maybe<Scalars['Boolean']>
  audience?: Maybe<Audience>
  deals: DealsResults
  endDate?: Maybe<Scalars['Timestamp']>
  id: Scalars['ID']
  isPublished?: Maybe<Scalars['Boolean']>
  name?: Maybe<Scalars['String']>
  startDate?: Maybe<Scalars['Timestamp']>
  status: PromotionStatus
  totalSales: Scalars['Currency']
  vendor: Vendor
}

export enum PromotionStatus {
  Active = 'ACTIVE',
  Draft = 'DRAFT',
  Expired = 'EXPIRED',
  Upcoming = 'UPCOMING',
}

export type PromotionsResults = {
  __typename?: 'PromotionsResults'
  nodes: Array<Promotion>
}

export type ProspectiveStoresInput = {
  cursor?: InputMaybe<Scalars['String']>
  limit?: InputMaybe<Scalars['Int']>
}

export type ProspectiveStoresResults = {
  __typename?: 'ProspectiveStoresResults'
  cursor?: Maybe<Scalars['String']>
  hasMore?: Maybe<Scalars['Boolean']>
  nodes: Array<Store>
  totalCount?: Maybe<Scalars['Int']>
}

export type Query = {
  __typename?: 'Query'
  accountingIntegrationMappingConfiguration: AccountingIntegrationMappingConfig
  accountingIntegrationRecords: AccountingIntegrationRecords
  /** @deprecated allBanners is more efficient and includes pagination */
  adminAllBanners: BannersResult
  adminAllCatalogRequests: CatalogRequestsResult
  adminAllFeatureFlags?: Maybe<FeatureFlagsResult>
  adminAllOrders: OrdersResult
  adminAllProductSampleRequests: ProductSamplesResult
  /** @deprecated allStores is more efficient and includes pagination */
  adminAllStores: StoresResult
  adminAllUsers: UsersResult
  adminAllVendorInvitations: VendorInvitationsResult
  adminAllVendorStoreDepartmentAccounts: VendorStoreDepartmentAccountsResult
  /** @deprecated allVendors is more efficient and includes pagination */
  adminAllVendors: VendorsResult
  adminGetLegacyOrderGuideVendorProductsForUserAndVendor: VendorProductsByIDsResult
  adminSimilarStores: StoresResult
  adminStoreInvitations: StoreInvitationsResult
  adminStoreVendorProductsQuery: AdminStoreVendorProductsQueryResult
  adminStoreVendorsQuery: AdminStoreVendorsQueryResult
  adminStoresByID: AdminStoresResult
  adminUsersPaginated: UsersResult
  adminVendorInvitations: AdminVendorInvitationsResult
  adminVendorStoreDepartmentAccountsByID: AdminVendorStoreDepartmentAccountsResult
  adminVendorsByID: AdminVendorsResult
  allBanners: AllBannersResult
  allStores: AllStoresResult
  allVendors: AllVendorsResult
  bannerByID?: Maybe<Banner>
  bannerOrders: BannerOrdersResult
  bulkGetOrderStoreCountByVendorIDs: BulkGetOrderStoreCountByVendorIDsResult
  bulkGetVSDAsOrderGuides: V2OrderGuidesResult
  bulkSuggestStores: BulkSuggestStoresResult
  dealByID?: Maybe<Deal>
  /** Returns a CSV upload log based on the given ID. */
  getCSVUploadLogByID?: Maybe<CsvUploadLog>
  /**
   * Returns a list of CSV upload logs. If this query is executed by a vendor
   * admin, they will only be able to fetch for logs made to their catalog.
   */
  getCSVUploadLogs: GetCsvUploadLogsResult
  getCompanyFTPConfigs: CompanyFtpConfigResult
  /** Returns discontinued vendor products based on the given `retailCompanyID`. */
  getDiscontinuedVendorProductsForRetailCompany: GetDiscontinuedVendorProductsForRetailCompanyResult
  getEPLUMProductsForStoreQuery: Scalars['String']
  getESLConfig?: Maybe<GqleslConfig>
  getExploDashboardForUserQuery: ExploConfig
  getMatchingVendorProducts: GetMatchingVendorProductsResult
  getMetabaseDashboardForUserQuery: Scalars['String']
  /**
   * Returns new vendor products based on the given `retailCompanyID`. Vendor
   * products are considered new, when they have been created within the span of
   * 7 days.
   */
  getNewVendorProductsForRetailCompany: GetNewVendorProductsForRetailCompanyResult
  getOrderMispickByID?: Maybe<OrderMispick>
  getPointOfSaleIngestLogByID: PointOfSaleIngestLog
  getPointOfSaleIngestLogs: Array<PointOfSaleIngestLogMetaData>
  getStoreDepartmentByID?: Maybe<StoreDepartment>
  getStoreDepartmentsByStoreID?: Maybe<Array<Maybe<StoreDepartment>>>
  getUserAbandonedCarts: GetUserAbandonedCartsResult
  getVendorAbandonedCarts: GetVendorAbandonedCartsResult
  getVendorStoreDepartmentAccountByID?: Maybe<VendorStoreDepartmentAccount>
  getVendorStoreDepartmentAccountForVendor?: Maybe<VendorStoreDepartmentAccount>
  /** @deprecated Use getVendorStoreDepartmentAccountsForVendorAndStore */
  getVendorStoreDepartmentAccountForVendorAndStore?: Maybe<VendorStoreDepartmentAccount>
  getVendorStoreDepartmentAccountsForStore: VendorStoreDepartmentAccountResult
  /** @deprecated Use store.vendorStoreDepartmentAccounts */
  getVendorStoreDepartmentAccountsForStores: VendorStoreDepartmentAccountResult
  getVendorStoreDepartmentAccountsForVendorAndStore: VendorStoreDepartmentAccountResult
  inventoryHubLineItemByID: ReconciledLineItem
  inventoryHubOrderByID: Order
  inventoryHubOrdersByIDs: Array<Order>
  /** @deprecated We are moving away from operations that are specific to certain user types. Please use `queryInvoiceModuleInvoices` instead. */
  inventoryHubStoreAPOrdersQuery: InventoryHubOrdersViewConnection
  /** @deprecated We are moving away from operations that are specific to certain user types. Please use `queryInvoiceModuleOrders` instead. */
  inventoryHubStoreAdminOrdersQuery: InventoryHubOrdersViewConnection
  /** @deprecated We are moving away from operations that are specific to certain user types. Please use `queryInvoiceModuleOrders` instead. */
  inventoryHubStoreBuyerOrdersQuery: InventoryHubOrdersViewConnection
  me?: Maybe<Viewer>
  misscanByID?: Maybe<Misscan>
  misscanVendorProductByID?: Maybe<MisscanVendorProduct>
  orderByID?: Maybe<Order>
  orderByPO?: Maybe<Order>
  promotionByID?: Maybe<Promotion>
  /** Get list of deleted product ids. Provide deletedAfter flag to limit search */
  queryDeletedVendorProducts: Array<Scalars['ID']>
  /** @deprecated We are moving away from operations that are specific to certain user types. Please use `queryInvoiceModuleInvoiceLineItems` instead. */
  queryInventoryHubAPViewLineItems: ReconciledLineItemsConnection
  /** @deprecated We are moving away from operations that are specific to certain user types. Please use `queryInvoiceModuleOrderLineItems` instead. */
  queryInventoryHubBuyerViewLineItems: ReconciledLineItemsConnection
  queryInvoiceModuleInvoiceLineItems: ReconciledLineItemsConnection
  queryInvoiceModuleInvoices: InventoryHubOrdersViewConnection
  queryInvoiceModuleOrderLineItems: ReconciledLineItemsConnection
  queryInvoiceModuleOrders: InventoryHubOrdersViewConnection
  queryInvoices: Array<Invoice>
  queryMasterCatalogProductMetadataByBarcode?: Maybe<GqlMasterCatalogProductMetadata>
  queryOrderGuideProducts: VendorProductsQueryResult
  queryOrderGuideVendorProducts: VendorProductsQueryResult
  queryStoreProductByBarcode: Array<GqlStoreProduct>
  queryVendorStoreAccountProducts: VendorProductsQueryResult
  searchAllVendorProducts: SearchAllVendorProductsQueryResult
  searchStores: SearchStoresQueryResult
  searchVendors: SearchVendorsQueryResult
  /** Returns a list of all vendor accounts that available for store admins to access. */
  storeAdminVendors: StoreAdminVendorsResult
  storeByID?: Maybe<Store>
  storeDepartments: Array<StoreDepartment>
  storeDepartmentsForCompany: StoreDepartmentViewConnection
  storeInvitation?: Maybe<StoreInvitation>
  /** @deprecated Use store.orders instead */
  storeOrders: StoreOrdersResult
  storeVendor: GqlStoreVendor
  storeVendors: Array<GqlStoreVendor>
  storesForCompany: StoreViewConnection
  /** Allow searching existing stores that might be relevant to a vendor */
  suggestStores: SuggestStoresResult
  taxRate: GqlTaxRate
  taxRates: Array<GqlTaxRate>
  userByID?: Maybe<User>
  /** Use to validate a csv for store vendor product upload */
  validateBulkUploadStoreVendorProducts: Array<ValidateBulkUploadStoreVendorProductsResult>
  /** Use to validate a csv for vendor catalog upload */
  validateBulkUploadVendorProducts: Array<ValidateBulkUploadVendorProductsResult>
  /** Returns a list of all duplicate invitation order guide names */
  validateInvitationOrderGuideNames?: Maybe<ValidateInvitationOrderGuideNamesResult>
  vendorByID?: Maybe<Vendor>
  /** Return vendors matching the passed-in URL slug. If no Vendors match, falls back to treating the input as an ID. */
  vendorBySlug?: Maybe<Vendor>
  vendorForVendorUser?: Maybe<Vendor>
  vendorOrders: VendorOrdersResult
  vendorProductByID?: Maybe<VendorProduct>
  vendorProductByUPC: VendorProductsResult
  vendorProductSuggestionsByUPC: VendorProductSuggestionsResult
  vendorProducts: VendorProductsResult
  vendorProductsByIDs?: Maybe<VendorProductsByIDsResult>
  vendorStoreAccountProductsByUpdateTime: VendorProductsResult
  vendorStoreDepartmentAccountsForCompany: VsdaViewConnection
  vendorsForCompany: VendorViewConnection
}

export type QueryAccountingIntegrationRecordsArgs = {
  input: AccountingIntegrationRecordsInput
}

export type QueryAdminAllBannersArgs = {
  posBannersOnly?: InputMaybe<Scalars['Boolean']>
}

export type QueryAdminAllOrdersArgs = {
  input?: InputMaybe<AdminAllOrdersInput>
}

export type QueryAdminAllStoresArgs = {
  input?: InputMaybe<AdminAllStoresInput>
  posStoresOnly?: InputMaybe<Scalars['Boolean']>
}

export type QueryAdminAllUsersArgs = {
  input?: InputMaybe<AdminAllUsersInput>
}

export type QueryAdminAllVendorStoreDepartmentAccountsArgs = {
  input?: InputMaybe<VendorStoreDepartmentAccountsInput>
}

export type QueryAdminGetLegacyOrderGuideVendorProductsForUserAndVendorArgs = {
  userID: Scalars['ID']
  vendorID: Scalars['ID']
}

export type QueryAdminSimilarStoresArgs = {
  input: AdminSimilarStoresInput
}

export type QueryAdminStoreInvitationsArgs = {
  input?: InputMaybe<AdminStoreInvitationsInput>
}

export type QueryAdminStoreVendorProductsQueryArgs = {
  input: StoreVendorProductsQueryInput
}

export type QueryAdminStoreVendorsQueryArgs = {
  input: StoreVendorsQueryInput
}

export type QueryAdminStoresByIdArgs = {
  ids: Array<Scalars['ID']>
}

export type QueryAdminUsersPaginatedArgs = {
  input?: InputMaybe<AdminUsersPaginatedInput>
}

export type QueryAdminVendorInvitationsArgs = {
  input?: InputMaybe<AdminVendorInvitationsInput>
}

export type QueryAdminVendorStoreDepartmentAccountsByIdArgs = {
  ids: Array<Scalars['ID']>
}

export type QueryAdminVendorsByIdArgs = {
  ids: Array<Scalars['ID']>
}

export type QueryAllBannersArgs = {
  input?: InputMaybe<PaginatedInput>
}

export type QueryAllStoresArgs = {
  input?: InputMaybe<PaginatedInput>
}

export type QueryAllVendorsArgs = {
  filterStoreVendors?: InputMaybe<Scalars['Boolean']>
  input?: InputMaybe<PaginatedInput>
}

export type QueryBannerByIdArgs = {
  id: Scalars['ID']
}

export type QueryBannerOrdersArgs = {
  input: BannerOrdersInputRoot
}

export type QueryBulkGetOrderStoreCountByVendorIDsArgs = {
  vendorIDs: Array<Scalars['ID']>
}

export type QueryBulkGetVsdAsOrderGuidesArgs = {
  input: BulkGetVsdAsOrderGuidesInput
}

export type QueryBulkSuggestStoresArgs = {
  input: BulkSuggestStoresInput
}

export type QueryDealByIdArgs = {
  id: Scalars['ID']
}

export type QueryGetCsvUploadLogByIdArgs = {
  id: Scalars['ID']
}

export type QueryGetCsvUploadLogsArgs = {
  input?: InputMaybe<GetCsvUploadLogsInput>
}

export type QueryGetCompanyFtpConfigsArgs = {
  companyID?: InputMaybe<Scalars['String']>
}

export type QueryGetDiscontinuedVendorProductsForRetailCompanyArgs = {
  input: GetDiscontinuedVendorProductsForRetailCompanyInput
}

export type QueryGetEplumProductsForStoreQueryArgs = {
  storeID: Scalars['String']
}

export type QueryGetEslConfigArgs = {
  input: EslConfigInput
}

export type QueryGetMatchingVendorProductsArgs = {
  input: GetMatchingVendorProductsInput
}

export type QueryGetNewVendorProductsForRetailCompanyArgs = {
  input: GetNewVendorProductsForRetailCompanyInput
}

export type QueryGetOrderMispickByIdArgs = {
  id: Scalars['ID']
}

export type QueryGetPointOfSaleIngestLogByIdArgs = {
  id: Scalars['ID']
}

export type QueryGetPointOfSaleIngestLogsArgs = {
  filterOutUploaded: Scalars['Boolean']
  forBannerID?: InputMaybe<Scalars['String']>
  forStoreID?: InputMaybe<Scalars['String']>
}

export type QueryGetStoreDepartmentByIdArgs = {
  id: Scalars['ID']
}

export type QueryGetStoreDepartmentsByStoreIdArgs = {
  id: Scalars['ID']
}

export type QueryGetUserAbandonedCartsArgs = {
  input?: InputMaybe<GetUserAbandonedCartsInput>
}

export type QueryGetVendorAbandonedCartsArgs = {
  input?: InputMaybe<GetVendorAbandonedCartsInput>
}

export type QueryGetVendorStoreDepartmentAccountByIdArgs = {
  id: Scalars['ID']
}

export type QueryGetVendorStoreDepartmentAccountForVendorArgs = {
  storeDepartmentID: Scalars['ID']
  vendorID: Scalars['ID']
}

export type QueryGetVendorStoreDepartmentAccountForVendorAndStoreArgs = {
  storeID: Scalars['ID']
  vendorID: Scalars['ID']
}

export type QueryGetVendorStoreDepartmentAccountsForStoreArgs = {
  filterByStatus?: InputMaybe<VendorStoreDepartmentAccountStatus>
  includeInactive?: InputMaybe<Scalars['Boolean']>
  storeID: Scalars['ID']
}

export type QueryGetVendorStoreDepartmentAccountsForStoresArgs = {
  storeIDs: Array<Scalars['ID']>
}

export type QueryGetVendorStoreDepartmentAccountsForVendorAndStoreArgs = {
  storeID: Scalars['ID']
  vendorID: Scalars['ID']
}

export type QueryInventoryHubLineItemByIdArgs = {
  id: Scalars['ID']
}

export type QueryInventoryHubOrderByIdArgs = {
  id: Scalars['ID']
}

export type QueryInventoryHubOrdersByIDsArgs = {
  ids: Array<Scalars['ID']>
}

export type QueryInventoryHubStoreApOrdersQueryArgs = {
  input: InventoryHubOrderQueryInput
}

export type QueryInventoryHubStoreAdminOrdersQueryArgs = {
  input: InventoryHubOrderQueryInput
}

export type QueryInventoryHubStoreBuyerOrdersQueryArgs = {
  input: InventoryHubOrderQueryInput
}

export type QueryMeArgs = {
  input?: InputMaybe<MeQueryInput>
}

export type QueryMisscanByIdArgs = {
  id: Scalars['ID']
}

export type QueryMisscanVendorProductByIdArgs = {
  id: Scalars['ID']
}

export type QueryOrderByIdArgs = {
  id: Scalars['ID']
}

export type QueryOrderByPoArgs = {
  poNum: Scalars['String']
}

export type QueryPromotionByIdArgs = {
  id: Scalars['ID']
}

export type QueryQueryDeletedVendorProductsArgs = {
  input?: InputMaybe<DeletedVendorProductsInput>
}

export type QueryQueryInventoryHubApViewLineItemsArgs = {
  input: ReconciledLineItemConnectionInput
}

export type QueryQueryInventoryHubBuyerViewLineItemsArgs = {
  input: ReconciledLineItemConnectionInput
}

export type QueryQueryInvoiceModuleInvoiceLineItemsArgs = {
  input: ReconciledLineItemConnectionInput
}

export type QueryQueryInvoiceModuleInvoicesArgs = {
  input: InventoryHubOrderQueryInput
}

export type QueryQueryInvoiceModuleOrderLineItemsArgs = {
  input: ReconciledLineItemConnectionInput
}

export type QueryQueryInvoiceModuleOrdersArgs = {
  input: InventoryHubOrderQueryInput
}

export type QueryQueryMasterCatalogProductMetadataByBarcodeArgs = {
  barcode: Scalars['String']
}

export type QueryQueryOrderGuideProductsArgs = {
  input: OrderGuideProductsQueryInput
}

export type QueryQueryOrderGuideVendorProductsArgs = {
  input: OrderGuideVendorProductsQueryInput
}

export type QueryQueryStoreProductByBarcodeArgs = {
  barcode: Scalars['String']
  filterByStoreSQLIDs?: InputMaybe<Array<Scalars['String']>>
}

export type QueryQueryVendorStoreAccountProductsArgs = {
  input: VendorStoreProductsQueryInput
}

export type QuerySearchAllVendorProductsArgs = {
  input: UniversalVendorProductsQueryInput
}

export type QuerySearchStoresArgs = {
  input: SearchStoresQueryInput
}

export type QuerySearchVendorsArgs = {
  input: SearchVendorsQueryInput
}

export type QueryStoreAdminVendorsArgs = {
  input?: InputMaybe<StoreAdminVendorsInput>
}

export type QueryStoreByIdArgs = {
  id: Scalars['ID']
}

export type QueryStoreDepartmentsArgs = {
  data: GetStoreDepartmentsInput
}

export type QueryStoreDepartmentsForCompanyArgs = {
  input: StoreDepartmentQueryInput
}

export type QueryStoreInvitationArgs = {
  invitationCode: Scalars['String']
}

export type QueryStoreOrdersArgs = {
  input: StoreOrdersInput
}

export type QueryStoreVendorArgs = {
  id: Scalars['String']
}

export type QueryStoresForCompanyArgs = {
  input: StoreQueryInput
}

export type QuerySuggestStoresArgs = {
  input: SuggestStoresInput
}

export type QueryTaxRateArgs = {
  id: Scalars['String']
}

export type QueryUserByIdArgs = {
  id: Scalars['ID']
}

export type QueryValidateBulkUploadStoreVendorProductsArgs = {
  inputProducts: Array<BulkStoreVendorProductInput>
  storeSQLIDs: Array<Scalars['ID']>
}

export type QueryValidateBulkUploadVendorProductsArgs = {
  inputProducts: Array<BulkVendorProductInput>
  isMultiVendorUpload: Scalars['Boolean']
  vendorIDForSingleVendorValidation?: InputMaybe<Scalars['String']>
}

export type QueryValidateInvitationOrderGuideNamesArgs = {
  orderGuideNames: Array<Scalars['String']>
  vendorID: Scalars['ID']
}

export type QueryVendorByIdArgs = {
  id: Scalars['ID']
}

export type QueryVendorBySlugArgs = {
  slugOrID?: InputMaybe<Scalars['String']>
}

export type QueryVendorForVendorUserArgs = {
  userID: Scalars['ID']
}

export type QueryVendorOrdersArgs = {
  input: VendorOrdersInput
}

export type QueryVendorProductByIdArgs = {
  id: Scalars['String']
  storeID?: InputMaybe<Scalars['String']>
  vendorID: Scalars['String']
}

export type QueryVendorProductByUpcArgs = {
  storeID?: InputMaybe<Scalars['String']>
  upc: Scalars['String']
  vendorID: Scalars['String']
}

export type QueryVendorProductSuggestionsByUpcArgs = {
  input: VendorProductSuggestionsInput
}

export type QueryVendorProductsArgs = {
  input?: InputMaybe<GetVendorProductsInput>
}

export type QueryVendorProductsByIDsArgs = {
  input: VendorProductsByIDsInput
}

export type QueryVendorStoreAccountProductsByUpdateTimeArgs = {
  input: VendorStoreAccountProductsByUpdateTimeInput
}

export type QueryVendorStoreDepartmentAccountsForCompanyArgs = {
  input: VsdaQueryInput
}

export type QueryVendorsForCompanyArgs = {
  input: VendorQueryInput
}

export type ReceivingLineItemIssue = GqlLineItemIssueBase & {
  __typename?: 'ReceivingLineItemIssue'
  createdAt: Scalars['DateTime']
  createdBy: Scalars['String']
  creditRequest?: Maybe<CreditRequest>
  details: Scalars['String']
  id: Scalars['ID']
  imgURLs: Array<Scalars['String']>
  quantity: Scalars['Float']
  status: OrderReceivingLineItemStatus
  userName?: Maybe<Scalars['String']>
  userType?: Maybe<Scalars['String']>
}

export enum ReceivingUnitOfMeasure {
  Case = 'CASE',
  Each = 'EACH',
}

export type ReconciledLineItem = {
  __typename?: 'ReconciledLineItem'
  description: Scalars['String']
  id: Scalars['ID']
  /** Product Image URL */
  imgURL: Scalars['String']
  issue?: Maybe<ReceivingLineItemIssue>
  itemCode: Scalars['String']
  packSize: Scalars['String']
  price: Money
  quantity: Scalars['String']
  status: ReconciledLineItemStatus
  total: Money
  unitOfMeasure: UnitOfMeasure
  upc: Scalars['String']
}

export type ReconciledLineItemConnectionInput = {
  after?: InputMaybe<Scalars['Cursor']>
  first: Scalars['Int']
  orderID: Scalars['ID']
  status?: InputMaybe<ReconciledLineItemStatus>
}

export type ReconciledLineItemEdge = {
  __typename?: 'ReconciledLineItemEdge'
  cursor: Scalars['String']
  node: ReconciledLineItem
}

export enum ReconciledLineItemStatus {
  Accurate = 'ACCURATE',
  Invoiced = 'INVOICED',
  Issue = 'ISSUE',
  Ordered = 'ORDERED',
  Unfulfilled = 'UNFULFILLED',
}

export type ReconciledLineItemsConnection = {
  __typename?: 'ReconciledLineItemsConnection'
  creditRequested: Money
  edges: Array<ReconciledLineItemEdge>
  pageInfo: PageInfo
  statusCounts: Array<GqlLineItemStatusCount>
  totalCount: Scalars['Float']
}

export type RemoveProductsFromOrderGuideInput = {
  productIDs: Array<Scalars['ID']>
  storeID: Scalars['ID']
  /** Optional: which user's OrderGuide to update. If not provided, this mutation defaults to the authenticated user. */
  userID?: InputMaybe<Scalars['ID']>
  vendorID: Scalars['ID']
}

export type RemoveProductsFromV2OrderGuideForStoreDepartmentInput = {
  storeDepartmentID: Scalars['ID']
  vendorProductIDs: Array<Scalars['ID']>
}

export type RemoveProductsFromV2OrderGuideInput = {
  vendorProductIDs: Array<Scalars['ID']>
  vendorStoreDepartmentAccountID: Scalars['ID']
}

export type RemoveProductsFromV2OrderGuideResult = {
  __typename?: 'RemoveProductsFromV2OrderGuideResult'
  orderGuide: V2OrderGuide
  removedVendorProducts: Array<VendorProduct>
}

export type RequestCatalogInput = {
  storeID: Scalars['ID']
  vendorID: Scalars['ID']
}

export type RequestInvoiceForOrderMutationInput = {
  orderID: Scalars['ID']
}

export type RestoreOrderGuideInput = {
  id: Scalars['String']
  timestamp: Scalars['String']
}

export type RetailCompany = {
  __typename?: 'RetailCompany'
  banner?: Maybe<Banner>
  id: Scalars['ID']
  /** Shorthand for banner name or store name, whichever is applicable */
  name?: Maybe<Scalars['String']>
  retailUsers: RetailUsersResult
  store?: Maybe<Store>
}

export type RetailUser = {
  __typename?: 'RetailUser'
  allOrderGuideProducts: AllOrderGuideProductsResult
  /** @deprecated Use storeDepartments instead */
  departments: DepartmentsResult
  /** The last order placed by this user */
  lastOrder?: Maybe<Order>
  /** @deprecated Use v2 order guide resolvers */
  orderGuideByAccount: OrderGuide
  /** @deprecated Use v2 order guide resolvers */
  orderGuidesByAccount: RetailUserOrderGuidesResult
  /** A boolean flag that indicates if the buyer can only read order guides. */
  readOnlyOrderGuides?: Maybe<Scalars['Boolean']>
  retailCompany: RetailCompany
  storeDepartments: StoreDepartmentsResult
  user: User
  userStoreDepartments: UserStoreDepartmentsResult
  /** @deprecated Use vendorStoreDepartmentAccounts instead */
  vendorAccounts: VendorStoreAccountsResult
  vendorStoreDepartmentAccounts: VendorStoreDepartmentAccountsResult
  /** Returns the total amount spent in placed orders by the user in the current week (starting from Sunday) */
  weeklyOrderSpending: Scalars['Currency']
  /** Returns all orders placed by the user in the current week (starting from Sunday) */
  weeklyOrders: Array<Order>
}

export type RetailUserAllOrderGuideProductsArgs = {
  input?: InputMaybe<AllOrderGuideProductsInput>
}

export type RetailUserLastOrderArgs = {
  storeID: Scalars['ID']
}

export type RetailUserOrderGuideByAccountArgs = {
  input: RetailUserOrderGuideInput
}

export type RetailUserOrderGuidesByAccountArgs = {
  input: RetailUserOrderGuidesInput
}

export type RetailUserVendorAccountsArgs = {
  input?: InputMaybe<VendorStoreAccountInput>
}

export type RetailUserVendorStoreDepartmentAccountsArgs = {
  input?: InputMaybe<VendorStoreDepartmentAccountInput>
}

export type RetailUserWeeklyOrderSpendingArgs = {
  storeID: Scalars['ID']
}

export type RetailUserWeeklyOrdersArgs = {
  storeID: Scalars['ID']
}

export type RetailUserOrderGuideInput = {
  cursor?: InputMaybe<Scalars['ID']>
  limit?: InputMaybe<Scalars['Int']>
  vendorID: Scalars['ID']
}

export type RetailUserOrderGuidesInput = {
  cursor?: InputMaybe<Scalars['ID']>
  limit?: InputMaybe<Scalars['Int']>
  vendorIDs: Array<Scalars['ID']>
}

export type RetailUserOrderGuidesResult = {
  __typename?: 'RetailUserOrderGuidesResult'
  nodes: Array<OrderGuide>
}

export type RetailUsersResult = {
  __typename?: 'RetailUsersResult'
  nodes: Array<RetailUser>
  totalCount: Scalars['Int']
}

export type RetailerDiscontinuedDate = {
  __typename?: 'RetailerDiscontinuedDate'
  date?: Maybe<Scalars['Timestamp']>
  retailCompany: RetailCompany
}

export type RetailerDiscontinuedDateInput = {
  date?: InputMaybe<Scalars['Timestamp']>
  retailerID: Scalars['String']
}

export type RetailerPricingInfo = {
  __typename?: 'RetailerPricingInfo'
  pricing: PricingInfo
  retailCompany: RetailCompany
}

export type RetailerVendorProductPriceResult = {
  __typename?: 'RetailerVendorProductPriceResult'
  price: Scalars['Currency']
}

export type SftpConnectionGql = {
  __typename?: 'SFTPConnectionGQL'
  bannerID?: Maybe<Scalars['String']>
  description: Scalars['String']
  direction: Scalars['String']
  id: Scalars['String']
  path: Scalars['String']
  resolvedPath: Scalars['String']
  storeID?: Maybe<Scalars['String']>
  userID: Scalars['String']
  vendorID?: Maybe<Scalars['String']>
}

export enum SftpFileType {
  Edi = 'EDI',
  Flat = 'FLAT',
}

export type SftpUser = {
  __typename?: 'SFTPUser'
  id: Scalars['Int']
  status: Scalars['Int']
  username: Scalars['String']
}

export type SftpUserGql = {
  __typename?: 'SFTPUserGQL'
  description?: Maybe<Scalars['String']>
  id: Scalars['String']
  userName: Scalars['String']
  userType: Scalars['String']
}

export enum SampleRequestStatus {
  Available = 'AVAILABLE',
  Requested = 'REQUESTED',
}

export type SearchAllVendorProductsQueryResult = {
  __typename?: 'SearchAllVendorProductsQueryResult'
  cursor: Scalars['ID']
  hasMore: Scalars['Boolean']
  nodes: Array<UniversalProductSearchItem>
  searchID: Scalars['String']
  totalCount: Scalars['Int']
}

export type SearchStoresQueryInput = {
  filterByUserAccountList?: InputMaybe<Scalars['Boolean']>
  limit?: InputMaybe<Scalars['Int']>
  pagination?: InputMaybe<PaginationInput>
  search: Scalars['String']
}

export type SearchStoresQueryResult = {
  __typename?: 'SearchStoresQueryResult'
  cursor?: Maybe<Scalars['ID']>
  hasMore: Scalars['Boolean']
  nodes: Array<Store>
  totalCount: Scalars['Int']
}

/**
 * ****************************
 *       Search
 * ****************************
 */
export type SearchVendorsQueryInput = {
  limit?: InputMaybe<Scalars['Int']>
  pagination?: InputMaybe<PaginationInput>
  search: Scalars['String']
}

export type SearchVendorsQueryResult = {
  __typename?: 'SearchVendorsQueryResult'
  cursor?: Maybe<Scalars['ID']>
  hasMore: Scalars['Boolean']
  nodes: Array<Vendor>
  totalCount: Scalars['Int']
}

export type SendBulkVendorInvitationInput = {
  email: Scalars['String']
  vendorID: Scalars['ID']
}

export type SendCreatePaymentProfileEmailInput = {
  adminFirstName?: InputMaybe<Scalars['String']>
  bannerID?: InputMaybe<Scalars['String']>
  deviceBillingInfo?: InputMaybe<DeviceBillingInfoInput>
  email?: InputMaybe<Scalars['String']>
  name?: InputMaybe<Scalars['String']>
  orderBillingInfo?: InputMaybe<OrderBillingInfoInput>
  setupFee?: InputMaybe<SetupFeeInput>
  storeID?: InputMaybe<Scalars['String']>
  userID?: InputMaybe<Scalars['String']>
  vendorID?: InputMaybe<Scalars['String']>
}

export type SendCreatePaymentProfileEmailResult = {
  __typename?: 'SendCreatePaymentProfileEmailResult'
  email: Scalars['String']
  token: Scalars['String']
}

export type SendEslFileRefreshInput = {
  storeIDs: Array<Scalars['String']>
  type: EslType
}

export type SendEslFileUpdateInput = {
  file: Scalars['Upload']
  storeIDs: Array<Scalars['String']>
  type: EslType
}

export enum SendEslFileUpdateLogStatus {
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Success = 'SUCCESS',
}

export type SendEslFileUpdateResult = {
  __typename?: 'SendESLFileUpdateResult'
  status: SendEslFileUpdateLogStatus
  statusMessage: Scalars['String']
}

export type SendVendorInvitationInput = {
  email: Scalars['String']
  invitedByStoreID: Scalars['ID']
  /** Must be a STORE_ADMIN or BUYER user matching the store referenced by invitedByStoreID */
  invitedByUserID: Scalars['ID']
  vendorID: Scalars['ID']
}

export type SetupFeeInput = {
  cost: Scalars['Currency']
}

export enum SortingDirection {
  Asc = 'ASC',
  Desc = 'DESC',
}

export type Store = {
  __typename?: 'Store'
  acquisitionDetail?: Maybe<Scalars['String']>
  acquisitionSource?: Maybe<AcquisitionSource>
  address?: Maybe<Scalars['String']>
  addressComponents?: Maybe<AddressComponents>
  authorizedVendors: VendorsResult
  banner?: Maybe<Banner>
  bannerStoreID?: Maybe<Scalars['String']>
  buyerUsers: BuyerUsersResult
  /** @deprecated Use storeDepartments instead */
  departments: DepartmentsResult
  discoverableVendors: VendorsResult
  emails: Array<Scalars['String']>
  firestoreID?: Maybe<Scalars['ID']>
  geographicCoordinates?: Maybe<Scalars['String']>
  id: Scalars['ID']
  imageURL?: Maybe<Scalars['String']>
  local_iana_timezone?: Maybe<Scalars['String']>
  name?: Maybe<Scalars['String']>
  orders: StoreOrdersResult
  paymentProfile?: Maybe<PaymentProfile>
  placeID?: Maybe<Scalars['String']>
  productOrderHistory: ProductOrderHistoryResult
  productSampleRequests: ProductSamplesResult
  referredByCompany?: Maybe<Company>
  regionalVendors: VendorsResult
  /** Returns a specific retailUser given a user ID. */
  retailUserByID?: Maybe<RetailUser>
  retailUsers: RetailUsersResult
  serialID?: Maybe<Scalars['ID']>
  storeDepartments: StoreDepartmentsResult
  storeReceivers: Array<StoreReceiver>
  storeType: StoreType
  /** @deprecated Use suggestedVendors on storeDepartments instead */
  suggestedVendors: VendorsResult
  supports_wic: Scalars['Boolean']
  userCount: Scalars['Int']
  /** @deprecated Use vendorStoreDepartmentAccounts instead */
  vendorAccountByVendorID?: Maybe<VendorStoreAccount>
  /** @deprecated Use vendorStoreDepartmentAccounts instead */
  vendorAccounts: VendorStoreAccountsResult
  vendorCount: Scalars['Int']
  vendorProducts: VendorProductsResult
  /** Returns a list of all the store's VendorStoreDepartmentAccounts */
  vendorStoreDepartmentAccounts: StoreVendorStoreDepartmentAccountsResult
  /** Returns a deduped list of Vendors based on all the store's VendorStoreDepartmentAccounts. */
  vendors: StoreVendorsResult
  visibleVendors: VendorsResult
}

export type StoreAuthorizedVendorsArgs = {
  input?: InputMaybe<AuthorizedVendorsInput>
}

export type StoreBuyerUsersArgs = {
  input?: InputMaybe<BuyerUsersInput>
}

export type StoreDiscoverableVendorsArgs = {
  input?: InputMaybe<DiscoverableVendorsInput>
}

export type StoreOrdersArgs = {
  input: StoreSpecificOrdersInput
}

export type StoreProductOrderHistoryArgs = {
  input: ProductOrderHistoryInput
}

export type StoreRetailUserByIdArgs = {
  id: Scalars['ID']
}

export type StoreRetailUsersArgs = {
  input?: InputMaybe<StoreRetailUsersInput>
}

export type StoreSuggestedVendorsArgs = {
  input?: InputMaybe<SuggestedVendorsInput>
}

export type StoreVendorAccountByVendorIdArgs = {
  vendorID: Scalars['ID']
}

export type StoreVendorAccountsArgs = {
  input?: InputMaybe<VendorStoreAccountInput>
}

export type StoreVendorProductsArgs = {
  input?: InputMaybe<VendorProductsInput>
}

export type StoreVendorStoreDepartmentAccountsArgs = {
  input?: InputMaybe<StoreVendorStoreDepartmentAccountsInput>
}

export type StoreVendorsArgs = {
  input?: InputMaybe<StoreVendorsInput>
}

export type StoreAdminVendorsInput = {
  limit?: InputMaybe<Scalars['Int']>
  pagination?: InputMaybe<PaginationInput>
  search?: InputMaybe<Scalars['String']>
}

export type StoreAdminVendorsResult = {
  __typename?: 'StoreAdminVendorsResult'
  cursor?: Maybe<Scalars['ID']>
  hasMore?: Maybe<Scalars['Boolean']>
  nodes: Array<Vendor>
}

export type StoreDepartment = {
  __typename?: 'StoreDepartment'
  buyerUsers: BuyerUsersResult
  deactivatedAt?: Maybe<Scalars['DateTime']>
  discoverableVendors: VendorsResult
  email?: Maybe<Scalars['String']>
  excludeFromSalesReporting: Scalars['Boolean']
  id: Scalars['ID']
  imageURL?: Maybe<Scalars['String']>
  name: Scalars['String']
  orderGuideVendorProductIDs: OrderGuideVendorProductIDsResult
  orders: StoreDepartmentOrdersResult
  parentDepartment?: Maybe<StoreDepartment>
  productCount: Scalars['Int']
  store: Store
  storeID: Scalars['String']
  subDepartments?: Maybe<Array<StoreDepartment>>
  suggestedCarts: StoreDepartmentSuggestedCartsResult
  suggestedVendors: VendorsResult
  totalBuyerCount?: Maybe<Scalars['Int']>
  totalVendorCount?: Maybe<Scalars['Int']>
  vendorStoreDepartmentAccounts: VendorStoreDepartmentAccountResult
}

export type StoreDepartmentBuyerUsersArgs = {
  input?: InputMaybe<BuyerUsersInput>
}

export type StoreDepartmentDiscoverableVendorsArgs = {
  input?: InputMaybe<DiscoverableVendorsInput>
}

export type StoreDepartmentOrderGuideVendorProductIDsArgs = {
  cursor?: InputMaybe<Scalars['String']>
  limit?: InputMaybe<Scalars['Int']>
}

export type StoreDepartmentOrdersArgs = {
  input?: InputMaybe<StoreDepartmentOrdersInput>
}

export type StoreDepartmentSuggestedCartsArgs = {
  input?: InputMaybe<StoreDepartmentSuggestedCartsInput>
}

export type StoreDepartmentSuggestedVendorsArgs = {
  input?: InputMaybe<SuggestedVendorsInput>
}

export type StoreDepartmentVendorStoreDepartmentAccountsArgs = {
  input?: InputMaybe<VendorStoreDepartmentAccountsInput>
}

export type StoreDepartmentEdge = {
  __typename?: 'StoreDepartmentEdge'
  cursor: Scalars['Cursor']
  node: StoreDepartment
}

export type StoreDepartmentOrdersInput = {
  filterByVendor?: InputMaybe<Scalars['ID']>
  limit?: InputMaybe<Scalars['Int']>
  pagination?: InputMaybe<PaginationInput>
}

export type StoreDepartmentOrdersResult = {
  __typename?: 'StoreDepartmentOrdersResult'
  cursor?: Maybe<Scalars['ID']>
  hasMore?: Maybe<Scalars['Boolean']>
  nodes: Array<Order>
}

export type StoreDepartmentQueryInput = {
  after?: InputMaybe<Scalars['Cursor']>
  first: Scalars['Int']
  storeIDs?: InputMaybe<Array<Scalars['ID']>>
}

export type StoreDepartmentSuggestedCartsInput = {
  vendorID?: InputMaybe<Scalars['ID']>
}

export type StoreDepartmentSuggestedCartsResult = {
  __typename?: 'StoreDepartmentSuggestedCartsResult'
  nodes: Array<SuggestedCart>
}

export type StoreDepartmentViewConnection = {
  __typename?: 'StoreDepartmentViewConnection'
  edges: Array<StoreDepartmentEdge>
  pageInfo: PageInfo
}

export type StoreDepartmentsResult = {
  __typename?: 'StoreDepartmentsResult'
  nodes: Array<StoreDepartment>
}

export type StoreEdge = {
  __typename?: 'StoreEdge'
  cursor: Scalars['Cursor']
  node: Store
}

export type StoreEmail = {
  __typename?: 'StoreEmail'
  email: Scalars['String']
}

export type StoreEmailInput = {
  email: Scalars['String']
}

export type StoreInput = {
  cursor?: InputMaybe<Scalars['String']>
  limit?: InputMaybe<Scalars['Int']>
  query?: InputMaybe<Scalars['String']>
}

export type StoreInvitation = {
  __typename?: 'StoreInvitation'
  email: Scalars['String']
  /** ID is identical to the invitation code */
  id?: Maybe<Scalars['ID']>
  invitedByUser?: Maybe<User>
  invitedByVendor?: Maybe<Vendor>
  lastOrderPlaced?: Maybe<Order>
  signedUpEmail?: Maybe<Scalars['String']>
  status: InvitationStatus
  store: Store
}

export type StoreInvitationsResult = {
  __typename?: 'StoreInvitationsResult'
  cursor?: Maybe<Scalars['ID']>
  hasMore: Scalars['Boolean']
  nodes: Array<StoreInvitation>
  totalCount: Scalars['Int']
}

export type StoreInviteInput = {
  accountNum: Scalars['String']
  address: Scalars['String']
  defaultDepartmentName: DepartmentName
  email: Scalars['String']
  name: Scalars['String']
  orderGuideProductIDs?: InputMaybe<Array<Scalars['String']>>
  phoneNum?: InputMaybe<Scalars['String']>
}

export type StoreOrdersFilterInput = {
  hasInvoice?: InputMaybe<Scalars['Boolean']>
  placedInTheLastWeek?: InputMaybe<Scalars['Boolean']>
  receivingStatuses?: InputMaybe<Array<OrderReceivingStatus>>
  storeDepartmentIDs?: InputMaybe<Array<Scalars['ID']>>
  vendorIDs?: InputMaybe<Array<Scalars['ID']>>
}

export type StoreOrdersInput = {
  filterByThisWeek?: InputMaybe<Scalars['Boolean']>
  filterByVendor?: InputMaybe<Scalars['ID']>
  limit?: InputMaybe<Scalars['Int']>
  pagination?: InputMaybe<PaginationInput>
  storeID: Scalars['ID']
}

export type StoreOrdersResult = {
  __typename?: 'StoreOrdersResult'
  cursor?: Maybe<Scalars['ID']>
  hasMore?: Maybe<Scalars['Boolean']>
  nodes: Array<Order>
}

export enum StoreProductPriceInputMethod {
  ManuallyEnteredPrice = 'MANUALLY_ENTERED_PRICE',
  UsedSuggestedPrice = 'USED_SUGGESTED_PRICE',
}

export enum StoreProductPriceSource {
  AcceptedCostChange = 'ACCEPTED_COST_CHANGE',
  BulkUpdate = 'BULK_UPDATE',
  ProductDetails = 'PRODUCT_DETAILS',
}

export enum StoreProductPriceSourcePlatform {
  Mobile = 'MOBILE',
  Web = 'WEB',
}

export type StoreQueryInput = {
  after?: InputMaybe<Scalars['Cursor']>
  first: Scalars['Int']
  storeIDs?: InputMaybe<Array<Scalars['ID']>>
}

export type StoreReceiver = {
  __typename?: 'StoreReceiver'
  createdByUser?: Maybe<User>
  user: User
}

export type StoreReceiverUser = {
  __typename?: 'StoreReceiverUser'
  stores: StoresResult
}

export type StoreRetailUsersInput = {
  departmentNames?: InputMaybe<Array<DepartmentName>>
  query?: InputMaybe<Scalars['String']>
  userTypes?: InputMaybe<Array<UserType>>
}

export type StoreSpecificOrdersInput = {
  filter?: InputMaybe<StoreOrdersFilterInput>
  /** Deprecated: Use placedInTheLastWeek in filter field */
  filterByThisWeek?: InputMaybe<Scalars['Boolean']>
  /** Deprecated: Use vendorIDs in filter field */
  filterByVendor?: InputMaybe<Scalars['ID']>
  limit?: InputMaybe<Scalars['Int']>
  pagination?: InputMaybe<PaginationInput>
  /** Deprecated: Use receivingStatuses in filter field */
  receivingStatus?: InputMaybe<OrderReceivingStatus>
  /** Deprecated: Use vendorIDs in filter field */
  storeDepartmentID?: InputMaybe<Scalars['ID']>
}

export enum StoreSuggestionType {
  /** The store exists, but the querying vendor does not have an account yet */
  ExistingStore = 'EXISTING_STORE',
  /** The vendor querying storeSuggestions already has an active account at this store */
  ExistingStoreAndAccount = 'EXISTING_STORE_AND_ACCOUNT',
}

export enum StoreType {
  /** @deprecated use SINGLE_A or MULTI_A */
  A = 'A',
  /** @deprecated use SINGLE_B or MULTI_B */
  B = 'B',
  /** @deprecated use SINGLE_C or MULTI_C */
  C = 'C',
  Enterprise = 'ENTERPRISE',
  FoodService = 'FOOD_SERVICE',
  MultiA = 'MULTI_A',
  MultiB = 'MULTI_B',
  MultiC = 'MULTI_C',
  Other = 'OTHER',
  Regional = 'REGIONAL',
  SingleA = 'SINGLE_A',
  SingleB = 'SINGLE_B',
  SingleC = 'SINGLE_C',
  Unknown = 'UNKNOWN',
}

export type StoreVendorCreateFields = {
  accountNumber?: InputMaybe<Scalars['String']>
  billingAddressString?: InputMaybe<Scalars['String']>
  billingName?: InputMaybe<Scalars['String']>
  contactName?: InputMaybe<Scalars['String']>
  contactPhone?: InputMaybe<Scalars['String']>
  deactivatedAt?: InputMaybe<Scalars['DateTime']>
  invoicesEmail?: InputMaybe<Scalars['String']>
  minOrderValue?: InputMaybe<Scalars['Decimal']>
  name: Scalars['String']
  notes?: InputMaybe<Scalars['String']>
  ordersEmail?: InputMaybe<Scalars['String']>
  taxID?: InputMaybe<Scalars['String']>
  vendorCode?: InputMaybe<Scalars['String']>
  vendorID?: InputMaybe<Scalars['String']>
}

export type StoreVendorEditableFields = {
  accountNumber?: InputMaybe<Scalars['String']>
  billingAddressString?: InputMaybe<Scalars['String']>
  billingName?: InputMaybe<Scalars['String']>
  contactName?: InputMaybe<Scalars['String']>
  contactPhone?: InputMaybe<Scalars['String']>
  deactivatedAt?: InputMaybe<Scalars['DateTime']>
  invoicesEmail?: InputMaybe<Scalars['String']>
  minOrderValue?: InputMaybe<Scalars['Decimal']>
  name?: InputMaybe<Scalars['String']>
  notes?: InputMaybe<Scalars['String']>
  ordersEmail?: InputMaybe<Scalars['String']>
  taxID?: InputMaybe<Scalars['String']>
  vendorCode?: InputMaybe<Scalars['String']>
  vendorID?: InputMaybe<Scalars['String']>
}

export type StoreVendorMappingUpdateInput = {
  parentVendorFirestoreID?: InputMaybe<Scalars['String']>
  storeVendorSerialID: Scalars['String']
}

export type StoreVendorProductOrderHistory = {
  __typename?: 'StoreVendorProductOrderHistory'
  orderDateTime: Scalars['Timestamp']
  orderID: Scalars['ID']
  price: Scalars['Currency']
  quantity: Scalars['Int']
  unitOfMeasure: UnitOfMeasure
}

export type StoreVendorProductOrderHistoryInput = {
  storeID: Scalars['ID']
}

export type StoreVendorProductResult = {
  __typename?: 'StoreVendorProductResult'
  brandName: Scalars['String']
  caseSize?: Maybe<Scalars['Float']>
  description: Scalars['String']
  firestoreID?: Maybe<Scalars['ID']>
  itemCode: Scalars['String']
  parentProductFirestoreID?: Maybe<Scalars['String']>
  parentProductSerialID?: Maybe<Scalars['String']>
  serialID: Scalars['ID']
  storeID?: Maybe<Scalars['String']>
  unitUPC: Scalars['String']
  unitVolume: Scalars['String']
  vendorID: Scalars['String']
  vendorName: Scalars['String']
}

export type StoreVendorProductsMappingUpdateInput = {
  parentVendorProductFirestoreID?: InputMaybe<Scalars['String']>
  storeVendorProductSerialID: Scalars['String']
}

export type StoreVendorProductsQueryInput = {
  cursor?: InputMaybe<Scalars['Float']>
  filterByBannerFirestoreID?: InputMaybe<Scalars['String']>
  filterByStoreFirestoreID?: InputMaybe<Scalars['String']>
  limit?: InputMaybe<Scalars['Float']>
  mappedProductsOnly?: InputMaybe<Scalars['Boolean']>
  vendorFirestoreID?: InputMaybe<Scalars['String']>
}

export type StoreVendorResult = {
  __typename?: 'StoreVendorResult'
  firestoreID: Scalars['ID']
  name: Scalars['String']
  parentVendorFirestoreID?: Maybe<Scalars['String']>
  parentVendorSerialID?: Maybe<Scalars['String']>
  serialID: Scalars['ID']
  storeID: Scalars['String']
  storeName: Scalars['String']
}

export type StoreVendorStoreDepartmentAccountsInput = {
  filterByStatus?: InputMaybe<VendorStoreDepartmentAccountStatus>
  includeInactive?: InputMaybe<Scalars['Boolean']>
  marketEnabledOnly?: InputMaybe<Scalars['Boolean']>
  /** Note: This input will be superseded by any given `searchByVendor` input */
  query?: InputMaybe<Scalars['String']>
  /** Note: This input will supersede any given `query` input */
  searchByVendor?: InputMaybe<Scalars['String']>
  vendorIDs?: InputMaybe<Array<Scalars['ID']>>
  vendorStoreDepartmentAccountIDs?: InputMaybe<Array<Scalars['ID']>>
}

export type StoreVendorStoreDepartmentAccountsResult = {
  __typename?: 'StoreVendorStoreDepartmentAccountsResult'
  nodes: Array<VendorStoreDepartmentAccount>
  totalCount: Scalars['Int']
}

export type StoreVendorsInput = {
  marketEnabledOnly?: InputMaybe<Scalars['Boolean']>
  query?: InputMaybe<Scalars['String']>
}

export type StoreVendorsQueryInput = {
  cursor?: InputMaybe<Scalars['Float']>
  filterByBannerFirestoreID?: InputMaybe<Scalars['String']>
  filterByStoreFirestoreID?: InputMaybe<Scalars['String']>
  limit?: InputMaybe<Scalars['Float']>
  mappedVendorsOnly?: InputMaybe<Scalars['Boolean']>
}

export type StoreVendorsResult = {
  __typename?: 'StoreVendorsResult'
  nodes: Array<Vendor>
  totalCount: Scalars['Int']
}

export type StoreViewConnection = {
  __typename?: 'StoreViewConnection'
  edges: Array<StoreEdge>
  pageInfo: PageInfo
}

export type StoresResult = {
  __typename?: 'StoresResult'
  cursor?: Maybe<Scalars['ID']>
  nodes: Array<Store>
  totalCount?: Maybe<Scalars['Int']>
}

export type StripeBankAccountTokenForm = {
  plaidAccountID: Scalars['String']
  plaidPublicToken: Scalars['String']
}

export type StripeBankAccountTokenResponse = {
  __typename?: 'StripeBankAccountTokenResponse'
  requestID: Scalars['String']
  stripeBankAccountToken: Scalars['String']
}

export enum SubmissionMethod {
  Email = 'EMAIL',
  Qbc = 'QBC',
  Qbe = 'QBE',
  Sps = 'SPS',
  TrueCommerce = 'TRUE_COMMERCE',
  VoriEdi = 'VORI_EDI',
}

export type SubmitOrderReceivingReportInput = {
  lineItems?: InputMaybe<Array<OrderReceivingLineItemInput>>
  markAsReceived?: InputMaybe<Scalars['Boolean']>
  mispicks?: InputMaybe<Array<OrderMispickInput>>
  orderID: Scalars['ID']
  remainingItemsReceived?: InputMaybe<Scalars['Boolean']>
}

export type SuggestStoresInput = {
  address?: InputMaybe<Scalars['String']>
  name?: InputMaybe<Scalars['String']>
  placeID?: InputMaybe<Scalars['String']>
  vendorID: Scalars['ID']
}

export type SuggestStoresResult = {
  __typename?: 'SuggestStoresResult'
  nodes: Array<SuggestStoresResultNode>
}

export type SuggestStoresResultNode = {
  __typename?: 'SuggestStoresResultNode'
  store: Store
  suggestionType: StoreSuggestionType
}

export type SuggestedCart = {
  __typename?: 'SuggestedCart'
  lineItems: Array<SuggestedCartLineItem>
  modelTimestamp: Scalars['String']
  store: Store
  storeDepartment: StoreDepartment
  vendor: Vendor
}

export type SuggestedCartLineItem = {
  __typename?: 'SuggestedCartLineItem'
  lastOrderID?: Maybe<Scalars['ID']>
  lastOrderQuantity?: Maybe<Scalars['Int']>
  lastOrderUnitOfMeasure?: Maybe<UnitOfMeasure>
  lastOrderedAt?: Maybe<Scalars['Timestamp']>
  quantity: Scalars['Int']
  unitOfMeasure: UnitOfMeasure
  vendorProduct: VendorProduct
}

export type SuggestedVendorsInput = {
  filterByOrderPlaced?: InputMaybe<Scalars['Boolean']>
}

export type SyncStediUsersResultGql = {
  __typename?: 'SyncStediUsersResultGQL'
  message: Scalars['String']
  sftpUser?: Maybe<SftpUserGql>
}

/**
 * ****************************
 *       Tasks
 * ****************************
 */
export type TaskResponse = {
  __typename?: 'TaskResponse'
  jobID: Scalars['ID']
  taskUUID: Scalars['String']
}

export enum TaxRateType {
  Amount = 'AMOUNT',
  Percentage = 'PERCENTAGE',
}

export enum TaxType {
  Other = 'Other',
  Sales = 'Sales',
}

export enum UomLock {
  CasesOnly = 'casesOnly',
  EachesOnly = 'eachesOnly',
  None = 'none',
}

export enum UploadErrorMessages {
  BadUpc = 'BAD_UPC',
  DuplicateItemCode = 'DUPLICATE_ITEM_CODE',
  DuplicateUpc = 'DUPLICATE_UPC',
  InvalidStoreDepartment = 'INVALID_STORE_DEPARTMENT',
  InvalidStoreVendor = 'INVALID_STORE_VENDOR',
  InvalidTaxId = 'INVALID_TAX_ID',
  MissingDescription = 'MISSING_DESCRIPTION',
  MissingItemCode = 'MISSING_ITEM_CODE',
}

export type UndoVendorCatalogCsvUploadInput = {
  deleteNewProducts: Scalars['Boolean']
  forceRestore: Scalars['Boolean']
  logID: Scalars['String']
  restoreOverwrittenProducts: Scalars['Boolean']
}

export type UndoVendorCatalogCsvUploadResult = {
  __typename?: 'UndoVendorCatalogCSVUploadResult'
  message: Scalars['String']
  numNewProductsDeleted: Scalars['Int']
  numProductsRestored: Scalars['Int']
  restoredOn?: Maybe<Scalars['Timestamp']>
}

export enum UnitOfMeasure {
  Case = 'CASE',
  Each = 'EACH',
  Lb = 'LB',
}

export type UniversalProductSearchItem = {
  __typename?: 'UniversalProductSearchItem'
  inOrderGuide: Scalars['Boolean']
  product: VendorProduct
}

export type UniversalVendorProductsQueryInput = {
  authorizedVendorsOnly?: InputMaybe<Scalars['Boolean']>
  inOrderGuide?: InputMaybe<Scalars['Boolean']>
  limit?: InputMaybe<Scalars['Int']>
  paginationInput?: InputMaybe<PaginationInput>
  query?: InputMaybe<Scalars['String']>
  searchID?: InputMaybe<Scalars['String']>
  storeID?: InputMaybe<Scalars['ID']>
  vendorID?: InputMaybe<Scalars['ID']>
}

export type UpdateAllBannerUsersOrderGuideInput = {
  bannerID: Scalars['ID']
  defaultUOM?: InputMaybe<UnitOfMeasure>
  productIDs: Array<Scalars['ID']>
  readOnly?: InputMaybe<Scalars['Boolean']>
  shouldOverwrite?: InputMaybe<Scalars['Boolean']>
  userIDs?: InputMaybe<Array<Scalars['ID']>>
  vendorID: Scalars['ID']
}

export type UpdateAudienceInput = {
  id: Scalars['ID']
  name?: InputMaybe<Scalars['String']>
  storeIDs?: InputMaybe<Array<Scalars['ID']>>
}

export type UpdateBannerAuthFileV2OrderGuidesAccountInput = {
  defaultUnitOfMeasure?: InputMaybe<UnitOfMeasure>
  departmentName: DepartmentName
  readOnly?: InputMaybe<Scalars['Boolean']>
  shouldOverwrite?: InputMaybe<Scalars['Boolean']>
  vendorID: Scalars['ID']
  vendorProductIDs: Array<Scalars['ID']>
}

export type UpdateBannerAuthFileV2OrderGuidesInput = {
  accounts: Array<UpdateBannerAuthFileV2OrderGuidesAccountInput>
  bannerID: Scalars['ID']
}

export type UpdateBannerInput = {
  acquisitionDetail?: InputMaybe<Scalars['String']>
  acquisitionSource?: InputMaybe<AcquisitionSource>
  bannerType?: InputMaybe<StoreType>
  billingInfo?: InputMaybe<BillingInfoInput>
  frontOfficeURL?: InputMaybe<Scalars['String']>
  id: Scalars['ID']
  imageURL?: InputMaybe<Scalars['String']>
  imageURLFile?: InputMaybe<Scalars['Upload']>
  name?: InputMaybe<Scalars['String']>
  referredByCompanyID?: InputMaybe<Scalars['ID']>
  status?: InputMaybe<BannerStatus>
  storeIDs?: InputMaybe<Array<Scalars['ID']>>
}

export type UpdateBannerV2OrderGuidesInput = {
  bannerID: Scalars['ID']
  defaultUnitOfMeasure?: InputMaybe<UnitOfMeasure>
  departmentName: DepartmentName
  readOnly?: InputMaybe<Scalars['Boolean']>
  shouldOverwrite?: InputMaybe<Scalars['Boolean']>
  vendorID: Scalars['ID']
  vendorProductIDs: Array<Scalars['ID']>
}

export type UpdateBannerVendorEmailsInput = {
  bannerID: Scalars['ID']
  override?: InputMaybe<Scalars['Boolean']>
  vendorEmails: Array<VendorEmailInput>
  vendorID: Scalars['ID']
}

export type UpdateBannerVendorEmailsResult = {
  __typename?: 'UpdateBannerVendorEmailsResult'
  nodes: Array<VendorStoreDepartmentAccount>
  updatedVSDAIds: Array<Scalars['String']>
}

export type UpdateBuyerProfileInput = {
  defaultDepartmentName?: InputMaybe<Scalars['String']>
  displayName?: InputMaybe<Scalars['String']>
  email?: InputMaybe<Scalars['String']>
  id: Scalars['ID']
  phoneNumber?: InputMaybe<Scalars['String']>
  readOnlyOrderGuides?: InputMaybe<Scalars['Boolean']>
}

export type UpdateCartMisscanQuantityInput = {
  misscanID: Scalars['ID']
  quantity: Scalars['Int']
  /** Vendor users must specify the store to update */
  storeID?: InputMaybe<Scalars['ID']>
  unitOfMeasure: UnitOfMeasure
}

export type UpdateCartMisscanQuantityResult = {
  __typename?: 'UpdateCartMisscanQuantityResult'
  updatedVendorCart?: Maybe<VendorCart>
}

export type UpdateDealInput = {
  basisPoints?: InputMaybe<Scalars['Int']>
  dealValue?: InputMaybe<Scalars['Currency']>
  freeCount?: InputMaybe<Scalars['Int']>
  id: Scalars['ID']
  threshold?: InputMaybe<Scalars['Int']>
  type?: InputMaybe<DealType>
  unitOfMeasure?: InputMaybe<UnitOfMeasure>
  vendorDiscountCode?: InputMaybe<Scalars['String']>
  vendorProductIDs?: InputMaybe<Array<Scalars['ID']>>
}

export type UpdateEslConfigInput = {
  apiKey?: InputMaybe<Scalars['String']>
  eslStoreID: Scalars['String']
  password?: InputMaybe<Scalars['String']>
  storeID: Scalars['String']
  type: EslType
  username?: InputMaybe<Scalars['String']>
}

export type UpdateLineItemCreditRequestMutationInput = {
  amount: MoneyInput
  lineItemID: Scalars['ID']
  notes: Scalars['String']
}

export type UpdateOrderInput = {
  orderConfirmed?: InputMaybe<Scalars['Boolean']>
  orderEmailOpened?: InputMaybe<Scalars['Boolean']>
  orderID: Scalars['ID']
  orderPlaced?: InputMaybe<Scalars['Boolean']>
  slackMsgID?: InputMaybe<Scalars['String']>
  suggestedCartsModelTimestamp?: InputMaybe<Scalars['String']>
}

export type UpdateOrderReceivingLineItemInput = {
  brandName?: InputMaybe<Scalars['String']>
  createMispickItem?: InputMaybe<Scalars['Boolean']>
  description?: InputMaybe<Scalars['String']>
  details?: InputMaybe<Scalars['String']>
  imageURLs?: InputMaybe<Array<Scalars['String']>>
  issueQuantity?: InputMaybe<Scalars['Int']>
  orderID?: InputMaybe<Scalars['ID']>
  quantity?: InputMaybe<Scalars['Int']>
  status?: InputMaybe<OrderReceivingLineItemStatus>
  unitOfMeasure?: InputMaybe<UnitOfMeasure>
  upc?: InputMaybe<Scalars['String']>
}

export type UpdateProductSampleRequestInput = {
  id: Scalars['ID']
  status?: InputMaybe<SampleRequestStatus>
}

export type UpdateProfileInput = {
  displayName?: InputMaybe<Scalars['String']>
  email?: InputMaybe<Scalars['String']>
  forceRealmSync?: InputMaybe<Scalars['Boolean']>
  phoneNumber?: InputMaybe<Scalars['String']>
  readOnlyOrderGuides?: InputMaybe<Scalars['Boolean']>
}

export type UpdatePromotionInput = {
  allAccounts?: InputMaybe<Scalars['Boolean']>
  audienceID?: InputMaybe<Scalars['ID']>
  endDate?: InputMaybe<Scalars['Timestamp']>
  id: Scalars['ID']
  isPublished?: InputMaybe<Scalars['Boolean']>
  name?: InputMaybe<Scalars['String']>
  startDate?: InputMaybe<Scalars['Timestamp']>
}

export type UpdateSftpConnectionInput = {
  SQLBannerID?: InputMaybe<Scalars['String']>
  SQLStoreID?: InputMaybe<Scalars['String']>
  SQLUserID: Scalars['String']
  SQLVendorID?: InputMaybe<Scalars['String']>
  description: Scalars['String']
  direction: Scalars['String']
  id: Scalars['Float']
  path: Scalars['String']
}

export type UpdateStoreDepartmentsSuggestedVendorListInput = {
  overwrite?: InputMaybe<Scalars['Boolean']>
  storeDepartmentsIDs: Array<Scalars['ID']>
  suggestedVendorList: Array<Scalars['ID']>
}

export type UpdateStoreDepartmentsSuggestedVendorListResult = {
  __typename?: 'UpdateStoreDepartmentsSuggestedVendorListResult'
  nodes: Array<StoreDepartment>
}

export type UpdateStoreInput = {
  acquisitionDetail?: InputMaybe<Scalars['String']>
  acquisitionSource?: InputMaybe<AcquisitionSource>
  address?: InputMaybe<Scalars['String']>
  bannerID?: InputMaybe<Scalars['String']>
  bannerStoreID?: InputMaybe<Scalars['String']>
  emails?: InputMaybe<Array<Scalars['String']>>
  geographicCoordinates?: InputMaybe<Scalars['String']>
  id: Scalars['ID']
  name?: InputMaybe<Scalars['String']>
  overwriteSuggestedVendorList?: InputMaybe<Scalars['Boolean']>
  placeID?: InputMaybe<Scalars['String']>
  referredByCompanyID?: InputMaybe<Scalars['ID']>
  storeType?: InputMaybe<StoreType>
  suggestedVendorList?: InputMaybe<Array<Scalars['ID']>>
  supportsWic?: InputMaybe<Scalars['Boolean']>
  vendorIDs?: InputMaybe<Array<Scalars['String']>>
}

export type UpdateStoreVendorListInput = {
  addedVendorIDs?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>
  removedVendorIDs?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>
  storeID: Scalars['ID']
}

export type UpdateStoreVendorProductInput = {
  accountSpecificCasePrice?: InputMaybe<Array<AccountSpecificPriceInput>>
  accountSpecificUnitPrice?: InputMaybe<Array<AccountSpecificPriceInput>>
  productID: Scalars['ID']
  retailerDiscontinuedDates?: InputMaybe<Array<RetailerDiscontinuedDateInput>>
}

export type UpdateUserAccountListInput = {
  accountIDs: Array<Scalars['ID']>
}

export type UpdateUserInput = {
  companyID?: InputMaybe<Scalars['String']>
  defaultDepartmentName?: InputMaybe<Scalars['String']>
  displayName?: InputMaybe<Scalars['String']>
  email?: InputMaybe<Scalars['String']>
  forceRealmSync?: InputMaybe<Scalars['Boolean']>
  id: Scalars['ID']
  phoneNumber?: InputMaybe<Scalars['String']>
  readOnlyOrderGuides?: InputMaybe<Scalars['Boolean']>
  userType?: InputMaybe<UserType>
}

export type UpdateUserOrderGuideAccountInput = {
  productIDs: Array<Scalars['ID']>
  storeID: Scalars['ID']
  type?: InputMaybe<Scalars['String']>
  userID: Scalars['ID']
  vendorID: Scalars['ID']
}

export type UpdateUserOrderGuideInput = {
  defaultUOM?: InputMaybe<UnitOfMeasure>
  /** List of product IDs to update the order guide to. Note: this mutation does not merge product IDs with any pre-existing order guide (if you desire merge behavior, use the add/delete mutations instead) */
  productIDs: Array<Scalars['ID']>
  readOnly?: InputMaybe<Scalars['Boolean']>
  storeID: Scalars['ID']
  /** Optional: which user's OrderGuide to update. If not provided, this mutation defaults to the authenticated user. */
  userID?: InputMaybe<Scalars['ID']>
  vendorID: Scalars['ID']
}

export type UpdateV2OrderGuideInput = {
  defaultUOM?: InputMaybe<UnitOfMeasure>
  readOnly?: InputMaybe<Scalars['Boolean']>
  vendorProductIDs: Array<Scalars['ID']>
  vendorStoreDepartmentAccountID: Scalars['ID']
}

export type UpdateVendorCartInput = {
  idempotencyKey?: InputMaybe<Scalars['String']>
  lineItems: Array<CartLineItemInput>
  misscanLineItems: Array<MisscanLineItemInput>
  /** Vendor users must also specify the store to update */
  storeID?: InputMaybe<Scalars['ID']>
  suggestedCartsModelTimestamp?: InputMaybe<Scalars['String']>
  /** Which user to update the Cart for. If not passed, updates the authenticated user's cart. */
  userID?: InputMaybe<Scalars['ID']>
  vendorID: Scalars['ID']
}

export type UpdateVendorCartResult = {
  __typename?: 'UpdateVendorCartResult'
  cart: VendorCart
  missingProductIDs: Array<Scalars['ID']>
}

export type UpdateVendorInput = {
  acquisitionDetail?: InputMaybe<Scalars['String']>
  acquisitionSource?: InputMaybe<AcquisitionSource>
  address?: InputMaybe<Scalars['String']>
  billingInfo?: InputMaybe<BillingInfoInput>
  defaultOrderSubmissionMethod?: InputMaybe<SubmissionMethod>
  departmentTags?: InputMaybe<Array<DepartmentName>>
  description?: InputMaybe<Scalars['String']>
  disableDiscontinuedPurchases?: InputMaybe<Scalars['Boolean']>
  disableOutOfStockPurchases?: InputMaybe<Scalars['Boolean']>
  distributionCenterID?: InputMaybe<Scalars['String']>
  email?: InputMaybe<Scalars['String']>
  headerImageURL?: InputMaybe<Scalars['String']>
  headerImageURLFile?: InputMaybe<Scalars['Upload']>
  hideWholesalePricing?: InputMaybe<Scalars['Boolean']>
  id: Scalars['ID']
  imgURL?: InputMaybe<Scalars['String']>
  imgURLFile?: InputMaybe<Scalars['Upload']>
  isInventoryEnabled?: InputMaybe<Scalars['Boolean']>
  lockUOMSelection?: InputMaybe<UomLock>
  misscanPolicy?: InputMaybe<VendorMisscanPolicy>
  name?: InputMaybe<Scalars['String']>
  orderDeadline?: InputMaybe<Scalars['String']>
  orderDeadlineInfo?: InputMaybe<VendorOrderDeadlineInfoInput>
  orderMin?: InputMaybe<Scalars['Currency']>
  orderMinimums?: InputMaybe<Array<VendorOrderMinimumInput>>
  orderSubmissionUOMLock?: InputMaybe<UomLock>
  referredByCompanyID?: InputMaybe<Scalars['ID']>
  retailerPricing?: InputMaybe<Scalars['Boolean']>
  showImages?: InputMaybe<Scalars['Boolean']>
  skipEmailWithEDIOrderSubmission?: InputMaybe<Scalars['Boolean']>
  spsTenetID?: InputMaybe<Scalars['String']>
  status?: InputMaybe<VendorStatus>
  trueCommerceTenetID?: InputMaybe<Scalars['String']>
  useAccountMetadataEmailOverVendorEmail?: InputMaybe<Scalars['Boolean']>
  vendorManagedCatalog?: InputMaybe<Scalars['Boolean']>
}

export type UpdateVendorProductInput = {
  accountSpecificCasePrice?: InputMaybe<Array<AccountSpecificPriceInput>>
  accountSpecificUnitPrice?: InputMaybe<Array<AccountSpecificPriceInput>>
  acquisitionDetail?: InputMaybe<Scalars['String']>
  acquisitionSource?: InputMaybe<AcquisitionSource>
  address?: InputMaybe<Scalars['String']>
  brand?: InputMaybe<Scalars['String']>
  caseCRV?: InputMaybe<Scalars['Currency']>
  casePrice?: InputMaybe<Scalars['Currency']>
  caseSize?: InputMaybe<Scalars['Float']>
  caseUPC?: InputMaybe<Scalars['String']>
  category?: InputMaybe<Scalars['String']>
  crvCost?: InputMaybe<Scalars['Currency']>
  departmentName?: InputMaybe<Scalars['String']>
  departmentTags?: InputMaybe<Array<DepartmentName>>
  description?: InputMaybe<Scalars['String']>
  erpID?: InputMaybe<Scalars['String']>
  imgURL?: InputMaybe<Scalars['String']>
  imgURLFile?: InputMaybe<Scalars['Upload']>
  inventory?: InputMaybe<Scalars['Int']>
  isDeleted?: InputMaybe<Scalars['Boolean']>
  isDiscontinued?: InputMaybe<Scalars['Boolean']>
  isStoreSpecific?: InputMaybe<Scalars['Boolean']>
  itemCode?: InputMaybe<Scalars['String']>
  missScanMethod?: InputMaybe<MissScanMethod>
  notes?: InputMaybe<Scalars['String']>
  packUPC?: InputMaybe<Scalars['String']>
  privateLabelProductBannerIDs?: InputMaybe<Array<Scalars['ID']>>
  privateLabelProductStoreIDs?: InputMaybe<Array<Scalars['ID']>>
  productID: Scalars['ID']
  referredByCompanyID?: InputMaybe<Scalars['String']>
  retailerDiscontinuedDates?: InputMaybe<Array<RetailerDiscontinuedDateInput>>
  sizing?: InputMaybe<Scalars['String']>
  srp?: InputMaybe<Scalars['String']>
  status?: InputMaybe<VendorProductStatus>
  storeID?: InputMaybe<Scalars['String']>
  unitCRV?: InputMaybe<Scalars['Currency']>
  unitPrice?: InputMaybe<Scalars['Currency']>
  unitUPC?: InputMaybe<Scalars['String']>
  unitVolume?: InputMaybe<Scalars['String']>
  upc?: InputMaybe<Scalars['String']>
  vendorID?: InputMaybe<Scalars['String']>
  wholesaleCasePrice?: InputMaybe<Scalars['Currency']>
  wholesaleUnitPrice?: InputMaybe<Scalars['Currency']>
}

export type UpdateVendorStoreAccountInput = {
  accountNumber?: InputMaybe<Scalars['String']>
  defaultUOM?: InputMaybe<UnitOfMeasure>
  orderDeadline?: InputMaybe<Scalars['String']>
  orderSubmissionMethod?: InputMaybe<SubmissionMethod>
  storeEmails?: InputMaybe<Array<Scalars['String']>>
  storeID: Scalars['String']
  vendorEmails?: InputMaybe<Array<Scalars['String']>>
  vendorID: Scalars['String']
}

export type UpdateVendorStoreDepartmentAccountForm = {
  accountNumber?: InputMaybe<Scalars['String']>
  defaultUnitOfMeasure?: InputMaybe<UnitOfMeasure>
  dunsNumber?: InputMaybe<Scalars['String']>
  name?: InputMaybe<Scalars['String']>
  orderDeadline?: InputMaybe<Scalars['String']>
  orderDeadlineInfo?: InputMaybe<VendorOrderDeadlineInfoInput>
  orderSubmissionMethod?: InputMaybe<SubmissionMethod>
  orderSubmissionUOMLock?: InputMaybe<UomLock>
  status?: InputMaybe<VendorStoreDepartmentAccountStatus>
  storeEmails?: InputMaybe<Array<StoreEmailInput>>
  vendorEmails?: InputMaybe<Array<VendorEmailInput>>
}

export type UpdateVendorsForStoreDepartmentInput = {
  storeDepartmentID: Scalars['ID']
  vendorIDs: Array<Scalars['ID']>
}

export type UpdateVendorsForStoreDepartmentResult = {
  __typename?: 'UpdateVendorsForStoreDepartmentResult'
  createdVendorIDs: Array<Scalars['ID']>
  deletedVendorIDs: Array<Scalars['ID']>
  nodes: Array<VendorStoreDepartmentAccount>
}

export type UploadError = {
  __typename?: 'UploadError'
  errorMessages: Array<UploadErrorMessages>
  index: Scalars['Int']
}

export type UploadInvoiceFileForOrderMutationInput = {
  files: Array<Scalars['Upload']>
  orderID: Scalars['ID']
}

export type User = {
  __typename?: 'User'
  accountListVendorStoreDepartmentAccounts: VendorStoreDepartmentAccountsResult
  canSeeFeatures: UserCanSeeFeaturesResult
  cartByID?: Maybe<VendorCart>
  carts: Array<VendorCart>
  catalogRequests: CatalogRequestsResult
  companyImageURL?: Maybe<Scalars['String']>
  companyUserType?: Maybe<CompanyUserType>
  defaultDepartmentName?: Maybe<Scalars['String']>
  displayName?: Maybe<Scalars['String']>
  email?: Maybe<Scalars['String']>
  forceRealmSync: Scalars['Boolean']
  id: Scalars['ID']
  phoneNumber?: Maybe<Scalars['String']>
  primaryCompanyID?: Maybe<Scalars['ID']>
  primaryCompanyName?: Maybe<Scalars['String']>
  primaryCompanyType?: Maybe<Scalars['String']>
  readOnlyOrderGuides?: Maybe<Scalars['Boolean']>
  retailUser?: Maybe<RetailUser>
  signupDate?: Maybe<Scalars['Timestamp']>
  storeDepartments: StoreDepartmentsResult
  storeReceiver?: Maybe<StoreReceiverUser>
  stores: StoresResult
  userSqlID?: Maybe<Scalars['String']>
  userType?: Maybe<UserType>
  vendorUser?: Maybe<VendorUser>
}

export type UserAccountListVendorStoreDepartmentAccountsArgs = {
  input?: InputMaybe<VendorStoreDepartmentAccountsInput>
}

export type UserCanSeeFeaturesArgs = {
  input?: InputMaybe<UserCanSeeFeaturesInput>
}

export type UserCartByIdArgs = {
  storeID: Scalars['ID']
  vendorID: Scalars['ID']
}

export type UserStoreDepartmentsArgs = {
  input?: InputMaybe<UserStoreDepartmentsQueryInput>
}

export type UserStoresArgs = {
  input?: InputMaybe<UserSearchStoresQueryInput>
}

export type UserCanSeeFeaturesInput = {
  /** List of feature IDs to check */
  featureIDs?: InputMaybe<Array<Scalars['String']>>
}

export type UserCanSeeFeaturesResult = {
  __typename?: 'UserCanSeeFeaturesResult'
  /** The subset of input feature IDs visible to this user */
  enabledFeatures: Array<Scalars['String']>
}

export type UserCart = {
  __typename?: 'UserCart'
  id: Scalars['ID']
  storeID: Scalars['ID']
  updatedAt?: Maybe<Scalars['Timestamp']>
  userID: Scalars['ID']
}

export type UserSearchStoresQueryInput = {
  limit?: InputMaybe<Scalars['Int']>
  pagination?: InputMaybe<PaginationInput>
  search?: InputMaybe<Scalars['String']>
}

/**
 * ****************************
 *       UserStoreDepartment
 * ****************************
 */
export type UserStoreDepartment = {
  __typename?: 'UserStoreDepartment'
  id: Scalars['String']
  storeDepartment: StoreDepartment
  user: User
}

export type UserStoreDepartmentsQueryInput = {
  filterByStoreID: Scalars['ID']
}

export type UserStoreDepartmentsResult = {
  __typename?: 'UserStoreDepartmentsResult'
  nodes: Array<UserStoreDepartment>
}

export type UserStoreQueryInput = {
  cursor?: InputMaybe<Scalars['ID']>
  limit?: InputMaybe<Scalars['Int']>
  query?: InputMaybe<Scalars['String']>
}

export enum UserType {
  Buyer = 'BUYER',
  DepartmentManager = 'DEPARTMENT_MANAGER',
  SalesRep = 'SALES_REP',
  StoreAccountsPayable = 'STORE_ACCOUNTS_PAYABLE',
  StoreAdmin = 'STORE_ADMIN',
  StoreReceiver = 'STORE_RECEIVER',
  VendorAdmin = 'VENDOR_ADMIN',
  VoriAdmin = 'VORI_ADMIN',
}

export type UsersResult = {
  __typename?: 'UsersResult'
  cursor?: Maybe<Scalars['ID']>
  hasMore?: Maybe<Scalars['Boolean']>
  nodes: Array<User>
  totalCount: Scalars['Int']
}

export type V2OrderGuide = {
  __typename?: 'V2OrderGuide'
  defaultUnitOfMeasure?: Maybe<UnitOfMeasure>
  id: Scalars['ID']
  readOnly?: Maybe<Scalars['Boolean']>
  storeDepartmentID: Scalars['String']
  vendorID: Scalars['String']
  vendorProductIDs: Array<Scalars['String']>
  vendorProducts?: Maybe<OrderGuideProductsResult>
  vendorStoreDepartmentAccount: VendorStoreDepartmentAccount
}

export type V2OrderGuideVendorProductsArgs = {
  input?: InputMaybe<V2OrderGuideProductsInput>
}

export type V2OrderGuideCsvResult = {
  __typename?: 'V2OrderGuideCSVResult'
  url: Scalars['String']
}

export type V2OrderGuideProductsInput = {
  cursor?: InputMaybe<Scalars['ID']>
  limit?: InputMaybe<Scalars['Int']>
  query?: InputMaybe<Scalars['String']>
}

export type V2OrderGuidesResult = {
  __typename?: 'V2OrderGuidesResult'
  nodes?: Maybe<Array<V2OrderGuide>>
}

export type VsdaEdge = {
  __typename?: 'VSDAEdge'
  cursor: Scalars['Cursor']
  node: VendorStoreDepartmentAccount
}

export type VsdaQueryInput = {
  after?: InputMaybe<Scalars['Cursor']>
  filterByStatus?: InputMaybe<VendorStoreDepartmentAccountStatus>
  first: Scalars['Int']
  includeInactive?: InputMaybe<Scalars['Boolean']>
  storeIDs?: InputMaybe<Array<Scalars['ID']>>
}

export type VsdaViewConnection = {
  __typename?: 'VSDAViewConnection'
  edges: Array<VsdaEdge>
  pageInfo: PageInfo
}

export type ValidateBulkUploadStoreVendorProductsResult = {
  __typename?: 'ValidateBulkUploadStoreVendorProductsResult'
  errors: Array<UploadError>
  numExistingProducts: Scalars['Int']
  numNewProducts: Scalars['Int']
  numProducts: Scalars['Int']
  numValidProducts: Scalars['Int']
  spreadsheetURL: Scalars['String']
}

export type ValidateBulkUploadVendorProductsResult = {
  __typename?: 'ValidateBulkUploadVendorProductsResult'
  errors: Array<UploadError>
  matchErrors: Array<MatchError>
  numDeletedProductsRestored: Scalars['Int']
  numExistingProducts: Scalars['Int']
  numNewProducts: Scalars['Int']
  numProducts: Scalars['Int']
  numValidProducts: Scalars['Int']
  spreadsheetURL: Scalars['String']
  vendor: Vendor
}

export type ValidateInvitationOrderGuideNamesResult = {
  __typename?: 'ValidateInvitationOrderGuideNamesResult'
  duplicates: Array<Scalars['String']>
}

export type ValidatedPointOfSaleDepartmentName = {
  __typename?: 'ValidatedPointOfSaleDepartmentName'
  bannerID: Scalars['ID']
  id: Scalars['String']
  matchedDepartmentName: Scalars['String']
  providedDepartmentName: Scalars['String']
  timestamp: Scalars['Timestamp']
}

export type ValidatedPointOfSaleDepartmentNameInput = {
  matchedDepartmentName: Scalars['String']
  providedDepartmentName: Scalars['String']
}

export type ValidatedPointOfSaleItemCode = {
  __typename?: 'ValidatedPointOfSaleItemCode'
  bannerID: Scalars['ID']
  id: Scalars['String']
  matchedItemCode: Scalars['String']
  providedUPC: Scalars['String']
  timestamp: Scalars['Timestamp']
  vendorID: Scalars['ID']
}

export type ValidatedPointOfSaleItemCodeInput = {
  matchedItemCode: Scalars['String']
  providedUPC: Scalars['String']
  vendorID: Scalars['ID']
}

export type ValidatedPointOfSaleVendorName = {
  __typename?: 'ValidatedPointOfSaleVendorName'
  bannerID: Scalars['ID']
  id: Scalars['String']
  matchedVendorID: Scalars['ID']
  matchedVendorName: Scalars['String']
  providedVendorName: Scalars['String']
  timestamp: Scalars['Timestamp']
}

export type ValidatedPointOfSaleVendorNameInput = {
  matchedVendorID: Scalars['ID']
  providedVendorName: Scalars['String']
}

export type Vendor = {
  __typename?: 'Vendor'
  acquisitionDetail?: Maybe<Scalars['String']>
  acquisitionSource?: Maybe<AcquisitionSource>
  /** Promotions that are published and currently active */
  activePromotions?: Maybe<PromotionsResults>
  address?: Maybe<Scalars['String']>
  addressComponents?: Maybe<AddressComponents>
  /** All promotions, regardless of status. */
  allPromotions?: Maybe<PromotionsResults>
  /** All employees of this vendor */
  audiences: AudiencesResult
  bestSellers?: Maybe<Array<VendorProduct>>
  billingInfo?: Maybe<BillingInfo>
  /** For vendors of status PROVIDED_CATALOG or CERTIFIED, the date on which we ingested their catalog for the first time */
  catalogFirstProvidedDate?: Maybe<Scalars['Timestamp']>
  catalogLastUpdatedAt?: Maybe<Scalars['Timestamp']>
  defaultOrderSubmissionMethod: SubmissionMethod
  departmentTags?: Maybe<Array<DepartmentName>>
  description?: Maybe<Scalars['String']>
  disableDiscontinuedPurchases: Scalars['Boolean']
  /**
   * Used on Market to prevent stores from ordering products that are currently
   * out of stock.
   */
  disableOutOfStockPurchases: Scalars['Boolean']
  distributionCenterID?: Maybe<Scalars['String']>
  email?: Maybe<Scalars['String']>
  geographicCoordinates?: Maybe<Scalars['String']>
  hasItemCodes?: Maybe<Scalars['Boolean']>
  hasVendorDashAccess: Scalars['Boolean']
  headerImageURL?: Maybe<Scalars['String']>
  hideWholesalePricing?: Maybe<Scalars['Boolean']>
  id: Scalars['ID']
  imgURL?: Maybe<Scalars['String']>
  isInventoryEnabled: Scalars['Boolean']
  isMarketEnabled: Scalars['Boolean']
  lastVendorProductUpdate?: Maybe<Scalars['Timestamp']>
  /** Whether this Vendor limits the unit of measure that customers may use to express item quantities. */
  lockUOMSelection?: Maybe<UomLock>
  misscanPolicy?: Maybe<VendorMisscanPolicy>
  name?: Maybe<Scalars['String']>
  orderDeadline?: Maybe<Scalars['String']>
  orderDeadlineInfo?: Maybe<VendorOrderDeadlineInfo>
  orderMin?: Maybe<Scalars['Currency']>
  orderMinimums?: Maybe<Array<VendorOrderMinimum>>
  orderSubmissionUOMLock?: Maybe<UomLock>
  ordersSinceDate: OrdersResult
  paymentProfile?: Maybe<PaymentProfile>
  placeID?: Maybe<Scalars['String']>
  potentialPromotionConflicts?: Maybe<PotentialPromotionConflictsResult>
  prospectiveStoreAccounts: StoresResult
  referredByCompany?: Maybe<Company>
  /** The number of retail users that have this Vendor in their vendor list */
  retailUserCount: Scalars['Int']
  retailerPricing?: Maybe<Scalars['Boolean']>
  serialID?: Maybe<Scalars['ID']>
  showImages?: Maybe<Scalars['Boolean']>
  skipEmailWithEDIOrderSubmission?: Maybe<Scalars['Boolean']>
  /** Optional slug used to construct human-friendly vendor URLs */
  slug?: Maybe<Scalars['String']>
  sortCatalogBy: CatalogSortType
  status: VendorStatus
  /** @deprecated Use storeDepartmentAccountsByStoreID */
  storeAccountByStoreID?: Maybe<VendorStoreAccount>
  storeAccounts: VendorStoreAccountsResult
  /** @deprecated Use vendorStoreDepartmentAccounts instead */
  storeDepartmentAccountsByStoreID: VendorVendorStoreDepartmentAccountsResult
  stores: StoresResult
  totalProductCount: Scalars['Int']
  trueCommerceTenetID?: Maybe<Scalars['String']>
  /**
   * Hack to accommodate vendors that receive orders through brokers,
   * and thus shouldn't receive PO emails at the vendor's default order email.
   */
  useAccountMetadataEmailOverVendorEmail: Scalars['Boolean']
  validOrderSubmissionMethods: Array<SubmissionMethod>
  vendorBrands: VendorBrandsResult
  vendorCategories: VendorCategoriesResult
  vendorCode?: Maybe<Scalars['String']>
  /** Temp protection of vendor catalog from store vendor product ingest */
  vendorManagedCatalog?: Maybe<Scalars['Boolean']>
  vendorProducts: VendorProductsResult
  vendorStoreDepartmentAccounts: VendorVendorStoreDepartmentAccountsResult
  vendorUsers: VendorUserResults
}

export type VendorOrdersSinceDateArgs = {
  input: VendorOrdersSinceDateInput
}

export type VendorPotentialPromotionConflictsArgs = {
  input: PotentialPromotionConflictsInput
}

export type VendorStoreAccountByStoreIdArgs = {
  storeID: Scalars['ID']
}

export type VendorStoreDepartmentAccountsByStoreIdArgs = {
  storeID: Scalars['ID']
}

export type VendorStoresArgs = {
  input?: InputMaybe<StoreInput>
}

export type VendorVendorProductsArgs = {
  input?: InputMaybe<VendorProductsInput>
}

export type VendorVendorStoreDepartmentAccountsArgs = {
  input?: InputMaybe<VendorVendorStoreDepartmentAccountsInput>
}

export type VendorBrandsResult = {
  __typename?: 'VendorBrandsResult'
  nodes: Array<Scalars['String']>
}

export type VendorCart = {
  __typename?: 'VendorCart'
  createdAt?: Maybe<Scalars['Timestamp']>
  /** Free items from active Promotions */
  freeItemCount: Scalars['Int']
  id: Scalars['ID']
  idempotencyKey?: Maybe<Scalars['String']>
  /** Number of unique SKUs in Cart */
  lineItemCount: Scalars['Int']
  lineItems: CartLineItems
  /** Line Items with anomalous quantities / UOM */
  lineItemsRequiringReview: CartReviewItemsResult
  misscanLineItems: MisscanLineItems
  /** Items eg from the order guide that are missing from the cart */
  missingItemSuggestions: MissingItemSuggestionsResult
  /** Line items that are currently out of stock from vendor */
  outOfStockProducts: CartOutOfStockProductsResult
  /** Sum of quantities in Cart */
  productCount: Scalars['Int']
  store: Store
  /** Subtotal of items in cart, inclusive of applicable deal value */
  subTotal: Scalars['Currency']
  suggestedCartsModelTimestamp?: Maybe<Scalars['String']>
  /** Suggested products to add to cart, based on current cart contents */
  suggestedProducts: CartSuggestedProductsResult
  /** Money saved through active Promotions */
  totalDiscount: Scalars['Currency']
  /** Line items that are currently out of stock from vendor */
  unavailableProducts: CartUnavailableProductsResult
  updatedAt?: Maybe<Scalars['Timestamp']>
  user: User
  vendor: Vendor
}

export type VendorCategoriesResult = {
  __typename?: 'VendorCategoriesResult'
  nodes: Array<Scalars['String']>
}

export type VendorEdge = {
  __typename?: 'VendorEdge'
  cursor: Scalars['Cursor']
  node: Vendor
}

export type VendorEmail = {
  __typename?: 'VendorEmail'
  email: Scalars['String']
  type: VendorEmailType
}

export type VendorEmailInput = {
  email: Scalars['String']
  type: VendorEmailType
}

export enum VendorEmailType {
  Primary = 'PRIMARY',
  Secondary = 'SECONDARY',
}

export type VendorInvitation = {
  __typename?: 'VendorInvitation'
  email: Scalars['String']
  /** ID is identical to the invitation code */
  id: Scalars['ID']
  invitedByStore?: Maybe<Store>
  invitedByUser?: Maybe<User>
  status: InvitationStatus
  vendor: Vendor
}

export type VendorInvitationsResult = {
  __typename?: 'VendorInvitationsResult'
  nodes: Array<VendorInvitation>
}

export enum VendorMisscanPolicy {
  /** @deprecated Misscan 1.0 is deprecated. Use STANDARD instead */
  Legacy = 'LEGACY',
  Locked = 'LOCKED',
  Standard = 'STANDARD',
}

export type VendorOrderDeadline = {
  __typename?: 'VendorOrderDeadline'
  deadlineDay: DayOfWeek
  deadlineTime?: Maybe<Scalars['String']>
  deliveryDay: DayOfWeek
}

export type VendorOrderDeadlineInfo = {
  __typename?: 'VendorOrderDeadlineInfo'
  orderDeadlines: Array<VendorOrderDeadline>
  timezone: Scalars['String']
}

export type VendorOrderDeadlineInfoInput = {
  orderDeadlines: Array<VendorOrderDeadlineInput>
  timezone: Scalars['String']
}

export type VendorOrderDeadlineInput = {
  deadlineDay: DayOfWeek
  deadlineTime?: InputMaybe<Scalars['String']>
  deliveryDay: DayOfWeek
}

export type VendorOrderMinimum = {
  __typename?: 'VendorOrderMinimum'
  orderMin: Scalars['Currency']
  storeID: Scalars['String']
}

export type VendorOrderMinimumInput = {
  orderMin: Scalars['Currency']
  storeID: Scalars['String']
}

export type VendorOrdersInput = {
  filterByActionRequired?: InputMaybe<Scalars['Boolean']>
  filterByConfirmed?: InputMaybe<Scalars['Boolean']>
  filterByReceived?: InputMaybe<Scalars['Boolean']>
  filterByStore?: InputMaybe<Scalars['ID']>
  limit?: InputMaybe<Scalars['Int']>
  pagination?: InputMaybe<PaginationInput>
  vendorID: Scalars['ID']
}

export type VendorOrdersResult = {
  __typename?: 'VendorOrdersResult'
  cursor?: Maybe<Scalars['ID']>
  hasMore?: Maybe<Scalars['Boolean']>
  nodes: Array<Order>
}

export type VendorOrdersSinceDateInput = {
  since: Scalars['Timestamp']
}

export type VendorProduct = {
  __typename?: 'VendorProduct'
  /** The currently active deal including this product, if applicable. VendorProducts can be featured in at most one deal at a time. */
  activeDeal?: Maybe<Deal>
  /** Custom pricing info across all retail accounts (where custom prices are set) */
  allRetailerPricing: Array<RetailerPricingInfo>
  caseCRV?: Maybe<Scalars['Currency']>
  /** @deprecated Use retailerPricing.casePrice instead */
  casePrice?: Maybe<Scalars['Currency']>
  caseSize?: Maybe<Scalars['Float']>
  /** @deprecated Use Product.caseUPC instead */
  caseUPC?: Maybe<Scalars['String']>
  /** The user id that deleted the vendor product */
  createdAt?: Maybe<Scalars['Timestamp']>
  deletedAt?: Maybe<Scalars['Timestamp']>
  /** The date in which the product was created */
  deletedByUserID?: Maybe<Scalars['String']>
  erpID?: Maybe<Scalars['String']>
  id: Scalars['ID']
  /** @deprecated use orderGuides instead */
  inOrderGuides?: Maybe<VendorProductInOrderGuidesResult>
  inventory?: Maybe<Scalars['Int']>
  inventoryLevelStatus?: Maybe<InventoryLevelStatus>
  /** @deprecated Unused. */
  isDeleted?: Maybe<Scalars['Boolean']>
  /** @deprecated Replaced by status. */
  isDiscontinued?: Maybe<Scalars['Boolean']>
  /** Only Products from certified vendors are displayed on Market. */
  isMarketplaceEnabled?: Maybe<Scalars['Boolean']>
  isPrivateLabelProduct: Scalars['Boolean']
  /** @deprecated Use isPrivateLabelProduct instead. */
  isStoreSpecific?: Maybe<Scalars['Boolean']>
  itemCode?: Maybe<Scalars['String']>
  lastOrder?: Maybe<StoreVendorProductOrderHistory>
  /**
   * Used primarily by the iOS app to populate offline cache with a diff of products that were updated since the last sync.
   * @deprecated Use updatedAt instead
   */
  lastUpdated?: Maybe<Scalars['Timestamp']>
  notes?: Maybe<Scalars['String']>
  orderGuides?: Maybe<VendorProductOrderGuidesResult>
  product: Product
  replacements: VendorProductReplacementsResult
  /** Displays a list of dates in which the product was discontinued by a retail company. */
  retailerDiscontinuedDates?: Maybe<Array<RetailerDiscontinuedDate>>
  /** The actual price for specific retailers, who might get discounts or markups depending on their relationship with the vendor. If no retailCompanyID is passed, defaults to the user's own company ID to determine the retailer. */
  retailerPricing: PricingInfo
  sizing?: Maybe<Scalars['String']>
  /** @deprecated Unused. */
  srp?: Maybe<Scalars['String']>
  status: VendorProductStatus
  /** @deprecated Use VendorProduct.Stores instead */
  store?: Maybe<Store>
  stores?: Maybe<Array<Maybe<Store>>>
  unitCRV?: Maybe<Scalars['Currency']>
  /** @deprecated Use retailerPricing.unitPrice instead */
  unitPrice?: Maybe<Scalars['Currency']>
  /** The date in which the product was last updated. Used primarily by the iOS app to populate offline cache with a diff of products that were updated since the last sync. */
  updatedAt?: Maybe<Scalars['Timestamp']>
  vendor?: Maybe<Vendor>
  /** The generally-available catalog pricing for this product. See also: retailerPricing */
  wholesalePricing: PricingInfo
}

export type VendorProductInOrderGuidesArgs = {
  input?: InputMaybe<VendorProductInOrderGuidesInput>
}

export type VendorProductLastOrderArgs = {
  input: StoreVendorProductOrderHistoryInput
}

export type VendorProductOrderGuidesArgs = {
  input?: InputMaybe<VendorProductOrderGuidesInput>
}

export type VendorProductReplacementsArgs = {
  input?: InputMaybe<VendorProductReplacementsInput>
}

export type VendorProductRetailerPricingArgs = {
  input?: InputMaybe<VendorProductRetailerPricingInput>
}

export type VendorProductByBrand = {
  __typename?: 'VendorProductByBrand'
  brandName?: Maybe<Scalars['String']>
  vendorProducts: VendorProductsResult
}

export enum VendorProductCatalogSource {
  Retailer = 'RETAILER',
  Vendor = 'VENDOR',
}

export type VendorProductInOrderGuidesInput = {
  retailCompanyID?: InputMaybe<Scalars['ID']>
}

export type VendorProductInOrderGuidesResult = {
  __typename?: 'VendorProductInOrderGuidesResult'
  nodes: Array<OrderGuide>
  totalCount: Scalars['Int']
}

export type VendorProductOrderGuidesInput = {
  bannerID?: InputMaybe<Scalars['ID']>
  storeID?: InputMaybe<Scalars['ID']>
}

export type VendorProductOrderGuidesResult = {
  __typename?: 'VendorProductOrderGuidesResult'
  nodes: Array<V2OrderGuide>
  totalCount: Scalars['Int']
}

export type VendorProductPromotionConflict = {
  __typename?: 'VendorProductPromotionConflict'
  deal: Deal
  vendorProduct: VendorProduct
}

export type VendorProductReplacement = {
  __typename?: 'VendorProductReplacement'
  score: Scalars['Float']
  vendorProduct: VendorProduct
}

export type VendorProductReplacementsCartFilterInput = {
  storeID?: InputMaybe<Scalars['ID']>
  userID?: InputMaybe<Scalars['ID']>
  vendorID?: InputMaybe<Scalars['ID']>
}

export type VendorProductReplacementsFilterInput = {
  cart?: InputMaybe<VendorProductReplacementsCartFilterInput>
}

export type VendorProductReplacementsInput = {
  filter?: InputMaybe<VendorProductReplacementsFilterInput>
  limit?: InputMaybe<Scalars['Int']>
}

export type VendorProductReplacementsResult = {
  __typename?: 'VendorProductReplacementsResult'
  nodes: Array<VendorProductReplacement>
}

export type VendorProductRetailerPricingInput = {
  retailCompanyID?: InputMaybe<Scalars['ID']>
}

export enum VendorProductStatus {
  Available = 'AVAILABLE',
  Discontinued = 'DISCONTINUED',
  StoreDiscontinued = 'STORE_DISCONTINUED',
  Unavailable = 'UNAVAILABLE',
}

export type VendorProductSuggestionsInput = {
  orderGuideProductsOnly?: InputMaybe<Scalars['Boolean']>
  storeID: Scalars['ID']
  upc: Scalars['String']
  vendorID?: InputMaybe<Scalars['ID']>
}

export type VendorProductSuggestionsResult = {
  __typename?: 'VendorProductSuggestionsResult'
  matchedVendorProducts?: Maybe<Array<VendorProduct>>
  matchingVendorProduct?: Maybe<VendorProduct>
  metadata?: Maybe<ProductLookupMetadata>
  misscans?: Maybe<Array<MisscanResolution>>
  suggestions?: Maybe<Array<VendorProduct>>
}

export type VendorProductsByBrandResult = {
  __typename?: 'VendorProductsByBrandResult'
  nodes: Array<VendorProductByBrand>
}

export type VendorProductsByIDsInput = {
  storeID?: InputMaybe<Scalars['ID']>
  vendorProductIDs: Array<Scalars['ID']>
}

export type VendorProductsByIDsResult = {
  __typename?: 'VendorProductsByIDsResult'
  nodes: Array<VendorProduct>
}

export type VendorProductsInput = {
  filterByBrand?: InputMaybe<Scalars['String']>
  filterByCategory?: InputMaybe<Scalars['String']>
  limit?: InputMaybe<Scalars['Int']>
  pagination?: InputMaybe<PaginationInput>
  search?: InputMaybe<Scalars['String']>
  sortBy?: InputMaybe<VendorProductsSortingInput>
}

export type VendorProductsQueryResult = {
  __typename?: 'VendorProductsQueryResult'
  cursor?: Maybe<Scalars['ID']>
  hasMore: Scalars['Boolean']
  nodes: Array<VendorProduct>
  totalCount: Scalars['Int']
}

export type VendorProductsResult = {
  __typename?: 'VendorProductsResult'
  cursor?: Maybe<Scalars['ID']>
  hasMore?: Maybe<Scalars['Boolean']>
  nodes: Array<VendorProduct>
}

export enum VendorProductsSortingField {
  ItemCode = 'ITEM_CODE',
}

export type VendorProductsSortingInput = {
  direction?: InputMaybe<SortingDirection>
  field: VendorProductsSortingField
}

export type VendorQueryInput = {
  after?: InputMaybe<Scalars['Cursor']>
  filterByAccountStatus?: InputMaybe<VendorStoreDepartmentAccountStatus>
  first: Scalars['Int']
  includeInactive?: InputMaybe<Scalars['Boolean']>
  storeIDs?: InputMaybe<Array<Scalars['ID']>>
}

export enum VendorStatus {
  Certified = 'CERTIFIED',
  Hidden = 'HIDDEN',
  None = 'NONE',
  ProvidedCatalog = 'PROVIDED_CATALOG',
}

export type VendorStoreAccount = {
  __typename?: 'VendorStoreAccount'
  accountNumber?: Maybe<Scalars['String']>
  activePromotions?: Maybe<PromotionsResults>
  /** @deprecated Use defaultUnitOfMeasure instead */
  defaultUOM?: Maybe<UnitOfMeasure>
  defaultUnitOfMeasure?: Maybe<UnitOfMeasure>
  orderDeadline?: Maybe<Scalars['String']>
  orderSubmissionMethod?: Maybe<SubmissionMethod>
  /** Orders placed by this account's store to the vendor, ordered by most recent. */
  recentOrders: VendorStoreAccountOrdersResult
  status: VendorStoreAccountStatus
  store?: Maybe<Store>
  storeEmailList: Array<StoreEmail>
  /** @deprecated Use storeEmailList instead */
  storeEmails?: Maybe<Array<Scalars['String']>>
  vendor: Vendor
  vendorEmailList: Array<VendorEmail>
  /** @deprecated Use vendorEmailList instead */
  vendorEmails?: Maybe<Array<Scalars['String']>>
  vendorID?: Maybe<Scalars['String']>
}

export type VendorStoreAccountRecentOrdersArgs = {
  input?: InputMaybe<VendorStoreAccountOrdersInput>
}

export type VendorStoreAccountInput = {
  marketEnabledOnly?: InputMaybe<Scalars['Boolean']>
  query?: InputMaybe<Scalars['String']>
}

export type VendorStoreAccountOrdersInput = {
  after?: InputMaybe<Scalars['Timestamp']>
  limit?: InputMaybe<Scalars['Int']>
}

export type VendorStoreAccountOrdersResult = {
  __typename?: 'VendorStoreAccountOrdersResult'
  nodes: Array<Order>
}

export type VendorStoreAccountProductsByUpdateTimeInput = {
  accountID: Scalars['ID']
  cursor?: InputMaybe<Scalars['ID']>
  filterBySource?: InputMaybe<ProductSourceFilter>
  lastRequestedAt?: InputMaybe<Scalars['Timestamp']>
  limit?: InputMaybe<Scalars['Int']>
  vendorID: Scalars['ID']
}

export enum VendorStoreAccountStatus {
  /** Account placed and order within the past ~30 days */
  Active = 'ACTIVE',
  /** We sent an invite but the account hasn't been created */
  InvitedButNotSignedUp = 'INVITED_BUT_NOT_SIGNED_UP',
  /** Account Created, but no invite was sent yet */
  NeverInvited = 'NEVER_INVITED',
  /** No orders last month, but was previously active */
  NoRecentOrders = 'NO_RECENT_ORDERS',
}

export type VendorStoreAccountsResult = {
  __typename?: 'VendorStoreAccountsResult'
  nodes: Array<VendorStoreAccount>
  totalCount: Scalars['Int']
}

/**
 * ****************************
 *      Vendor Store Department Acccount
 * ****************************
 */
export type VendorStoreDepartmentAccount = {
  __typename?: 'VendorStoreDepartmentAccount'
  accountActivityStatus: VendorStoreDepartmentAccountActivityStatus
  accountNumber?: Maybe<Scalars['String']>
  activePromotions?: Maybe<PromotionsResults>
  deactivatedAt?: Maybe<Scalars['Timestamp']>
  defaultUnitOfMeasure?: Maybe<UnitOfMeasure>
  dunsNumber?: Maybe<Scalars['String']>
  id: Scalars['ID']
  lastOrder?: Maybe<Order>
  name: Scalars['String']
  orderDeadline?: Maybe<Scalars['String']>
  orderDeadlineInfo?: Maybe<VendorOrderDeadlineInfo>
  /** Orders placed by this account's store to the vendor, ordered by most recent. */
  orderGuide?: Maybe<V2OrderGuide>
  orderSubmissionMethod?: Maybe<SubmissionMethod>
  orderSubmissionUOMLock?: Maybe<UomLock>
  recentOrders: VendorStoreDepartmentAccountOrdersResult
  status: VendorStoreDepartmentAccountStatus
  store?: Maybe<Store>
  storeDepartment: StoreDepartment
  storeDepartmentID: Scalars['String']
  storeEmails: Array<StoreEmail>
  vendor: Vendor
  vendorEmails: Array<VendorEmail>
  vendorID: Scalars['String']
  vendorName: Scalars['String']
}

/**
 * ****************************
 *      Vendor Store Department Acccount
 * ****************************
 */
export type VendorStoreDepartmentAccountRecentOrdersArgs = {
  input?: InputMaybe<VendorStoreDepartmentAccountOrdersInput>
}

export enum VendorStoreDepartmentAccountActivityStatus {
  /** Account placed and order within the past ~30 days */
  Active = 'ACTIVE',
  /** We sent an invite but the account hasn't been created */
  InvitedButNotSignedUp = 'INVITED_BUT_NOT_SIGNED_UP',
  /** Hasn't placed an order yet */
  NeverActive = 'NEVER_ACTIVE',
  /** Account Created, but no invite was sent yet */
  NeverInvited = 'NEVER_INVITED',
  /** No orders last month, but was previously active */
  NoRecentOrders = 'NO_RECENT_ORDERS',
}

export type VendorStoreDepartmentAccountInput = {
  filterByStatus?: InputMaybe<VendorStoreDepartmentAccountStatus>
  includeInactive?: InputMaybe<Scalars['Boolean']>
  marketEnabledOnly?: InputMaybe<Scalars['Boolean']>
  query?: InputMaybe<Scalars['String']>
}

export type VendorStoreDepartmentAccountOrdersInput = {
  after?: InputMaybe<Scalars['Timestamp']>
  limit?: InputMaybe<Scalars['Int']>
}

export type VendorStoreDepartmentAccountOrdersResult = {
  __typename?: 'VendorStoreDepartmentAccountOrdersResult'
  nodes: Array<Order>
}

export type VendorStoreDepartmentAccountResult = {
  __typename?: 'VendorStoreDepartmentAccountResult'
  nodes: Array<VendorStoreDepartmentAccount>
}

export enum VendorStoreDepartmentAccountStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
}

export type VendorStoreDepartmentAccountsInput = {
  filterByStatus?: InputMaybe<VendorStoreDepartmentAccountStatus>
  filterByUserDepartmentList?: InputMaybe<Scalars['Boolean']>
  includeInactive?: InputMaybe<Scalars['Boolean']>
  marketEnabledOnly?: InputMaybe<Scalars['Boolean']>
  searchByVendor?: InputMaybe<Scalars['String']>
}

export type VendorStoreDepartmentAccountsResult = {
  __typename?: 'VendorStoreDepartmentAccountsResult'
  nodes: Array<VendorStoreDepartmentAccount>
  totalCount: Scalars['Int']
}

export type VendorStoreProductsQueryInput = {
  cursor?: InputMaybe<Scalars['ID']>
  filterByStoreID?: InputMaybe<Scalars['ID']>
  limit?: InputMaybe<Scalars['Int']>
  query?: InputMaybe<Scalars['String']>
  vendorID: Scalars['ID']
}

/**
 * ****************************
 *         User Types
 * ****************************
 */
export type VendorUser = {
  __typename?: 'VendorUser'
  /** @deprecated Use v2 order guide resolvers */
  orderGuideByAccount: OrderGuide
  /** @deprecated Use vendorStoreDepartmentAccounts instead */
  storeAccounts: VendorStoreAccountsResult
  user: User
  vendor: Vendor
  vendorStoreDepartmentAccounts: VendorStoreDepartmentAccountsResult
}

/**
 * ****************************
 *         User Types
 * ****************************
 */
export type VendorUserOrderGuideByAccountArgs = {
  input: VendorUserOrderGuideInput
}

/**
 * ****************************
 *         User Types
 * ****************************
 */
export type VendorUserVendorStoreDepartmentAccountsArgs = {
  input?: InputMaybe<VendorStoreDepartmentAccountsInput>
}

export type VendorUserOrderGuideInput = {
  cursor?: InputMaybe<Scalars['ID']>
  limit?: InputMaybe<Scalars['Int']>
  query?: InputMaybe<Scalars['String']>
  storeID: Scalars['ID']
}

export type VendorUserResults = {
  __typename?: 'VendorUserResults'
  nodes: Array<VendorUser>
}

export type VendorVendorStoreDepartmentAccountsInput = {
  filterByStatus?: InputMaybe<VendorStoreDepartmentAccountStatus>
  filterByStore?: InputMaybe<Scalars['ID']>
  filterByUserDepartmentList?: InputMaybe<Scalars['Boolean']>
  includeInactive?: InputMaybe<Scalars['Boolean']>
}

export type VendorVendorStoreDepartmentAccountsResult = {
  __typename?: 'VendorVendorStoreDepartmentAccountsResult'
  nodes: Array<VendorStoreDepartmentAccount>
  totalCount: Scalars['Int']
}

export type VendorViewConnection = {
  __typename?: 'VendorViewConnection'
  edges: Array<VendorEdge>
  pageInfo: PageInfo
}

export type VendorsResult = {
  __typename?: 'VendorsResult'
  cursor: Scalars['String']
  hasMore: Scalars['Boolean']
  nodes: Array<Vendor>
  totalCount: Scalars['Int']
}

/** Metadata about the currently authenticated user session.  */
export type Viewer = {
  __typename?: 'Viewer'
  /** The authenticated user, while impersonating user */
  impersonatingUser?: Maybe<User>
  isImpersonating?: Maybe<Scalars['Boolean']>
  user: User
}

export type MeQueryInput = {
  impersonatedUserEmail?: InputMaybe<Scalars['String']>
  impersonatedUserID?: InputMaybe<Scalars['ID']>
}

export type UpdateCartProductQuantityInput = {
  quantity: Scalars['Int']
  /** Vendor users must specify the store to update */
  storeID?: InputMaybe<Scalars['ID']>
  unitOfMeasure: UnitOfMeasure
  vendorProductID: Scalars['ID']
}

export type UpdateCartProductQuantityResult = {
  __typename?: 'updateCartProductQuantityResult'
  updatedVendorCart?: Maybe<VendorCart>
}
